/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddressDto {
  line1: string;
  line2?: string;
  city: string;
  country: string;
  postalCode: string;
  state: string;
}

export type AdminDeadlineOverrideData = PreventionAssignment;

export interface AdminDeadlineOverrideDto {
  /**
   * Prevention assignment ID
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  assignmentId: string;
  /**
   * Target deadline for the prevention assignment. Can be any date including past dates for testing purposes.
   * @format date-time
   * @example "2025-12-31T23:59:59.000Z"
   */
  targetDeadline: string;
}

export interface ApiErrorResponseDto {
  /** The specific error type. */
  error?: string;
  /** A short description of the error. */
  message: string;
  /** The request path that caused the error. */
  path: string;
  /** The HTTP status code. */
  statusCode: number;
  /**
   * Timestamp of when the error occurred (ISO 8601 format).
   * @example "2025-04-09T06:45:00.000Z"
   */
  timestamp: string;
}

export interface ApiResponseDto {
  /** A human-readable message summarizing the result. */
  message: string;
  /**
   * The ID of the organization the operation was performed on.
   * @example "org_123abc"
   */
  organizationId: string;
  /** Detailed results of the operation. */
  results: object;
  /**
   * Indicates the outcome of the request.
   * @example "success"
   */
  status: string;
  /**
   * Timestamp of when the response was generated (ISO 8601 format).
   * @example "2025-04-09T06:45:00.000Z"
   */
  timestamp: string;
}

export type ApproveBookingData = Booking;

export type ApproveBookingResult = Booking;

export interface AssessmentCycle {
  anonymousLinkToken: string;
  /** @format date-time */
  closureTimestamp: string | null;
  /** @format date-time */
  createdAt: string;
  createdBy: User | null;
  /** @format date-time */
  creationTimestamp: string;
  employeeNote: string;
  id: string;
  name: string;
  /** @format uuid */
  organization: Organization;
  responses: AssessmentResponse[];
  status: AssessmentCycleStatusEnum;
  /** @format date-time */
  updatedAt: string;
}

export enum AssessmentCycleStatusEnum {
  Active = "active",
  Closed = "closed",
  Final = "final",
}

export interface AssessmentResponse {
  answers: object;
  /** @format uuid */
  assessmentCycle: AssessmentCycle;
  /** @format date-time */
  createdAt: string;
  id: string;
  /** @format uuid */
  selectedGroup: Group | null;
  /** @format date-time */
  submissionTimestamp: string;
  /** @format date-time */
  updatedAt: string;
}

/** Assessment status */
export enum AssessmentStatus {
  Pending = "pending",
  NoMeasuresNecessary = "no_measures_necessary",
  MeasuresNecessary = "measures_necessary",
}

export type AssignEmployeeData = Employee;

export interface AssignEmployeeFirstLogDto {
  /** @format uuid */
  employeeId: string;
}

export type AssignFirstAidLogEntryData = FirstAidLog;

export interface Booking {
  /** @format date-time */
  createdAt: string;
  edited: boolean;
  id: string;
  /** @format date-time */
  requestedAt: string;
  sequence: number;
  status: BookingStatusEnum;
  /** @format date-time */
  time: string;
  type: BookingTypeEnum;
  /** @format date-time */
  updatedAt: string;
  user: User;
}

export enum BookingStatusEnum {
  CREATED = "CREATED",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  CHANGED = "CHANGED",
}

export enum BookingTypeEnum {
  TherapistSession = "therapist_session",
  OrientationCall = "orientation_call",
  Partner = "partner",
  Course = "course",
}

export type BootstrapInstructionTopicsData = EnsureInstructionTopicsResponseDto;

export type CancelBookingData = any;

export type CancelBookingResult = any;

export interface CheckData {
  /** @example {"database":{"status":"up"}} */
  details?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example {} */
  error?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example {"database":{"status":"up"}} */
  info?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example "ok" */
  status?: string;
}

export type CheckError = {
  /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
  details?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example {"redis":{"status":"down","message":"Could not connect"}} */
  error?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example {"database":{"status":"up"}} */
  info?: Record<
    string,
    {
      status: string;
      [key: string]: any;
    }
  >;
  /** @example "error" */
  status?: string;
};

export type ChurnOrgData = Organization;

export interface ChurnOrgDto {
  /** @format uuid */
  orgId: string;
}

export interface ChurnUserByEmailDto {
  /**
   * @maxItems 100
   * @minItems 1
   */
  emails: string[];
}

export type ChurnUsersByEmailData = any;

export interface ClearUserCacheData {
  /** @example "User cache cleared successfully" */
  message?: string;
}

export type CloseCycleData = AssessmentCycle;

export type CompleteUploadData = any;

export type CourseTokenData = object;

export type CreateAdminManualActivityLogData =
  CreateManualActivityLogAdminResponse;

export interface CreateAssessmentCycleDto {
  /**
   * Note visible to employees
   * @example "Please complete this assessment by the end of the month"
   */
  employeeNote: string;
  /**
   * Organization ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  organizationId: string;
}

export type CreateAssessmentData = MaternityRiskAssessmentResponseDto;

export type CreateBloomUserData = User;

export type CreateBookingData = any;

export interface CreateBookingDto {
  courseId?: string;
  externalId: string;
  locale?: string;
  partnerPromo?: string;
  source?: CreateBookingDtoSourceEnum;
  status?: CreateBookingDtoStatusEnum;
  /** @format date-time */
  time?: string;
  type: CreateBookingDtoTypeEnum;
  userId: string;
}

export enum CreateBookingDtoSourceEnum {
  User = "user",
  Expert = "expert",
}

export enum CreateBookingDtoStatusEnum {
  CREATED = "CREATED",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  CHANGED = "CHANGED",
}

export enum CreateBookingDtoTypeEnum {
  TherapistSession = "therapist_session",
  OrientationCall = "orientation_call",
  Partner = "partner",
  Course = "course",
}

export type CreateCompletionData = PreventionCompletion;

export type CreateCycleData = AssessmentCycle;

export type CreateData = Partner;

export type CreateEmployeeData = Employee;

export type CreateExpertData = any;

export interface CreateExpertDto {
  active: boolean;
  categories: number[];
  description: string;
  email: string;
  firstName: string;
  languages: number[];
  lastName: string;
  locale: string;
  pricing: number;
  profession: CreateExpertDtoProfessionEnum;
}

export enum CreateExpertDtoProfessionEnum {
  Therapist = "Therapist",
  Expert = "Expert",
}

export interface CreateFirstAidLogDto {
  /** @format uuid */
  affectedEmployeeId: string;
  assignmentStatus: FirstAidLogAssignmentStatusEnum;
  doctorConsulted: boolean;
  /** @format date-time */
  doctorVisitDateTime?: string | null;
  /** @format date-time */
  firstAidDateTime: string;
  firstAidDescription: string;
  firstAiderIds?: string[] | null;
  /** @format date-time */
  incidentDateTime: string;
  incidentDescription: string;
  incidentLocation: string;
  injuryDescription: string;
  /** @format uuid */
  organizationId: string;
  otherInvolvedPersons?: string | null;
  witnessIds?: string[] | null;
}

export type CreateInstructionWithProfileData =
  CreateInstructionWithProfileResponseDto;

export interface CreateInstructionWithProfileDto {
  /**
   * Employee IDs that should receive the assignment
   * @minItems 1
   * @example ["d9bbf5b0-9766-4d42-8ff3-387dca777001","d9bbf5b0-9766-4d42-8ff3-387dca777002"]
   */
  employeeIds: string[];
  /**
   * Instruction topic ID that will be assigned
   * @format uuid
   * @example "27bba93c-6f92-4ce0-a2db-ecfed469e50a"
   */
  instructionTopicId: string;
  /**
   * Whether the profile should be active
   * @default true
   */
  isActive?: boolean;
  /**
   * Organization ID to create the instruction profile for
   * @format uuid
   * @example "d1171cf3-4ab9-4d57-b98d-31e4eba7b783"
   */
  organizationId: string;
}

export interface CreateInstructionWithProfileResponseDto {
  /** Details for created assignments */
  assignments: {
    assignmentId?: string;
    /** @format date-time */
    dueDate?: string;
    employeeId?: string;
    employeeName?: string;
  }[];
  /**
   * Number of assignments created
   * @example 6
   */
  assignmentsCreated: number;
  /**
   * ID of created instruction profile
   * @example "5de9f120-bab7-4f99-b5f1-e0ae8f7c955d"
   */
  profileId: string;
  /**
   * Number of employees skipped
   * @example 2
   */
  skipped: number;
  /** Skipped employees with reason */
  skippedEmployees?: {
    employeeId?: string;
    employeeName?: string;
    reason?: string;
  }[];
  /**
   * Name of selected instruction topic
   * @example "Allgemeine Sicherheitsunterweisung"
   */
  topicName: string;
}

export type CreateKomboIntegrationData = KomboIntegrationResponseDto;

export interface CreateKomboIntegrationDto {
  enableFieldMapping?: boolean;
  enableFiltering?: boolean;
  language?: CreateKomboIntegrationDtoLanguageEnum;
  /** @format uuid */
  orgId: string;
}

export enum CreateKomboIntegrationDtoLanguageEnum {
  En = "en",
  De = "de",
  Fr = "fr",
  It = "it",
  Es = "es",
}

export type CreateLegalEntityData = LegalEntity;

export interface CreateLegalEntityDto {
  address: AddressDto;
  komboId: string;
  name: string;
  /** @format uuid */
  parentOrganizationId: string;
}

export interface CreateManualActivityLogAdminDto {
  /** @format uuid */
  employeeId?: string;
  /** @format uuid */
  entityId: string;
  entityType: CreateManualActivityLogAdminDtoEntityTypeEnum;
  metadata: MetadataDto;
  /** @format uuid */
  organizationId: string;
  timestamp: string;
}

export enum CreateManualActivityLogAdminDtoEntityTypeEnum {
  Employee = "employee",
  Organization = "organization",
  LegalEntity = "legal_entity",
  WorkLocation = "work_location",
  PreventionTrigger = "prevention_trigger",
  PreventionProfile = "prevention_profile",
  PreventionAssignment = "prevention_assignment",
  PreventionCompletion = "prevention_completion",
  PreventionNotice = "prevention_notice",
  PreventionDeadline = "prevention_deadline",
  PreventionReceipt = "prevention_receipt",
  FirstAidLog = "first_aid_log",
  InstructionAssignment = "instruction_assignment",
  InstructionCompletion = "instruction_completion",
  Sync = "sync",
  Import = "import",
  Export = "export",
  Backup = "backup",
  Job = "job",
  MhRiskAssessment = "mh_risk_assessment",
  MaternityNotification = "maternity_notification",
  MaternityRiskAssessment = "maternity_risk_assessment",
  Document = "document",
}

export interface CreateManualActivityLogAdminResponse {
  message: string;
}

export interface CreateMaternityNotificationDto {
  /**
   * Whether consultation was offered
   * @example true
   */
  consultationOffered: boolean;
  /**
   * Employee ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  employeeId: string;
  /**
   * Expected due date
   * @example "2024-07-15"
   */
  expectedDueDate: string;
  /**
   * Additional notes about the notification
   * @example "Employee requires special workplace adjustments"
   */
  notes?: string;
  /**
   * Date when the maternity notification was made
   * @example "2024-01-15"
   */
  notificationDate: string;
  /**
   * Organization ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  organizationId: string;
}

export interface CreateMaternityRiskAssessmentDto {
  /**
   * Notification ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  notificationId: string;
}

export interface CreateNewUserDto {
  /** @default true */
  active: boolean;
  authUserId?: string;
  /** @format email */
  email: string;
  firstName: string;
  language: CreateNewUserDtoLanguageEnum;
  lastName: string;
  marketingConsent: boolean;
  ohsAuthUserId?: string;
  organizationId: string;
  /** @default false */
  requiresPasswordReset: boolean;
  termsAndConditionsConsent: boolean;
}

export enum CreateNewUserDtoLanguageEnum {
  En = "en",
  De = "de",
  Zh = "zh",
}

export type CreateNotificationData = MaternityNotificationResponseDto;

export type CreateOccupationalMedicineInfoData =
  OrganizationOccupationalMedicineInfo;

export type CreateOrganizationAdminData = Organization;

export interface CreateOrganizationAdminRequestDto {
  legalEntities?: CreateLegalEntityDto[];
  occupationalMedicineInfo?: CreateOrganizationOccupationalMedicineInfoWithOrganizationDto;
  organization: CreateOrganizationDto;
  workLocations?: CreateWorkLocationDto[];
}

export interface CreateOrganizationDto {
  /**
   * Additional comments about the organization
   * @maxLength 500
   * @example "Initial setup phase."
   */
  comment?: string;
  /**
   * Date when the contract expires (ISO 8601 format)
   * @format date
   * @example "2025-12-31"
   */
  contractExpiryDate?: string;
  /**
   * Type of contract the organization has
   * @example "all_inclusive"
   */
  contract_type?: OrganizationContractType;
  /**
   * Current budget allocated (e.g., in cents or smallest currency unit)
   * @min 0
   * @example 500000
   */
  current_budget?: number;
  /**
   * Contact email for the organization
   * @format email
   * @example "contact@example.com"
   */
  email: string;
  /** Employees belonging to the organization */
  employees?: Employee[];
  /**
   * List of Kombo IDs for excluded employees
   * @example ["kombo_emp_exclude_1","kombo_emp_exclude_2"]
   */
  excludedEmployeeKomboIds?: string[];
  /**
   * List of Kombo IDs for excluded legal entities
   * @example ["kombo_le_exclude_1","kombo_le_exclude_2"]
   */
  excludedLegalEntityKomboIds?: string[];
  /**
   * List of Kombo IDs for excluded work locations
   * @example ["kombo_wl_exclude_1","kombo_wl_exclude_2"]
   */
  excludedWorkLocationKomboIds?: string[];
  /**
   * Flag indicating if the organization has access to EAP features
   * @example true
   */
  hasEapAccess: boolean;
  /**
   * Flag indicating if the organization has access to instructions features
   * @example false
   */
  hasInstructionsAccess: boolean;
  /**
   * Flag indicating if the organization has access to OHS Hub features
   * @example true
   */
  hasOhsHubAccess: boolean;
  /**
   * Flag indicating if end-user Terms & Conditions approval is required
   * @example false
   */
  isEnduserTCApprovalRequired: boolean;
  /**
   * Unique key for the organization
   * @example "ORG_UNIQUE_KEY_123"
   */
  key: string;
  /**
   * Integration ID for Kombo
   * @example "kombo_int_12345"
   */
  komboIntegrationId?: string;
  /** Legal entities belonging to the organization */
  legalEntities?: LegalEntity[];
  /** Occupational medicine information for the organization */
  occupationalMedicineInfo?: OrganizationOccupationalMedicineInfo;
  /**
   * Name of the organization
   * @example "Example Company Inc."
   */
  organizationName: string;
  /**
   * Original identifier from the source system
   * @example "SOURCE_ID_ABC"
   */
  originId: string;
  /**
   * Maximum number of allowed sessions
   * @min 0
   * @example 10
   */
  session_limit?: number;
  /**
   * Identifier for the tool associated with the organization
   * @example "HRToolXYZ"
   */
  tool: string;
  /** Users associated with the organization */
  users?: User[];
  /** Work locations belonging to the organization */
  workLocations?: WorkLocation[];
}

export interface CreateOrganizationOccupationalMedicineInfoDto {
  companyCc?: string;
  emailSendingActive?: boolean;
  employeeContact?: string;
  /** @format uuid */
  legalEntityId?: string;
  mandatoryInstructionsDe?: string;
  mandatoryInstructionsEn?: string;
  offerInstructionsDe?: string;
  offerInstructionsEn?: string;
  /** @format uuid */
  parentOrganizationId: string;
  serviceName?: string;
}

export interface CreateOrganizationOccupationalMedicineInfoWithOrganizationDto {
  companyCc?: string;
  emailSendingActive?: boolean;
  employeeContact?: string;
  /** @format uuid */
  legalEntityId?: string;
  mandatoryInstructionsDe?: string;
  mandatoryInstructionsEn?: string;
  offerInstructionsDe?: string;
  offerInstructionsEn?: string;
  serviceName?: string;
}

export type CreateOutput = TestResult;

export type CreateOutput1 = FirstAidLog;

export interface CreatePreventionCompletionDto {
  /**
   * The ID of the prevention assignment to complete
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignmentId: string;
  /**
   * The date when the prevention was completed. Cannot be more than 7 days in the future or more than 5 years in the past.
   * @example "2024-01-15T10:30:00Z"
   */
  completionDate?: string;
  /**
   * Whether the prevention was actually done (true) or declined/not done (false)
   * @default true
   * @example true
   */
  done?: boolean;
}

export type CreatePreventionProfileData = PreventionProfile;

export interface CreatePreventionProfileDto {
  category: CreatePreventionProfileDtoCategoryEnum;
  description?: string;
  isActive: boolean;
  orgId: string;
  preventionTriggerId: string;
  rules: object;
}

export enum CreatePreventionProfileDtoCategoryEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export type CreatePreventionRuleData = PreventionProfile;

export interface CreatePreventionRuleDto {
  /**
   * Prevention category
   * @example "OFFER"
   */
  category: CreatePreventionRuleDtoCategoryEnum;
  /** Rule description */
  description?: string;
  /**
   * Due days for prevention completion
   * @example 90
   */
  dueDays?: number;
  /** Whether the rule is active */
  isActive: boolean;
  /** Rule name */
  name: string;
  /** Organization ID */
  organizationId: string;
  /** Prevention trigger ID */
  preventionTriggerId: string;
  /**
   * JSON rules engine conditions
   * @example {"all":[{"fact":"jobCategories","operator":"contains","value":"construction"},{"fact":"age","operator":"greaterThanInclusive","value":50}]}
   */
  rules: object;
}

/**
 * Prevention category
 * @example "OFFER"
 */
export enum CreatePreventionRuleDtoCategoryEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export type CreatePreventionWithProfileData =
  CreatePreventionWithProfileResponseDto;

export interface CreatePreventionWithProfileDto {
  /**
   * Type of assignment (MANDATORY or OFFER)
   * @example "MANDATORY"
   */
  assignmentType: CreatePreventionWithProfileDtoAssignmentTypeEnum;
  /**
   * Optional due date override (ISO date string). If not provided, uses default calculation based on employee start date. Must be in the future.
   * @example "2025-03-15T00:00:00.000Z"
   */
  dueDate?: string;
  /**
   * Array of employee IDs to assign the prevention to
   * @minItems 1
   * @example ["uuid-employee-1","uuid-employee-2"]
   */
  employeeIds: string[];
  /**
   * Organization ID to create the prevention for
   * @format uuid
   * @example "uuid-organization-id"
   */
  organizationId: string;
  /**
   * Name for the new prevention trigger (e.g., "Skin hazards")
   * @minLength 1
   * @example "Skin hazards"
   */
  preventionName: string;
  /**
   * Reason for the prevention assignment (stored as profile description)
   * @minLength 1
   * @example "Works with Toluol"
   */
  reason: string;
}

/**
 * Type of assignment (MANDATORY or OFFER)
 * @example "MANDATORY"
 */
export enum CreatePreventionWithProfileDtoAssignmentTypeEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export interface CreatePreventionWithProfileResponseDto {
  /** Details of created assignments */
  assignments: {
    assignmentId?: string;
    /** @format date-time */
    deadline?: string;
    employeeId?: string;
    employeeName?: string;
  }[];
  /**
   * Number of assignments created
   * @example 5
   */
  assignmentsCreated: number;
  /**
   * ID of the created prevention profile
   * @example "uuid-profile-id"
   */
  profileId: string;
  /**
   * Number of employees skipped (already had active assignment or other issues)
   * @example 2
   */
  skipped: number;
  /** List of skipped employees with reasons */
  skippedEmployees?: {
    employeeId?: string;
    employeeName?: string;
    reason?: string;
  }[];
  /**
   * ID of the created prevention trigger
   * @example "uuid-trigger-id"
   */
  triggerId: string;
  /**
   * Name of the created trigger
   * @example "Skin hazards"
   */
  triggerName: string;
}

export type CreateResult = User;

export interface CreateTestResultDto {
  score: number;
}

export interface CreateTestUsersDto {
  /**
   * @min 0
   * @max 100
   */
  amount: number;
  emailRoot: string;
  /** @format uuid */
  orgId: string;
}

export interface CreateUnassignedFirstAidLogDto {
  /** @format uuid */
  affectedEmployeeId: string;
  affectedEmployeeName: string;
  assignmentStatus: FirstAidLogAssignmentStatusEnum;
  doctorConsulted: boolean;
  /** @format date-time */
  doctorVisitDateTime?: string | null;
  /** @format date-time */
  firstAidDateTime: string;
  firstAidDescription: string;
  firstAiderIds?: string[] | null;
  firstAiderNames?: string;
  /** @format date-time */
  incidentDateTime: string;
  incidentDescription: string;
  incidentLocation: string;
  injuryDescription: string;
  /** @format uuid */
  organizationId: string;
  otherInvolvedPersons?: string | null;
  /** @format email */
  submitterEmail: string;
  submitterFirstName: string;
  submitterLastName: string;
  witnessIds?: string[] | null;
  witnessNames?: string;
}

export interface CreateUserAdminDto {
  clerkApps: CreateUserAdminDtoClerkAppsEnum[];
  /** @format email */
  email: string;
  firstName: string;
  isAdmin?: boolean;
  language: CreateUserAdminDtoLanguageEnum;
  lastName: string;
  organizationId: string;
}

export enum CreateUserAdminDtoClerkAppsEnum {
  Bloom = "bloom",
  Ginione = "ginione",
}

export enum CreateUserAdminDtoLanguageEnum {
  En = "en",
  De = "de",
  Zh = "zh",
}

export type CreateUserData = User;

export type CreateUserResult = User;

export type CreateWorkLocationData = WorkLocation;

export interface CreateWorkLocationDto {
  address?: AddressDto;
  komboId: string;
  name: string;
  /** @format uuid */
  parentOrganizationId: string;
  type: CreateWorkLocationDtoTypeEnum;
}

export enum CreateWorkLocationDtoTypeEnum {
  OFFICE = "OFFICE",
  REMOTE = "REMOTE",
  HYBRID = "HYBRID",
  SITE = "SITE",
}

export type DeleteAssessmentData = any;

export type DeleteCompletionData = any;

export type DeleteDocumentData = any;

export type DeleteNotificationData = any;

export interface DeletePreventionRuleData {
  /** @example "Prevention rule deleted successfully" */
  message?: string;
}

export type DeleteReceiptData = any;

export interface DocumentDto {
  /** @format date-time */
  createdAt: string;
  entityId: string;
  entityType: string;
  fileSize: string;
  id: string;
  mimeType: string;
  organizationId: string;
  originalFilename: string;
  status: string;
  storageKey: string;
  /** @format date-time */
  updatedAt: string;
  uploaderId: string;
}

export type EmailData = any;

export interface Employee {
  avatar: string | null;
  /** @format date-time */
  created_at: string;
  displayName: string | null;
  employeeNumber: string | null;
  employmentStatus?: EmployeeEmploymentStatusEnum;
  employmentType?: EmployeeEmploymentTypeEnum;
  firstName: string | null;
  groups?: Group[];
  id: string;
  jobTitle: string | null;
  komboId: string;
  lastName: string | null;
  /** @format uuid */
  legalEntity?: LegalEntity;
  note: string;
  /** @format uuid */
  parentOrganization: Organization;
  personalEmail: string | null;
  preventionAssignments: PreventionAssignment[];
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  terminationDate?: string;
  /** @format date-time */
  updated_at: string;
  workEmail: string | null;
  /** @format uuid */
  workLocation?: WorkLocation;
}

export enum EmployeeEmploymentStatusEnum {
  ACTIVE = "ACTIVE",
  TERMINATED = "TERMINATED",
  ON_LEAVE = "ON_LEAVE",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
  DELETED = "DELETED",
}

export enum EmployeeEmploymentTypeEnum {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME",
  CONTRACTOR = "CONTRACTOR",
  INTERN = "INTERN",
  OTHER = "OTHER",
}

export interface EnrichedActivityLog {
  /** The category this activity belongs to */
  category?: EnrichedActivityLogCategoryEnum;
  id: string;
  timestamp: string;
  translationKeyLabel: string;
  translationKeyTitle: string | null;
  /** An object containing parameters (primitives like string, number, boolean, Date) needed for translation interpolation. */
  translationParams: Record<string, stringNumberBooleanNull>;
}

/** The category this activity belongs to */
export enum EnrichedActivityLogCategoryEnum {
  PreventionRegister = "prevention_register",
  MhRiskAssessment = "mh_risk_assessment",
  FirstAidLog = "first_aid_log",
  Maternity = "maternity",
  Instructions = "instructions",
}

export interface EnrichedSurveyDto {
  description: string;
  id: string;
  organizationName: string;
  sections: SurveySection[];
  title: string;
}

export interface EnsureInstructionTopicsResponseDto {
  /**
   * How many topics already existed for this organization
   * @example 1
   */
  alreadyExisting: number;
  /**
   * How many new topics were created from the content registry keys
   * @example 2
   */
  created: number;
  /** Instruction topics available after bootstrap */
  topics: InstructionTopicAdminResponseDto[];
}

/** Filter logs by entity type (e.g., mh_risk_assessment) */
export enum EntityTypeEnum {
  Employee = "employee",
  Organization = "organization",
  LegalEntity = "legal_entity",
  WorkLocation = "work_location",
  PreventionTrigger = "prevention_trigger",
  PreventionProfile = "prevention_profile",
  PreventionAssignment = "prevention_assignment",
  PreventionCompletion = "prevention_completion",
  PreventionNotice = "prevention_notice",
  PreventionDeadline = "prevention_deadline",
  PreventionReceipt = "prevention_receipt",
  FirstAidLog = "first_aid_log",
  InstructionAssignment = "instruction_assignment",
  InstructionCompletion = "instruction_completion",
  Sync = "sync",
  Import = "import",
  Export = "export",
  Backup = "backup",
  Job = "job",
  MhRiskAssessment = "mh_risk_assessment",
  MaternityNotification = "maternity_notification",
  MaternityRiskAssessment = "maternity_risk_assessment",
  Document = "document",
}

export type EvaluateRulesForOrgData = any;

export type EventData = any;

export interface ExclusionsOptionsKomboEmployeeDto {
  avatar: string | null;
  created_at: string;
  displayName: string | null;
  employeeNumber: string | null;
  employmentStatus?: string;
  employmentType?: string;
  firstName: string | null;
  groups: Group[];
  id: string;
  jobTitle: string | null;
  komboId: string;
  lastName: string | null;
  legalEntity?: ExclusionsOptionsKomboLegalEntityDto;
  note: string;
  parentOrganization: Organization;
  personalEmail: string | null;
  preventionAssignments: object[];
  startDate?: string;
  terminationDate?: string;
  updated_at: string;
  workEmail: string | null;
  workLocation?: ExclusionsOptionsKomboWorkLocationDto;
}

export interface ExclusionsOptionsKomboLegalEntityDto {
  address: object;
  /** @format date-time */
  created_at: string;
  id: string;
  komboId: string;
  name: string;
  /** @format date-time */
  updated_at: string;
}

export interface ExclusionsOptionsKomboResponseDto {
  groups: Group[];
  komboEmployees: ExclusionsOptionsKomboEmployeeDto[];
  komboLegalEntities: ExclusionsOptionsKomboLegalEntityDto[];
  komboWorkLocations: ExclusionsOptionsKomboWorkLocationDto[];
}

export interface ExclusionsOptionsKomboWorkLocationDto {
  address: object;
  /** @format date-time */
  created_at: string;
  id: string;
  komboId: string;
  name: string;
  type: string;
  /** @format date-time */
  updated_at: string;
}

export interface Expert {
  active: boolean;
  calendlyUri: string;
  /** @format date-time */
  createdAt: string;
  email: string;
  externalId: string;
  firstName: string;
  fullName: string;
  id: string;
  lastName: string;
  pricing: number;
  /** @format date-time */
  updatedAt: string;
}

export type FetchOrgData = Organization;

export type FetchOrgDetailedAdminData = Organization;

export type FetchOrgDetailedData = Organization;

export type FinalizeCycleData = AssessmentCycle;

export type FindAllData = User[];

export type FindAllOutput = InstructionAssignmentResponseDto[];

export interface FindAllParams2 {
  /** @format uuid */
  employeeId?: string;
  /** @format uuid */
  instructionTopicId?: string;
  orgId: string;
  status?: StatusEnum;
}

export enum FindAllParams3StatusEnum {
  PENDING = "PENDING",
  INVITED = "INVITED",
  REMINDER_1_SENT = "REMINDER_1_SENT",
  REMINDER_2_SENT = "REMINDER_2_SENT",
  COMPLETED = "COMPLETED",
  OVERDUE = "OVERDUE",
}

export type FindAllResult = InstructionTopicResponseDto[];

export type FindBookingData = Booking;

export interface FindBookingParams {
  courseId: string;
  userId: string;
}

export type FindByEmployeeIdData = PreventionNotice[];

export type FindByIdData = PreventionNotice;

export type FindByOrganizationData = FirstAidLog[];

export type FindOneData = Organization;

export type FindOneOutput = InstructionAssignmentResponseDto;

export type FindOneOutput1 = FirstAidLog;

export type FindOneResult = InstructionTopicResponseDto;

export interface FirstAidLog {
  affectedEmployee: Employee;
  affectedEmployeeName: string;
  assignmentStatus: FirstAidLogAssignmentStatusEnum;
  /** @format date-time */
  createdAt: string;
  doctorConsulted: boolean;
  /** @format date-time */
  doctorVisitDateTime: string | null;
  /** @format date-time */
  firstAidDateTime: string;
  firstAidDescription: string;
  firstAiderNames?: string;
  firstAiders: Employee[] | null;
  id: string;
  /** @format date-time */
  incidentDateTime: string;
  incidentDescription: string;
  incidentLocation: string;
  injuryDescription: string;
  organization: Organization;
  otherInvolvedPersons: string | null;
  submitterEmail: string;
  submitterFirstName: string;
  submitterLastName: string;
  /** @format date-time */
  updatedAt: string;
  witnessNames?: string;
  witnesses: Employee[] | null;
}

export enum FirstAidLogAssignmentStatusEnum {
  Pending = "pending",
  Assigned = "assigned",
}

export type GenerateUsersData = any;

export interface GetAdminRoleByIdData {
  /** The role assigned to the user, or null if no role */
  role?: string | null;
}

export type GetAllBookingsData = Booking[];

export interface GetAllBookingsParams {
  expertExternalId: string;
  limit: number;
  past: string;
}

export type GetAllConfigData = any;

export type GetAllConfigPayload = string[];

export type GetAllData = Expert[];

export type GetAllLogsData = EnrichedActivityLog[];

export interface GetAllLogsParams {
  /** When true, returns aggregated logs with individual maternity, mental health, and first aid logs */
  aggregated?: boolean;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string;
  /** Filter logs by specific entity ID */
  entityId?: string;
  /** Filter logs by entity type (e.g., mh_risk_assessment) */
  entityType?: EntityTypeEnum;
  /** Filter logs by multiple entity types (comma-separated) */
  entityTypes?: string[];
  /** Organization ID to filter logs by */
  organizationId: string;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string;
}

/** Filter logs by entity type (e.g., mh_risk_assessment) */
export enum GetAllLogsParams1EntityTypeEnum {
  Employee = "employee",
  Organization = "organization",
  LegalEntity = "legal_entity",
  WorkLocation = "work_location",
  PreventionTrigger = "prevention_trigger",
  PreventionProfile = "prevention_profile",
  PreventionAssignment = "prevention_assignment",
  PreventionCompletion = "prevention_completion",
  PreventionNotice = "prevention_notice",
  PreventionDeadline = "prevention_deadline",
  PreventionReceipt = "prevention_receipt",
  FirstAidLog = "first_aid_log",
  InstructionAssignment = "instruction_assignment",
  InstructionCompletion = "instruction_completion",
  Sync = "sync",
  Import = "import",
  Export = "export",
  Backup = "backup",
  Job = "job",
  MhRiskAssessment = "mh_risk_assessment",
  MaternityNotification = "maternity_notification",
  MaternityRiskAssessment = "maternity_risk_assessment",
  Document = "document",
}

export type GetAllOrgsData = any;

export type GetAllResult = Partner[];

export type GetAreTcRequiredForEnduserOfOrganisationData = boolean;

export type GetAssessmentData = MaternityRiskAssessmentResponseDto;

export interface GetAssessmentStatisticsData {
  completionRate?: number;
  measuresNecessary?: number;
  noMeasuresNecessary?: number;
  pending?: number;
  total?: number;
}

export type GetAssessmentTimelineData = MaternityRiskAssessmentResponseDto[];

export interface GetAssessmentTimelineParams {
  /** End date (YYYY-MM-DD) */
  endDate: string;
  orgId: string;
  /** Start date (YYYY-MM-DD) */
  startDate: string;
}

export type GetAssessmentWithDetailsData = MaternityRiskAssessmentResponseDto;

export type GetAssessmentsByEmployeeData = MaternityRiskAssessmentResponseDto[];

export type GetAvailabilitiesData = any;

export type GetBookingDetailsData = Booking;

export type GetBookingDetailsResult = Booking;

export type GetBookingsData = Booking[];

export type GetByExternalIdData = Expert;

export type GetCompletionsByAssignmentData = PreventionCompletion[];

export type GetCourseTokenData = object;

export interface GetCourseTokenParams {
  bookingId: string;
  is_expert: string;
}

export type GetCycleByTokenData = AssessmentCycle;

export type GetCycleData = AssessmentCycle;

export type GetDocumentData = DocumentDto;

export type GetDocumentsData = DocumentDto[];

export interface GetDocumentsParams {
  entityId: string;
  entityType: string;
  orgId: string;
  uploaderId: string;
}

export type GetDownloadUrlData = any;

export interface GetEmployeeMaternityStatusData {
  assessmentStatus?: string | null;
  hasActiveNotification?: boolean;
  latestNotification?: MaternityNotificationResponseDto | null;
}

export type GetEmployeesWithPreventionStatusData =
  PreventionEmployeesResponseDto;

export interface GetExclusionsData {
  excludedEmployeeKomboIds?: string[];
  excludedLegalEntityKomboIds?: string[];
  excludedWorkLocationKomboIds?: string[];
}

export type GetExpertBookingDetailsData = Booking;

export type GetExpertBookingsData = object[];

export interface GetExpertBookingsParams {
  expertId: string;
  limit: number;
  past: string;
}

export type GetExpertConversationsData = object[];

export interface GetExpertConversationsParams {
  expertId: string;
  limit: number;
}

export interface GetFirstAidLogQrCodeDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  organizationId: string;
}

export type GetGiniscoreStatisticsData = GiniscoreStatisticsResponse;

export type GetGroupsData = Group[];

export type GetHelloData = string;

export type GetInstructionStatisticsData = InstructionStatisticsResponseDto;

export type GetInstructionTopicsData = InstructionTopicAdminResponseDto[];

export type GetKomboIntegrationData = KomboIntegrationResponseDto;

export type GetLatestCompletionData = PreventionCompletion;

export type GetLatestNotificationByEmployeeData =
  MaternityNotificationResponseDto;

export type GetLogsByEmployeeData = EnrichedActivityLog[];

export type GetMentalHealthRiskAssessmentLogsData = EnrichedActivityLog[];

export interface GetMentalHealthRiskAssessmentLogsParams {
  /** Organization ID to filter logs by */
  organizationId: string;
}

export type GetMessagesData = SessionMessageResponseDto[];

export interface GetNotificationCountsData {
  active?: number;
  completed?: number;
  total?: number;
}

export type GetNotificationData = MaternityNotificationResponseDto;

export type GetNotificationsByEmployeeData = MaternityNotificationResponseDto[];

export type GetNumberOfRemainingSessionsData = number;

export type GetOccupationalMedicineInfoData =
  OrganizationOccupationalMedicineInfo;

export interface GetOccupationalMedicineInfoParams {
  legalEntityId?: string;
  orgId: string;
}

export type GetOhsHubOrgsData = OrganizationDto[];

export type GetOrgBudgetsData = OrgBudgetOverviewDto[];

export type GetOrganizationByQrCodeData = any;

export type GetOrganizationFirstAidQrCodeData = GetFirstAidLogQrCodeDto;

export type GetOrganizationOptionsData = GetOrganizationOptionsResponseDto;

export type GetOrganizationOptionsKomboData = ExclusionsOptionsKomboResponseDto;

export interface GetOrganizationOptionsResponseDto {
  groups: Group[];
  legalEntities: LegalEntity[];
  workLocations: WorkLocation[];
}

export type GetParticipantsCountData = number;

export interface GetParticipantsCountParams {
  courseId: string;
}

export type GetPreventionDetailLogsData = EnrichedActivityLog[];

export interface GetPreventionDetailLogsParams {
  /** Prevention assignment ID (prevention detail id) */
  assignmentId: string;
  /** Employee ID to filter logs by */
  employeeId: string;
  /** Organization ID to filter logs by */
  organizationId: string;
}

export type GetPreventionProfilesData = PreventionProfileResponseDto[];

export type GetPreventionRulesData = PreventionProfile[];

export type GetPreventionStatisticsData = PreventionStatisticsResponseDto;

export type GetPreventionTriggersData = PreventionTriggerResponseDto[];

export type GetQuestionnaireData = QuestionnaireResponseDto;

export type GetQuestionnaireResponseData = QuestionnaireResponseResponseDto;

export type GetReceiptData = ReceiptDocumentResponseDto;

export type GetReceiptSummaryData = ReceiptSummaryResponseDto;

export interface GetRequiresPasswordResetData {
  requiresPasswordReset: boolean;
  requiresPwResetGinione: boolean;
  shouldUseGinione: boolean;
}

export type GetSelectableGroupsData = Group[];

export type GetSingleVideosProgressData = any;

export interface GetSingleVideosProgressParams {
  url: string;
  userId: string;
}

export type GetStressLevelsData = any;

export type GetSurveyData = SurveyDto;

export interface GetSurveyParams1 {
  /** Survey language */
  locale?: LocaleEnum;
  token: string;
}

/** Survey language */
export enum GetSurveyParams2LocaleEnum {
  En = "en",
  DeDE = "de-DE",
}

export type GetSurveyResult = SurveyResponseDto;

export type GetTotalDurationData = any;

export type GetTotalUnreadMessagesCountData = UnreadMessagesCountResponseDto;

export type GetTotalUnreadMessagesCountForExpertData =
  UnreadMessagesCountResponseDto;

export type GetUserBookingsData = object[];

export interface GetUserBookingsParams {
  past: string;
  userId: string;
}

export type GetUserByAuthIdData = User;

export type GetUserByIdData = User;

export type GetUserConversationsData = object[];

export type GetUsersByOrganizationData = object[];

export type GetUsersData = User[];

export interface GetUsersParams {
  active: boolean;
  orgId: string;
}

export type GetVideoDurationData = any;

export interface GetVideoDurationParams {
  url: string;
}

export type GetVideosProgressData = any;

export interface GetVideosProgressParams {
  courseId: number;
  userId: string;
}

export interface GiniscoreBreakdown {
  /** Maternity module statistics */
  maternity: MaternityStats;
  /** Prevention module statistics */
  prevention: PreventionStats;
}

export interface GiniscoreStatisticsResponse {
  /** Detailed breakdown of statistics by module */
  breakdown: GiniscoreBreakdown;
  /**
   * Penalty deducted from base score
   * @example 7.7
   */
  penalty: number;
  /**
   * Final OHS compliance score after penalty deduction (0-100), or null if no data
   * @example 87.5
   */
  score: number;
}

export interface Group {
  /** @format date-time */
  created_at: string;
  employees?: Employee[];
  id: string;
  /** @format uuid */
  komboId: string;
  name: string | null;
  /** @format uuid */
  parentOrganization: Organization;
  type: GroupTypeEnum;
  /** @format date-time */
  updated_at: string;
}

export enum GroupTypeEnum {
  DEPARTMENT = "DEPARTMENT",
  TEAM = "TEAM",
  COST_CENTER = "COST_CENTER",
}

export type HandleCalendlyWebhookData = any;

export type HasActiveBookingData = any;

export interface HasActiveBookingParams {
  courseId: string;
  userId: string;
}

export type IndexData = any;

export type IngestByIdData = ApiResponseDto & {
  results?: any;
};

export type IngestByIdError = ApiErrorResponseDto;

export interface InstructionAccessResponseDto {
  /** Present when status is "valid" (full assignment) or "completed" (completion data) */
  assignment?: object;
  status: InstructionAccessResponseDtoStatusEnum;
  /** Localized topic title, present for expired and completed states */
  topicTitle?: object;
}

export enum InstructionAccessResponseDtoStatusEnum {
  Valid = "valid",
  Completed = "completed",
  Expired = "expired",
}

export interface InstructionAssignmentContentSummaryDto {
  description: string;
  key: string;
  /**
   * Localized content summary fields
   * @example {"title":{"de":"Sicherheit am Arbeitsplatz","en":"Workplace safety"},"description":{"de":"Grundlagen der Arbeitssicherheit","en":"Workplace safety fundamentals"}}
   */
  localized?: LocalizedInstructionContentSummaryDto;
  title: string;
}

export interface InstructionAssignmentResponseDto {
  /** @format date-time */
  reminder1SentAt?: string | null;
  /** @format date-time */
  reminder2SentAt?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  completions?: InstructionCompletionResponseDto[];
  contentSummary?: InstructionAssignmentContentSummaryDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  dueDate: string;
  id: string;
  /** @format date-time */
  invitationSentAt?: string | null;
  isActive: boolean;
  passingScore?: number | null;
  quizScore?: number | null;
  quizTotalQuestions?: number | null;
  status: InstructionAssignmentResponseDtoStatusEnum;
  /** @format date-time */
  updatedAt: string;
}

export enum InstructionAssignmentResponseDtoStatusEnum {
  PENDING = "PENDING",
  INVITED = "INVITED",
  REMINDER_1_SENT = "REMINDER_1_SENT",
  REMINDER_2_SENT = "REMINDER_2_SENT",
  COMPLETED = "COMPLETED",
  OVERDUE = "OVERDUE",
}

export interface InstructionCompletionResponseDto {
  /** @format date-time */
  completedAt: string;
  documentUrl?: string | null;
  id: string;
  passed: boolean;
  quizScore: number;
  quizTotalQuestions: number;
}

export interface InstructionStatisticsResponseDto {
  /**
   * Instruction assignments statistics broken down by topic
   * @example [{"id":"550e8400-e29b-41d4-a716-446655440000","name":"General Safety","total":50,"completed":30,"overdue":5,"upcoming":10}]
   */
  byTopic: InstructionTopicStatisticsDto[];
  /**
   * Number of instruction completions in the last 90 days
   * @example 42
   */
  completionCount: number;
  /**
   * Number of instruction invitations sent in the last 30 days
   * @example 15
   */
  notificationSentCount: number;
  /**
   * Number of overdue instruction assignments
   * @example 8
   */
  overdue: number;
  /**
   * Total number of active instruction assignments
   * @example 100
   */
  totalInstruction: number;
  /**
   * Number of instruction assignments due within 60 days
   * @example 25
   */
  upcoming: number;
}

export interface InstructionTopicAdminResponseDto {
  /**
   * Instruction topic ID
   * @example "27bba93c-6f92-4ce0-a2db-ecfed469e50a"
   */
  id: string;
  /**
   * Instruction topic key
   * @example "general-safety"
   */
  key: string;
  /**
   * Instruction topic name
   * @example "Allgemeine Sicherheitsunterweisung"
   */
  name: string;
}

export interface InstructionTopicResponseDto {
  /** @format date-time */
  createdAt: string;
  defaultDueDays: number;
  estimatedDurationMinutes: number;
  id: string;
  isActive: boolean;
  key: string;
  name: string;
  /** @format date-time */
  updatedAt: string;
}

export interface InstructionTopicStatisticsDto {
  /**
   * Completed instruction assignments for this topic
   * @example 30
   */
  completed: number;
  /**
   * Instruction topic ID
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Instruction topic name
   * @example "General Safety"
   */
  name: string;
  /**
   * Overdue instruction assignments for this topic
   * @example 5
   */
  overdue: number;
  /**
   * Total active instruction assignments for this topic
   * @example 50
   */
  total: number;
  /**
   * Upcoming instruction assignments for this topic (due within 60 days)
   * @example 10
   */
  upcoming: number;
}

export interface InvalidateUserCacheData {
  /** @example "User cache invalidated successfully" */
  message?: string;
}

export interface InvitationCodeVerificationDto {
  code: string;
}

export type InviteVerificationData = object;

export interface KomboIntegrationResponseDto {
  /** @format date-time */
  expiresAt: string;
  link: string;
  organizationId: string;
  organizationName: string;
}

export interface LegalEntity {
  address?: AddressDto;
  /** @format date-time */
  created_at: string;
  employees: Employee[];
  id: string;
  /** @format uuid */
  komboId: string;
  name: string;
  /** @format uuid */
  parentOrganization: Organization;
  /** @format date-time */
  updated_at: string;
}

export type ListAssessmentsData = MaternityRiskAssessmentResponseDto[];

export interface ListAssessmentsParams {
  /** Filter by completion status */
  completed?: boolean;
  orgId: string;
  /** Filter by assessment status */
  status?: AssessmentStatus;
}

export type ListCyclesData = AssessmentCycle[];

export type ListExpertsData = any;

export type ListNotificationsData = MaternityNotificationResponseDto[];

export interface ListNotificationsParams {
  /** Filter by end date (YYYY-MM-DD) */
  endDate?: string;
  orgId: string;
  /** Filter by start date (YYYY-MM-DD) */
  startDate?: string;
}

/** Survey language */
export enum LocaleEnum {
  En = "en",
  DeDE = "de-DE",
}

export interface LocalizedInstructionContentSummaryDto {
  description: LocalizedTextDto;
  title: LocalizedTextDto;
}

export interface LocalizedTextDto {
  de: string;
  en: string;
}

export interface LogMetadataDto {
  de_DE: string;
  en: string;
}

export interface ManualCreateEmployeeDto {
  avatar?: string | null;
  displayName?: string | null;
  employeeNumber?: string | null;
  employmentStatus: ManualCreateEmployeeDtoEmploymentStatusEnum;
  employmentType: ManualCreateEmployeeDtoEmploymentTypeEnum;
  firstName?: string | null;
  groupIds?: string[];
  jobTitle?: string | null;
  lastName?: string | null;
  /** @format uuid */
  legalEntityId?: string;
  parentOrganizationId?: string;
  /** @format email */
  personalEmail?: string;
  /** @format date-time */
  startDate?: string;
  /** @format email */
  workEmail?: string | null;
  /** @format uuid */
  workLocationId?: string;
}

export enum ManualCreateEmployeeDtoEmploymentStatusEnum {
  ACTIVE = "ACTIVE",
  TERMINATED = "TERMINATED",
  ON_LEAVE = "ON_LEAVE",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
  DELETED = "DELETED",
}

export enum ManualCreateEmployeeDtoEmploymentTypeEnum {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME",
  CONTRACTOR = "CONTRACTOR",
  INTERN = "INTERN",
  OTHER = "OTHER",
}

export interface MaternityNotification {
  consultationOffered: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  employee: Employee;
  /** @format date-time */
  expectedDueDate: string;
  id: string;
  notes: string;
  /** @format date-time */
  notificationDate: string;
  /** @format uuid */
  organization: Organization;
  /** @format date-time */
  updatedAt: string;
}

export interface MaternityNotificationResponseDto {
  /**
   * Whether consultation was offered
   * @example true
   */
  consultationOffered: boolean;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  createdAt: string;
  /** Employee details */
  employee: Employee;
  /**
   * Expected due date
   * @format date-time
   * @example "2024-07-15"
   */
  expectedDueDate: string;
  /**
   * Notification ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Additional notes
   * @example "Employee requires special workplace adjustments"
   */
  notes?: string;
  /**
   * Date when the maternity notification was made
   * @format date-time
   * @example "2024-01-15"
   */
  notificationDate: string;
  /** Organization details */
  organization: Organization;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  updatedAt: string;
}

export interface MaternityRiskAssessment {
  /** @format date-time */
  completedAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  employee: Employee;
  id: string;
  /** @format uuid */
  notification: MaternityNotification;
  /** @format uuid */
  organization: Organization;
  questionnaireResponse: QuestionnaireResponse;
  status: MaternityRiskAssessmentStatusEnum;
  /** @format date-time */
  updatedAt: string;
}

export interface MaternityRiskAssessmentResponseDto {
  /**
   * Completion timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  completedAt?: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  createdAt: string;
  /** Employee details */
  employee: Employee;
  /**
   * Assessment ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /** Maternity notification details */
  notification: MaternityNotification;
  /** Organization details */
  organization: Organization;
  /** Questionnaire response details */
  questionnaireResponse?: QuestionnaireResponse;
  /**
   * Assessment status
   * @example "pending"
   */
  status: AssessmentStatus;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  updatedAt: string;
}

export enum MaternityRiskAssessmentStatusEnum {
  Pending = "pending",
  NoMeasuresNecessary = "no_measures_necessary",
  MeasuresNecessary = "measures_necessary",
}

export interface MaternityStats {
  /** Total number of overdue maternity assessments */
  overdue: number;
  /** Total number of completed maternity assessments */
  totalDone: number;
  /** Total number of maternity notifications */
  totalDue: number;
}

export type MeetingToken2Data = object;

export type MeetingTokenData = object;

export interface MeetingTokenParams {
  bookingId: string;
  expertExternalId: string;
  is_expert: string;
}

export type MeetingTokenResult = object;

export type MessagesData = SessionMessage;

export interface MetadataDto {
  log: LogMetadataDto;
}

export interface NoticeProcessingResultDto {
  /** The email address the notice was sent to. */
  email?: string;
  /**
   * The ID of the employee associated with the notice.
   * @format uuid
   */
  employeeId: string;
  /** Error message if processing failed. */
  error?: string;
  /** Whether this was a dry run. */
  isDryRun: boolean;
  /**
   * The ID of the processed notice.
   * @format uuid
   */
  noticeId: string;
  /**
   * The ID of the prevention trigger associated with the notice.
   * @format uuid
   */
  preventionTriggerId: string;
  /**
   * When the notice was sent, if applicable.
   * @format date-time
   */
  sentAt?: string;
  /** Whether the notice processing was successful. */
  success: boolean;
}

export type NotifyPasswordResetData = any;

export interface OrgBudgetOverviewDto {
  /** Contract type, e.g. all_inclusive, starter, churn */
  contract_type: string | null;
  /** Current budget, null when never set */
  current_budget: number | null;
  /** @format uuid */
  id: string;
  organizationName: string;
}

export interface Organization {
  comment: string;
  contractExpiryDate: string;
  contract_type: string;
  /** @format date-time */
  createdAt: string;
  current_budget: number;
  email: string;
  employees: Employee[];
  excludedEmployeeKomboIds: string[];
  excludedLegalEntityKomboIds: string[];
  excludedWorkLocationKomboIds: string[];
  hasEapAccess: boolean;
  hasInstructionsAccess: boolean;
  hasOhsHubAccess: boolean;
  id: string;
  isEnduserTCApprovalRequired: boolean;
  key: string;
  komboIntegrationId: string;
  komboIntegrationLink: string;
  /** @format date-time */
  komboIntegrationLinkExpiry: string;
  legalEntities: LegalEntity[];
  occupationalMedicineInfo: OrganizationOccupationalMedicineInfo;
  organizationName: string;
  originId: string;
  session_limit: number;
  tool: string;
  /** @format date-time */
  updatedAt: string;
  users: User[];
  workLocations: WorkLocation[];
}

/** Type of contract the organization has */
export enum OrganizationContractType {
  Trial = "trial",
  Starter = "starter",
  Churn = "churn",
  AllInclusive = "all_inclusive",
  Custom = "custom",
}

export interface OrganizationDto {
  /**
   * Additional comments about the organization
   * @maxLength 500
   * @example "Initial setup phase."
   */
  comment?: string;
  /**
   * Date when the contract expires (ISO 8601 format)
   * @format date
   * @example "2025-12-31"
   */
  contractExpiryDate?: string;
  /**
   * Type of contract the organization has
   * @example "all_inclusive"
   */
  contract_type?: OrganizationContractType;
  /**
   * Timestamp when the organization was created (ISO 8601 format)
   * @format date-time
   * @example "2023-10-26T10:00:00.000Z"
   */
  createdAt: string;
  /**
   * Current budget allocated (e.g., in cents or smallest currency unit)
   * @min 0
   * @example 500000
   */
  current_budget?: number;
  /**
   * Contact email for the organization
   * @format email
   * @example "contact@example.com"
   */
  email: string;
  /** Employees belonging to the organization */
  employees?: Employee[];
  /**
   * List of Kombo IDs for excluded employees
   * @example ["kombo_emp_exclude_1","kombo_emp_exclude_2"]
   */
  excludedEmployeeKomboIds?: string[];
  /**
   * List of Kombo IDs for excluded legal entities
   * @example ["kombo_le_exclude_1","kombo_le_exclude_2"]
   */
  excludedLegalEntityKomboIds?: string[];
  /**
   * List of Kombo IDs for excluded work locations
   * @example ["kombo_wl_exclude_1","kombo_wl_exclude_2"]
   */
  excludedWorkLocationKomboIds?: string[];
  /** Indicates if EAP features are enabled */
  hasEAPFeatures: boolean;
  /**
   * Flag indicating if the organization has access to EAP features
   * @example true
   */
  hasEapAccess: boolean;
  /**
   * Flag indicating if the organization has access to instructions features
   * @example false
   */
  hasInstructionsAccess: boolean;
  /**
   * Flag indicating if the organization has access to OHS Hub features
   * @example true
   */
  hasOhsHubAccess: boolean;
  /** Indicates if OHS Hub features are enabled */
  hasOhsHubFeatures: boolean;
  /**
   * Unique identifier for the organization (UUID)
   * @format uuid
   * @example "f6a7b8c9-d0e1-f2a3-b4c5-d6e7f8a9b0c1"
   */
  id: string;
  /** Indicates if the contract type is ALL_INCLUSIVE */
  isAllInclusive: boolean;
  /** Indicates if the contract type is CHURN */
  isChurn: boolean;
  /** Indicates if the contract type is CUSTOM */
  isCustom: boolean;
  /**
   * Flag indicating if end-user Terms & Conditions approval is required
   * @example false
   */
  isEnduserTCApprovalRequired: boolean;
  /** Indicates if the contract type is STARTER */
  isStarter: boolean;
  /** Indicates if the contract type is TRIAL */
  isTrial: boolean;
  /**
   * Unique key for the organization
   * @example "ORG_UNIQUE_KEY_123"
   */
  key: string;
  /**
   * Integration ID for Kombo
   * @example "kombo_int_12345"
   */
  komboIntegrationId?: string;
  /** Legal entities belonging to the organization */
  legalEntities?: LegalEntity[];
  /** Occupational medicine information for the organization */
  occupationalMedicineInfo?: OrganizationOccupationalMedicineInfo;
  /**
   * Name of the organization
   * @example "Example Company Inc."
   */
  organizationName: string;
  /**
   * Original identifier from the source system
   * @example "SOURCE_ID_ABC"
   */
  originId: string;
  /**
   * Maximum number of allowed sessions
   * @min 0
   * @example 10
   */
  session_limit?: number;
  /**
   * Identifier for the tool associated with the organization
   * @example "HRToolXYZ"
   */
  tool: string;
  /**
   * Timestamp when the organization was last updated (ISO 8601 format)
   * @format date-time
   * @example "2023-10-27T11:30:00.000Z"
   */
  updatedAt: string;
  /** Users associated with the organization */
  users?: User[];
  /** Work locations belonging to the organization */
  workLocations?: WorkLocation[];
}

export interface OrganizationOccupationalMedicineInfo {
  companyCc: string;
  /** @format date-time */
  created_at: string;
  emailSendingActive: boolean;
  employeeContact: string;
  id: string;
  /** @format uuid */
  legalEntity?: LegalEntity;
  mandatoryInstructionsDe: string;
  mandatoryInstructionsEn: string;
  offerInstructionsDe: string;
  offerInstructionsEn: string;
  /** @format uuid */
  parentOrganization: Organization;
  serviceName: string;
  /** @format date-time */
  updated_at: string;
}

export interface Partner {
  active: boolean;
  categories: number[];
  /** @format date-time */
  createdAt: string;
  description: string;
  externalId: string;
  id: string;
  languages: number[];
  name: string;
  partnerUrl: string;
  pricing: number;
  title: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PreventionAssignment {
  completions: PreventionCompletion[];
  /** @format date-time */
  createdAt: string;
  cycles: PreventionCycle[];
  /** @format date-time */
  deadline: string;
  employee: Employee;
  /** @format uuid */
  id: string;
  isActive: boolean;
  preventionNotices: PreventionNotice[];
  preventionProfile: PreventionProfile;
  preventionTrigger: PreventionTrigger;
  status: PreventionAssignmentStatusEnum;
  /** @format date-time */
  updatedAt: string;
}

export interface PreventionAssignmentBasedStats {
  /** Number of employees with at least one mandatory prevention assignment */
  employeesWithAssignments: number;
  /** Total number of active employees */
  totalEmployees: number;
}

export enum PreventionAssignmentStatusEnum {
  ALL_GOOD = "ALL_GOOD",
  DEADLINE_APPROACHING = "DEADLINE_APPROACHING",
  DEADLINE_MISSED = "DEADLINE_MISSED",
}

export interface PreventionCompletion {
  /** @format date-time */
  completionDate: string;
  /** @format date-time */
  createdAt: string;
  done: boolean;
  employee: Employee;
  /** @format uuid */
  id: string;
  preventionAssignment: PreventionAssignment;
  preventionCycle: PreventionCycle | null;
  /** @format date-time */
  updatedAt: string;
}

export interface PreventionCycle {
  /** @format date-time */
  completedAt: string | null;
  completion: PreventionCompletion | null;
  /** @format date-time */
  createdAt: string;
  cycleNumber: number;
  /** @format uuid */
  id: string;
  notices: PreventionNotice[];
  preventionAssignment: PreventionAssignment;
  /** @format date-time */
  startDate: string;
  status: PreventionCycleStatusEnum;
  /** @format date-time */
  updatedAt: string;
}

export enum PreventionCycleStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
}

export interface PreventionDeadlineBasedStats {
  /** Total number of overdue prevention assignments */
  overdue: number;
  /** Total number of completed prevention assignments */
  totalDone: number;
  /** Total number of due prevention assignments (deadline-based) */
  totalDue: number;
}

export interface PreventionEmployeesResponseDto {
  /** List of employees with prevention status */
  employees: Employee[];
  /**
   * Organization ID
   * @example "org-uuid-123"
   */
  organizationId: string;
  /**
   * Total number of employees
   * @example 50
   */
  totalEmployees: number;
}

export interface PreventionNotice {
  /** @format date-time */
  createdAt: string;
  emailType?: string;
  employee: Employee;
  errorMessage: string;
  /** @format uuid */
  id: string;
  isSent: boolean;
  preventionAssignment: PreventionAssignment;
  preventionCycle: PreventionCycle | null;
  preventionTrigger: PreventionTrigger;
  /** @format date-time */
  sentAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PreventionProfile {
  category: PreventionProfileCategoryEnum;
  /** @format date-time */
  createdAt: string;
  description?: string;
  /** @format uuid */
  id: string;
  isActive: boolean;
  organization: Organization;
  preventionTrigger: PreventionTrigger;
  rules: object;
  /** @format date-time */
  updatedAt: string;
}

export enum PreventionProfileCategoryEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export interface PreventionProfileResponseDto {
  /**
   * Profile category
   * @example "MANDATORY"
   */
  category: PreventionProfileResponseDtoCategoryEnum;
  /**
   * Profile description
   * @example "Safety training for new employees"
   */
  description: string;
  /**
   * Profile ID
   * @example "profile-uuid-123"
   */
  id: string;
}

/**
 * Profile category
 * @example "MANDATORY"
 */
export enum PreventionProfileResponseDtoCategoryEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export interface PreventionStatisticsResponseDto {
  /**
   * Number of all good prevention assignments
   * @example 70
   */
  allGood: number;
  /**
   * Number of employees with at least one active prevention assignment
   * @example 42
   */
  employeesWithPreventions: number;
  /**
   * Number of overdue prevention assignments
   * @example 10
   */
  overdue: number;
  /**
   * Number of pending prevention assignments
   * @example 20
   */
  pending: number;
  /**
   * Number of prevention completions in the last 90 days
   * @example 42
   */
  preventionCompletionCount: number;
  /**
   * Number of prevention notices sent in the last 30 days
   * @example 15
   */
  preventionNoticeCount: number;
  /**
   * Prevention assignments categorized by status and type
   * @example {"automatic":{"MANDATORY":10,"OFFER":20},"upcoming":{"MANDATORY":15,"OFFER":25},"overdue":{"MANDATORY":5},"upcomingAndOverdueList":[]}
   */
  preventionStatus: PreventionStatusCounts;
}

export interface PreventionStats {
  /** Assignment-based prevention statistics */
  assignmentBased: PreventionAssignmentBasedStats;
  /** Deadline-based prevention statistics */
  deadlineBased: PreventionDeadlineBasedStats;
}

export interface PreventionStatusCounts {
  automatic: {
    MANDATORY: number;
    OFFER: number;
  };
  overdue: {
    MANDATORY: number;
  };
  upcoming: {
    MANDATORY: number;
    OFFER: number;
  };
  upcomingAndOverdueList: PreventionAssignment[];
}

export interface PreventionTrigger {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  name: string;
  preventionProfile: PreventionProfile;
  /** @format date-time */
  updatedAt: string;
}

export interface PreventionTriggerResponseDto {
  /**
   * Trigger ID
   * @example "trigger-uuid-123"
   */
  id: string;
  /**
   * Trigger name
   * @example "New Employee Onboarding"
   */
  name: string;
}

export type ProcessAllPreventionEmailsUnifiedData = object;

export interface ProcessAllPreventionEmailsUnifiedParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID (required for authentication) */
  orgId: string;
}

export type ProcessByIdData = ApiResponseDto & {
  results?: any;
};

export type ProcessByIdError = ApiErrorResponseDto;

export type ProcessMandatoryEmailsForAllOrgsData = object;

export interface ProcessMandatoryEmailsForAllOrgsParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID (required for authentication) */
  orgId: string;
}

export type ProcessMandatoryEmailsForSingleOrgData = any;

export interface ProcessMandatoryEmailsForSingleOrgParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID to process mandatory emails for */
  orgId: string;
}

export type ProcessNoticeData = ProcessSingleResultDto;

export interface ProcessNoticeParams1 {
  /** If true, will not send emails or update records */
  dryRun?: any;
  /** The ID of the prevention notice */
  id: string;
  /** The ID of the organization */
  orgId: string;
}

export type ProcessNoticeResult = ProcessSingleResultDto;

export type ProcessNoticesByOrganizationData = ProcessResultDto;

export interface ProcessNoticesByOrganizationParams {
  dryRun: boolean;
  orgId: string;
}

export type ProcessNoticesForAllOrgsData = ProcessNoticesResultDto;

export interface ProcessNoticesForAllOrgsParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID (required for authentication) */
  orgId: string;
}

export type ProcessNoticesForSingleOrgData = ProcessSingleOrgResultDto;

export interface ProcessNoticesForSingleOrgParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID to process notices for */
  orgId: string;
}

export interface ProcessNoticesResultDto {
  /** Number of failed organizations */
  failed: number;
  /**
   * Detailed results per organization
   * @example [{"organizationId":"org-1","organizationName":"Test Org","success":true,"duration":1.5,"processed":10,"sent":5,"failed":2,"noticeResults":[{"success":true,"noticeId":"notice-1","employeeId":"emp-1","preventionTriggerId":"trigger-1","email":"test1@example.com","isDryRun":true}]}]
   */
  results: object[];
  /** Number of successful organizations */
  successful: number;
  /** Total duration in seconds */
  totalDuration: number;
  /** Total number of organizations processed */
  totalProcessed: number;
}

export type ProcessPreventionEmailsUnifiedSingleOrgData = object;

export interface ProcessPreventionEmailsUnifiedSingleOrgParams {
  /** Whether to perform a dry run (default: true) */
  dryRun?: boolean;
  /** Organization ID to process */
  orgId: string;
}

export interface ProcessResultDto {
  /** Number of notices that failed to process. */
  failed: number;
  /** Total number of notices processed. */
  processed: number;
  /** Detailed results for each processed notice. */
  results: NoticeProcessingResultDto[];
  /** Number of notices successfully sent. */
  sent: number;
}

export interface ProcessSingleOrgResultDto {
  /** Processing duration in seconds */
  duration: number;
  /** Error message if processing failed */
  error?: string;
  /** Number of notices that failed */
  failed?: number;
  /** Detailed results for each notice processed */
  noticeResults?: NoticeProcessingResultDto[];
  /** Organization ID */
  organizationId: string;
  /** Organization name */
  organizationName: string;
  /** Number of notices processed */
  processed?: number;
  /** Number of notices sent */
  sent?: number;
  /** Whether processing was successful */
  success: boolean;
}

export interface ProcessSingleResultDto {
  /** The email address the notice was sent to. */
  email?: string;
  /**
   * The ID of the employee associated with the notice.
   * @format uuid
   */
  employeeId: string;
  /** Error message if processing failed. */
  error?: string;
  /** Whether this was a dry run. */
  isDryRun: boolean;
  /** Human-readable message about the processing result. */
  message: string;
  /**
   * The ID of the processed notice.
   * @format uuid
   */
  noticeId: string;
  /**
   * The ID of the prevention trigger associated with the notice.
   * @format uuid
   */
  preventionTriggerId: string;
  /**
   * When the notice was sent, if applicable.
   * @format date-time
   */
  sentAt?: string;
  /** Whether the notice processing was successful. */
  success: boolean;
}

export interface QuestionCategoryDto {
  /**
   * Category title
   * @example "Working Hours"
   */
  categoryTitle: string;
  /** List of questions in this category */
  questions: QuestionDto[];
  /**
   * Optional toggle question for the category
   * @example "Does the employee work in areas where..."
   */
  toggleQuestion?: string;
}

export interface QuestionDto {
  /**
   * Explanatory note for the question
   * @example "The employment of pregnant employees for more than 8.5 hours daily is not permissible."
   */
  note: string;
  /**
   * Question text
   * @example "Does the employee work more than 8.5 hours a day?"
   */
  question: string;
}

export interface QuestionnaireResponse {
  answers: object;
  /** @format uuid */
  assessment: MaternityRiskAssessment;
  /** @format date-time */
  createdAt: string;
  id: string;
  /** @format date-time */
  submittedAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface QuestionnaireResponseDto {
  /** English version of the questionnaire */
  english: QuestionCategoryDto[];
  /** German version of the questionnaire */
  german: QuestionCategoryDto[];
}

export interface QuestionnaireResponseResponseDto {
  /**
   * Questionnaire answers
   * @example {"question_1":"no_measures","question_2":"yes_measures","question_3":"no_measures"}
   */
  answers: object;
  /** Assessment details */
  assessment: MaternityRiskAssessment;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  createdAt: string;
  /**
   * Response ID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Submission timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  submittedAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  updatedAt: string;
}

export interface QuizAnswerDto {
  /** @min 0 */
  questionIndex: number;
  selectedAnswerIndices: number[];
}

export interface QuizResultDto {
  passed: boolean;
  score: number;
  total: number;
}

export interface QuizSubmitDto {
  answers: QuizAnswerDto[];
}

export interface ReceiptDocumentResponseDto {
  /**
   * The ID of the receipt document
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  documentId: string;
  /**
   * The presigned URL to download the receipt document
   * @example "https://example-bucket.s3.amazonaws.com/documents/receipt.pdf?signature=..."
   */
  url: string;
}

export interface ReceiptSummaryResponseDto {
  /**
   * Number of receipt documents associated with the completion
   * @min 0
   * @example 1
   */
  documentCount: number;
  /**
   * Whether the completion has a receipt document
   * @example true
   */
  hasReceipt: boolean;
  /**
   * The date when the receipt was last updated
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  lastUpdated?: string;
  /**
   * The ID of the primary receipt document
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  primaryDocumentId?: string;
}

export type RemoveData = any;

export type RequestUploadData = RequestUploadResponseDto;

export interface RequestUploadDto {
  /** @format uuid */
  entity_id: string;
  entity_type: string;
  filename: string;
  mimeType: RequestUploadDtoMimeTypeEnum;
  /** @max 10485760 */
  size: number;
}

export enum RequestUploadDtoMimeTypeEnum {
  ApplicationPdf = "application/pdf",
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
  ImageTiff = "image/tiff",
  ImageJpg = "image/jpg",
}

export interface RequestUploadResponseDto {
  documentId: string;
  uploadUrl: string;
}

export type ReserveSessionData = object;

export interface ReserveSessionDto {
  numberOfSessions: number;
  /**
   * @format date-time
   * @default "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  userId: string;
}

export type SaveVideoProgressData = any;

export type SearchUsersData = User[];

export interface SearchUsersParams {
  query: string;
}

export interface SendTestMandatoryPreventionEmailData {
  /** Total emails that failed */
  failed?: number;
  /** Total emails processed */
  processed?: number;
  /** Detailed results for each email sent */
  results?: {
    emailAddress?: string;
    emailType?: string;
    error?: string;
    /** @format date-time */
    sentAt?: string;
    success?: boolean;
  }[];
  /** Total emails sent successfully */
  sent?: number;
  /** Total emails skipped */
  skipped?: number;
}

export interface SendTestMandatoryPreventionEmailDto {
  /**
   * Display name for the test employee
   * @default "Test Employee"
   * @example "Test User"
   */
  displayName?: string;
  /**
   * Email address to send test emails to
   * @format email
   * @example "test@company.com"
   */
  email: string;
  /**
   * Type of mandatory prevention email to send. Use "ALL" to send all types.
   * @default "ALL"
   * @example "ALL"
   */
  emailType?: SendTestMandatoryPreventionEmailDtoEmailTypeEnum;
  /**
   * Organization ID to use for realistic test data. If not provided, mock data will be used.
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  organizationId?: string;
  /**
   * Prevention trigger name for the test
   * @default "Test Prevention Trigger"
   * @example "G25 - Arbeitsmedizinische Vorsorge"
   */
  preventionTriggerName?: string;
}

/**
 * Type of mandatory prevention email to send. Use "ALL" to send all types.
 * @default "ALL"
 * @example "ALL"
 */
export enum SendTestMandatoryPreventionEmailDtoEmailTypeEnum {
  NOTICE = "NOTICE",
  FIRST_REMINDER = "FIRST_REMINDER",
  SECOND_REMINDER = "SECOND_REMINDER",
  ALL = "ALL",
}

export interface SendTestOfferPreventionEmailData {
  failed?: number;
  processed?: number;
  results?: {
    emailAddress?: string;
    error?: string;
    /** @format date-time */
    sentAt?: string;
    success?: boolean;
  }[];
  sent?: number;
  skipped?: number;
}

export interface SendTestOfferPreventionEmailDto {
  /**
   * Display name for the test employee
   * @default "Test Employee"
   * @example "Test User"
   */
  displayName?: string;
  /**
   * Email address to send the test offer email to
   * @format email
   * @example "test@company.com"
   */
  email: string;
  /**
   * Organization ID to use for realistic test data (org name, medicine info). If not provided, mock data will be used.
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  organizationId?: string;
  /**
   * Prevention trigger name for the test
   * @default "Test Prevention Trigger"
   * @example "Occupational health check-up"
   */
  preventionTriggerName?: string;
}

export interface SessionMessage {
  booking: Booking;
  /** @format date-time */
  createdAt: string;
  expertExternalId: string;
  id: string;
  message: string;
  /** @format date-time */
  readAt: string | null;
  sentBy: string;
  /** @format date-time */
  updatedAt: string;
  user: User;
}

export interface SessionMessageDto {
  bookingId: string;
  locale?: string;
  message: string;
  /**
   * @format date-time
   * @default "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  userId: string;
}

export interface SessionMessageResponseDto {
  /** @format date-time */
  date: string;
  message: string;
  /** @format date-time */
  readAt: string | null;
  sentBy: string;
}

export enum StatusEnum {
  PENDING = "PENDING",
  INVITED = "INVITED",
  REMINDER_1_SENT = "REMINDER_1_SENT",
  REMINDER_2_SENT = "REMINDER_2_SENT",
  COMPLETED = "COMPLETED",
  OVERDUE = "OVERDUE",
}

export interface SubmitAssessmentDto {
  /** The answers to the survey questions */
  answers: Record<string, string | number>;
  /**
   * The ID of the group this assessment is for
   * @format uuid
   */
  selectedGroupId?: string;
}

export type SubmitExternalFirstAidLogData = any;

export type SubmitQuestionnaireData = QuestionnaireResponseResponseDto;

export interface SubmitQuestionnaireResponseDto {
  /**
   * Questionnaire answers
   * @example {"question_1":"no_measures","question_2":"yes_measures","question_3":"no_measures"}
   */
  answers: object;
  /**
   * Assessment ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assessmentId: string;
}

export type SubmitQuizData = QuizResultDto;

export type SubmitResponseData = AssessmentResponse;

export interface SurveyDto {
  description: string;
  id: string;
  sections: SurveySection[];
  title: string;
}

export interface SurveyQuestion {
  defaultValue?: number;
  groupId?: string;
  groupLabels?: Record<string, string>;
  id: string;
  options?: {
    label?: string;
    value?: string;
  }[];
  question: string;
  type: SurveyQuestionTypeEnum;
}

export enum SurveyQuestionTypeEnum {
  Radio = "radio",
  Step = "step",
  Text = "text",
  Select = "select",
}

export interface SurveyResponseDto {
  /**
   * The ID of the assessment cycle
   * @example "uuid-assessment-cycle"
   */
  cycleId: string;
  /**
   * The ID of the organization that created the assessment
   * @example "uuid-organization"
   */
  organizationId: string;
  /**
   * Name of the organization that created the assessment
   * @example "Acme Corp"
   */
  organizationName: string;
  /**
   * Status of the assessment cycle
   * @example "active"
   */
  status: SurveyResponseDtoStatusEnum;
  /** The survey content */
  survey?: EnrichedSurveyDto;
}

/**
 * Status of the assessment cycle
 * @example "active"
 */
export enum SurveyResponseDtoStatusEnum {
  Active = "active",
  Closed = "closed",
  Final = "final",
}

export interface SurveySection {
  description: string;
  id: string;
  items: (SurveyQuestion | SurveySubSection)[];
  /** @example {"1":"label1","2":"label2"} */
  scaleLabels?: Record<string, string>;
  title: string;
}

export interface SurveySubSection {
  description?: string;
  id: string;
  questions: SurveyQuestion[];
  title: string;
  type: SurveySubSectionTypeEnum;
}

export enum SurveySubSectionTypeEnum {
  Subsection = "subsection",
}

export type SyncByIdData = ApiResponseDto;

export type SyncByIdError = ApiErrorResponseDto;

export interface TestResult {
  /** @format date-time */
  created_at: string;
  id: number;
  score: number;
  user_id: string;
}

export interface TestSlackIntegrationData {
  message?: string;
  success?: boolean;
}

export type ToggleEmailSendingData = OrganizationOccupationalMedicineInfo;

export type TriggerDailySyncData = ApiResponseDto;

export interface UnreadMessagesCountResponseDto {
  /**
   * Total number of unread messages
   * @example 5
   */
  count: number;
}

export interface UpdateAssessmentCycleNoteDto {
  /**
   * New employee note
   * @example "Updated assessment instructions"
   */
  employeeNote: string;
}

export type UpdateAssessmentData = MaternityRiskAssessmentResponseDto;

export type UpdateAssessmentStatusData = MaternityRiskAssessmentResponseDto;

export type UpdateAuthUserIdData = any;

export type UpdateBookingData = any;

export interface UpdateBookingDto {
  status: UpdateBookingDtoStatusEnum;
  /** @format date-time */
  time: string;
  /**
   * @format date-time
   * @default "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
}

export enum UpdateBookingDtoStatusEnum {
  CREATED = "CREATED",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  CHANGED = "CHANGED",
}

export type UpdateBookingResult = Booking;

export type UpdateBookingTimeData = Booking;

export interface UpdateBookingTimeDto {
  newTime: string;
}

export type UpdateBookingTimeResult = Booking;

export type UpdateBudgetData = number;

export type UpdateCalendlyTokenData = any;

export type UpdateCompletionData = PreventionCompletion;

export type UpdateCycleNoteData = AssessmentCycle;

export type UpdateData = Expert;

export type UpdateDeadlineData = PreventionAssignment;

export type UpdateDueDateData = InstructionAssignmentResponseDto;

export type UpdateEapAccessData = any;

export interface UpdateEmployeeNoteDto {
  /** @maxLength 500 */
  note: string;
}

export type UpdateExclusionsData = Organization;

export type UpdateExclusionsResult = Organization;

export interface UpdateExpertCalendlyTokenDto {
  calendlyAccessToken: string;
}

export interface UpdateFirstAidLogDto {
  /** @format uuid */
  affectedEmployeeId?: string;
  affectedEmployeeName?: string;
  assignmentStatus?: FirstAidLogAssignmentStatusEnum;
  doctorConsulted?: boolean;
  /** @format date-time */
  doctorVisitDateTime?: string | null;
  /** @format date-time */
  firstAidDateTime?: string;
  firstAidDescription?: string;
  firstAiderIds?: string[] | null;
  firstAiderNames?: string;
  /** @format date-time */
  incidentDateTime?: string;
  incidentDescription?: string;
  incidentLocation?: string;
  injuryDescription?: string;
  /** @format uuid */
  organizationId?: string;
  otherInvolvedPersons?: string | null;
  witnessIds?: string[] | null;
  witnessNames?: string;
}

export interface UpdateInstructionAssignmentDueDateDto {
  /** New due date (minimum 61 days in the future) */
  dueDate: string;
}

export type UpdateInstructionsAccessData = any;

export type UpdateLanguageIdData = any;

export interface UpdateMaternityNotificationDto {
  /**
   * Whether consultation was offered
   * @example true
   */
  consultationOffered?: boolean;
  /**
   * Expected due date
   * @example "2024-07-15"
   */
  expectedDueDate?: string;
  /**
   * Notification ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Date when the maternity notification was made
   * @example "2024-01-15"
   */
  notificationDate?: string;
}

export interface UpdateMaternityRiskAssessmentDto {
  /**
   * Assessment ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Assessment status
   * @example "measures_necessary"
   */
  status?: AssessmentStatus;
}

export type UpdateNoteForEmployeeData = Employee;

export type UpdateNotificationData = MaternityNotificationResponseDto;

export type UpdateOccupationalMedicineInfoData =
  OrganizationOccupationalMedicineInfo;

export type UpdateOhsHubAccessData = any;

export interface UpdateOrgAccessDto {
  hasInstructionsAccess: boolean;
  /** @format uuid */
  orgId: string;
}

export interface UpdateOrgBudgetDto {
  /** @min 0 */
  newBudget: number;
  /** @format uuid */
  orgId: string;
}

export interface UpdateOrgEapAccessDto {
  hasEapAccess: boolean;
  /** @format uuid */
  orgId: string;
}

export interface UpdateOrgExclusionsDto {
  /** @maxItems 500 */
  excludedEmployeeKomboIds?: string[];
  /** @maxItems 100 */
  excludedLegalEntityKomboIds?: string[];
  /** @maxItems 100 */
  excludedWorkLocationKomboIds?: string[];
  /** @format uuid */
  orgId: string;
}

export interface UpdateOrgOhsHubAccessDto {
  hasOhsHubAccess: boolean;
  /** @format uuid */
  orgId: string;
}

export type UpdateOrganizationData = User;

export interface UpdateOrganizationExclusionsDto {
  /**
   * @maxItems 500
   * @minItems 1
   */
  excludedEmployeeKomboIds?: string[];
  /**
   * @maxItems 100
   * @minItems 1
   */
  excludedLegalEntityKomboIds?: string[];
  /**
   * @maxItems 100
   * @minItems 1
   */
  excludedWorkLocationKomboIds?: string[];
}

export interface UpdateOrganizationOccupationalMedicineInfoDto {
  companyCc?: string;
  emailSendingActive?: boolean;
  employeeContact?: string;
  /** @format uuid */
  legalEntityId?: string;
  mandatoryInstructionsDe?: string;
  mandatoryInstructionsEn?: string;
  offerInstructionsDe?: string;
  offerInstructionsEn?: string;
  serviceName?: string;
}

export type UpdateOutput = FirstAidLog;

export interface UpdatePreventionAssignmentDeadlineDto {
  /** @format date-time */
  deadline: string;
  preventionAssignmentId: string;
}

export interface UpdatePreventionCompletionDto {
  /**
   * The ID of the prevention assignment to complete
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignmentId?: string;
  /**
   * The date when the prevention was completed. Cannot be more than 7 days in the future or more than 5 years in the past.
   * @example "2024-01-15T10:30:00Z"
   */
  completionDate?: string;
  /**
   * Whether the prevention was actually done (true) or declined/not done (false)
   * @default true
   * @example true
   */
  done?: boolean;
}

export interface UpdatePreventionNoticeDto {
  /** Type of email (OFFER, NOTICE, FIRST_REMINDER, SECOND_REMINDER) */
  emailType?: string;
  /**
   * The ID of the employee.
   * @format uuid
   */
  employeeId?: string;
  /** Whether the notice has been sent. */
  isSent?: boolean;
  /**
   * The ID of the prevention assignment.
   * @format uuid
   */
  preventionAssignmentId?: string;
  /**
   * The ID of the prevention cycle.
   * @format uuid
   */
  preventionCycleId?: string;
  /**
   * The ID of the prevention trigger.
   * @format uuid
   */
  preventionTriggerId?: string;
  /**
   * When the notice was sent.
   * @format date-time
   */
  sentAt?: string;
}

export type UpdatePreventionRuleData = PreventionProfile;

export interface UpdatePreventionRuleDto {
  /**
   * Prevention category
   * @example "OFFER"
   */
  category?: UpdatePreventionRuleDtoCategoryEnum;
  /** Rule description */
  description?: string;
  /**
   * Due days for prevention completion
   * @example 90
   */
  dueDays?: number;
  /** Whether the rule is active */
  isActive?: boolean;
  /** Rule name */
  name?: string;
  /** Organization ID */
  organizationId?: string;
  /** Prevention trigger ID */
  preventionTriggerId?: string;
  /**
   * JSON rules engine conditions
   * @example {"all":[{"fact":"jobCategories","operator":"contains","value":"construction"},{"fact":"age","operator":"greaterThanInclusive","value":50}]}
   */
  rules?: object;
}

/**
 * Prevention category
 * @example "OFFER"
 */
export enum UpdatePreventionRuleDtoCategoryEnum {
  MANDATORY = "MANDATORY",
  OFFER = "OFFER",
}

export type UpdateQuestionnaireData = QuestionnaireResponseResponseDto;

export interface UpdateQuestionnaireResponseDto {
  /**
   * Updated questionnaire answers
   * @example {"question_1":"no_measures","question_2":"yes_measures","question_3":"no_measures"}
   */
  answers: object;
  /**
   * Assessment ID
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assessmentId: string;
}

export type UpdateRequiresPasswordResetData = any;

export type UpdateResult = PreventionNotice;

export type UpdateStatusForOrgData = any;

export interface UpdateUserAccessData {
  /** @example "User access updated successfully" */
  message?: string;
  /** Updated user with accessible entities and locations */
  user?: object;
}

export interface UpdateUserAccessDto {
  /**
   * Array of Legal Entity IDs to assign to the user
   * @example ["123e4567-e89b-12d3-a456-426614174000","123e4567-e89b-12d3-a456-426614174001"]
   */
  legalEntityIds: string[];
  /**
   * OHS Hub role for the user (admin or restricted)
   * @example "restricted"
   */
  ohsHubRole?: UpdateUserAccessDtoOhsHubRoleEnum;
  /**
   * Array of Work Location IDs to assign to the user
   * @example ["123e4567-e89b-12d3-a456-426614174002","123e4567-e89b-12d3-a456-426614174003"]
   */
  workLocationIds: string[];
}

/**
 * OHS Hub role for the user (admin or restricted)
 * @example "restricted"
 */
export enum UpdateUserAccessDtoOhsHubRoleEnum {
  Admin = "admin",
  Restricted = "restricted",
}

export interface UpdateUserOrganizationDto {
  /**
   * The ID of the new organization for the user
   * @example "sample_uuid"
   */
  organizationId: string;
  /**
   * Whether to set the user as an OHS Hub admin in the new organization. Defaults to true to preserve existing behaviour (e.g. admin panel "set current org").
   * @example true
   */
  setAsOhsHubAdmin?: boolean;
}

export interface User {
  accessibleLegalEntities: LegalEntity[];
  accessibleWorkLocations: WorkLocation[];
  active: boolean;
  authUserId: string | null;
  /** @format date-time */
  createdAt: string;
  email: string;
  firstName: string;
  fullName: string;
  hasOhsHubAccess: boolean;
  id: string;
  language: UserLanguageEnum;
  lastName: string;
  marketingConsent: boolean;
  ohsAuthUserId: string | null;
  ohsHubRole: UserOhsHubRoleEnum;
  organization: Organization;
  requiresPasswordReset: boolean;
  requiresPwResetGinione: boolean;
  termsAndConditionsConsent: boolean;
  /** @format date-time */
  termsAndConditionsConsentAcceptedAt: string;
  topics: string[];
  /** @format date-time */
  updatedAt: string;
  verified: boolean;
}

export enum UserLanguageEnum {
  En = "en",
  De = "de",
  Zh = "zh",
}

export enum UserOhsHubRoleEnum {
  Admin = "admin",
  Restricted = "restricted",
}

export type ValidateTokenData = InstructionAccessResponseDto;

export interface WorkLocation {
  address?: AddressDto;
  /** @format date-time */
  created_at: string;
  employees: Employee[];
  id: string;
  komboId: string;
  name: string;
  /** @format uuid */
  parentOrganization: Organization;
  type: WorkLocationTypeEnum;
  /** @format date-time */
  updated_at: string;
}

export enum WorkLocationTypeEnum {
  OFFICE = "OFFICE",
  REMOTE = "REMOTE",
  HYBRID = "HYBRID",
  SITE = "SITE",
}

export namespace Videos {
  /**
   * No description
   * @tags Video
   * @name GetTotalDuration
   * @request GET:/videos/total-duration/{id}
   * @response `200` `GetTotalDurationData`
   */
  export namespace GetTotalDuration {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetTotalDurationData;
  }

  /**
   * No description
   * @tags Video
   * @name SaveVideoProgress
   * @request POST:/videos/progress
   * @response `201` `SaveVideoProgressData`
   */
  export namespace SaveVideoProgress {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SaveVideoProgressData;
  }

  /**
   * No description
   * @tags Video
   * @name GetSingleVideosProgress
   * @request GET:/videos/progress
   * @response `200` `GetSingleVideosProgressData`
   */
  export namespace GetSingleVideosProgress {
    export type RequestParams = {};
    export type RequestQuery = {
      url: string;
      userId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetSingleVideosProgressData;
  }

  /**
   * No description
   * @tags Video
   * @name GetVideosProgress
   * @request GET:/videos/progress/{courseId}
   * @response `200` `GetVideosProgressData`
   */
  export namespace GetVideosProgress {
    export type RequestParams = {
      courseId: number;
    };
    export type RequestQuery = {
      userId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetVideosProgressData;
  }

  /**
   * No description
   * @tags Video
   * @name GetVideoDuration
   * @request GET:/videos/video-duration
   * @response `200` `GetVideoDurationData`
   */
  export namespace GetVideoDuration {
    export type RequestParams = {};
    export type RequestQuery = {
      url: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetVideoDurationData;
  }
}

export namespace Bookings {
  /**
   * No description
   * @tags Booking
   * @name CreateBooking
   * @request POST:/bookings
   * @response `201` `CreateBookingData`
   */
  export namespace CreateBooking {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateBookingDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name FindBooking
   * @request GET:/bookings/find-booking
   * @response `200` `FindBookingData`
   */
  export namespace FindBooking {
    export type RequestParams = {};
    export type RequestQuery = {
      courseId: string;
      userId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetParticipantsCount
   * @request GET:/bookings/participants-count
   * @response `200` `GetParticipantsCountData`
   */
  export namespace GetParticipantsCount {
    export type RequestParams = {};
    export type RequestQuery = {
      courseId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetParticipantsCountData;
  }

  /**
   * No description
   * @tags Booking
   * @name HasActiveBooking
   * @request GET:/bookings/has-active-booking
   * @response `200` `HasActiveBookingData`
   */
  export namespace HasActiveBooking {
    export type RequestParams = {};
    export type RequestQuery = {
      courseId: string;
      userId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HasActiveBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetUserBookings
   * @request GET:/bookings/user/{userId}
   * @response `200` `GetUserBookingsData`
   */
  export namespace GetUserBookings {
    export type RequestParams = {
      userId: string;
    };
    export type RequestQuery = {
      past: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUserBookingsData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetExpertBookings
   * @request GET:/bookings/expert/{expertId}
   * @response `200` `GetExpertBookingsData`
   */
  export namespace GetExpertBookings {
    export type RequestParams = {
      expertId: string;
    };
    export type RequestQuery = {
      limit: number;
      past: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetExpertBookingsData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetBookingDetails
   * @request GET:/bookings/{id}
   * @response `200` `GetBookingDetailsData`
   */
  export namespace GetBookingDetails {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetBookingDetailsData;
  }

  /**
   * No description
   * @tags Booking
   * @name UpdateBooking
   * @request PUT:/bookings/{id}
   * @response `200` `UpdateBookingData`
   */
  export namespace UpdateBooking {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBookingDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name ApproveBooking
   * @request PUT:/bookings/{id}/approve
   * @response `200` `ApproveBookingData`
   */
  export namespace ApproveBooking {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApproveBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name CancelBooking
   * @request PUT:/bookings/{id}/cancel
   * @response `200` `CancelBookingData`
   */
  export namespace CancelBooking {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CancelBookingData;
  }

  /**
   * No description
   * @tags Booking
   * @name UpdateBookingTime
   * @request PUT:/bookings/{id}/update-time
   * @response `200` `UpdateBookingTimeData`
   */
  export namespace UpdateBookingTime {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBookingTimeDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBookingTimeData;
  }

  /**
   * No description
   * @tags Booking
   * @name Messages
   * @request POST:/bookings/{id}/messages
   * @response `201` `MessagesData`
   */
  export namespace Messages {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SessionMessageDto;
    export type RequestHeaders = {};
    export type ResponseBody = MessagesData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetMessages
   * @request GET:/bookings/{id}/messages
   * @response `200` `GetMessagesData`
   */
  export namespace GetMessages {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetMessagesData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetUserConversations
   * @request GET:/bookings/{userId}/conversations
   * @response `200` `GetUserConversationsData`
   */
  export namespace GetUserConversations {
    export type RequestParams = {
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUserConversationsData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetTotalUnreadMessagesCount
   * @summary Get total unread messages count for a user
   * @request GET:/bookings/{authUserId}/unread-messages-count
   * @response `200` `GetTotalUnreadMessagesCountData` Returns the total count of unread messages
   */
  export namespace GetTotalUnreadMessagesCount {
    export type RequestParams = {
      authUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetTotalUnreadMessagesCountData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetExpertConversations
   * @request GET:/bookings/{expertId}/expert-conversations
   * @response `200` `GetExpertConversationsData`
   */
  export namespace GetExpertConversations {
    export type RequestParams = {
      expertId: string;
    };
    export type RequestQuery = {
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetExpertConversationsData;
  }

  /**
   * No description
   * @tags Booking
   * @name GetTotalUnreadMessagesCountForExpert
   * @summary Get total unread messages count for an expert
   * @request GET:/bookings/{expertId}/expert-unread-messages-count
   * @response `200` `GetTotalUnreadMessagesCountForExpertData` Returns the total count of unread messages
   */
  export namespace GetTotalUnreadMessagesCountForExpert {
    export type RequestParams = {
      expertId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetTotalUnreadMessagesCountForExpertData;
  }
}

export namespace Orgs {
  /**
   * No description
   * @tags Org
   * @name GetBookings
   * @request GET:/orgs/{orgId}
   * @response `200` `GetBookingsData`
   */
  export namespace GetBookings {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetBookingsData;
  }

  /**
   * No description
   * @tags Org
   * @name GetUsers
   * @request GET:/orgs/{orgId}/users
   * @response `200` `GetUsersData`
   */
  export namespace GetUsers {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      active: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUsersData;
  }
}

export namespace OrientationCall {
  /**
   * No description
   * @tags OrientationCall
   * @name HandleCalendlyWebhook
   * @request POST:/orientation-call/calendly
   * @response `201` `HandleCalendlyWebhookData`
   */
  export namespace HandleCalendlyWebhook {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HandleCalendlyWebhookData;
  }
}

export namespace Experts {
  /**
   * No description
   * @tags Expert
   * @name Update
   * @request POST:/experts
   * @response `201` `UpdateData`
   */
  export namespace Update {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateData;
  }

  /**
   * No description
   * @tags Expert
   * @name GetAll
   * @request GET:/experts
   * @response `200` `GetAllData`
   */
  export namespace GetAll {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllData;
  }

  /**
   * No description
   * @tags Expert
   * @name GetByExternalId
   * @request GET:/experts/{expert_external_id}
   * @response `200` `GetByExternalIdData`
   */
  export namespace GetByExternalId {
    export type RequestParams = {
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetByExternalIdData;
  }

  /**
   * No description
   * @tags Expert
   * @name GetAvailabilities
   * @request GET:/experts/{expert_external_id}/availabilities
   * @response `200` `GetAvailabilitiesData`
   */
  export namespace GetAvailabilities {
    export type RequestParams = {
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAvailabilitiesData;
  }

  /**
   * No description
   * @tags Expert
   * @name GetAllBookings
   * @request GET:/experts/{expert_external_id}/bookings
   * @response `200` `GetAllBookingsData`
   */
  export namespace GetAllBookings {
    export type RequestParams = {
      expertExternalId: string;
    };
    export type RequestQuery = {
      limit: number;
      past: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllBookingsData;
  }

  /**
   * No description
   * @tags Expert
   * @name UpdateBooking
   * @request POST:/experts/{expert_external_id}/bookings/{booking_id}
   * @response `201` `UpdateBookingResult`
   */
  export namespace UpdateBooking {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBookingDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBookingResult;
  }

  /**
   * No description
   * @tags Expert
   * @name GetBookingDetails
   * @request GET:/experts/{expert_external_id}/bookings/{booking_id}
   * @response `200` `GetBookingDetailsResult`
   */
  export namespace GetBookingDetails {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetBookingDetailsResult;
  }

  /**
   * No description
   * @tags Expert
   * @name GetExpertBookingDetails
   * @request GET:/experts/{expert_external_id}/bookings-details/{booking_id}
   * @response `200` `GetExpertBookingDetailsData`
   */
  export namespace GetExpertBookingDetails {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetExpertBookingDetailsData;
  }

  /**
   * No description
   * @tags Expert
   * @name MeetingToken
   * @request GET:/experts/{expert_external_id}/bookings/{booking_id}/meeting/token
   * @response `200` `MeetingTokenData`
   */
  export namespace MeetingToken {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {
      is_expert: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingTokenData;
  }

  /**
   * No description
   * @tags Expert
   * @name GetCourseToken
   * @request GET:/experts/bookings/{booking_id}/course/token
   * @response `200` `GetCourseTokenData`
   */
  export namespace GetCourseToken {
    export type RequestParams = {
      bookingId: string;
    };
    export type RequestQuery = {
      is_expert: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetCourseTokenData;
  }

  /**
   * No description
   * @tags Expert
   * @name ReserveSession
   * @request GET:/experts/{expert_external_id}/reserve/session
   * @response `200` `ReserveSessionData`
   */
  export namespace ReserveSession {
    export type RequestParams = {
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ReserveSessionDto;
    export type RequestHeaders = {};
    export type ResponseBody = ReserveSessionData;
  }

  /**
   * No description
   * @tags Expert
   * @name ApproveBooking
   * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/approve
   * @response `200` `ApproveBookingResult`
   */
  export namespace ApproveBooking {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApproveBookingResult;
  }

  /**
   * No description
   * @tags Expert
   * @name CancelBooking
   * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/cancel
   * @response `200` `CancelBookingResult`
   */
  export namespace CancelBooking {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CancelBookingResult;
  }

  /**
   * No description
   * @tags Expert
   * @name UpdateBookingTime
   * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/update-time
   * @response `200` `UpdateBookingTimeResult`
   */
  export namespace UpdateBookingTime {
    export type RequestParams = {
      bookingId: string;
      expertExternalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateBookingTimeDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBookingTimeResult;
  }
}

export namespace Partners {
  /**
   * No description
   * @tags Partner
   * @name Create
   * @request POST:/partners
   * @response `201` `CreateData`
   */
  export namespace Create {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CreateData;
  }

  /**
   * No description
   * @tags Partner
   * @name GetAll
   * @request GET:/partners
   * @response `200` `GetAllResult`
   */
  export namespace GetAll {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllResult;
  }
}

export namespace Strapi {
  /**
   * No description
   * @tags StrapiWebhook
   * @name Event
   * @request POST:/strapi/webhook
   * @response `201` `EventData`
   */
  export namespace Event {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EventData;
  }
}

export namespace Users {
  /**
   * No description
   * @tags UserBooking
   * @name MeetingToken
   * @request GET:/users/{user_id}/bookings/{booking_id}/meeting/token
   * @response `200` `MeetingTokenResult`
   */
  export namespace MeetingToken {
    export type RequestParams = {
      bookingId: string;
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingTokenResult;
  }

  /**
   * No description
   * @tags UserBooking
   * @name CourseToken
   * @request GET:/users/bookings/{booking_id}/course/token
   * @response `200` `CourseTokenData`
   */
  export namespace CourseToken {
    export type RequestParams = {
      bookingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CourseTokenData;
  }

  /**
   * No description
   * @tags CourseBooking
   * @name MeetingToken2
   * @request GET:/users/{user_id}/bookings/{booking_id}/course/token
   * @originalName meetingToken
   * @duplicate
   * @response `200` `MeetingToken2Data`
   */
  export namespace MeetingToken2 {
    export type RequestParams = {
      bookingId: string;
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingToken2Data;
  }

  /**
   * No description
   * @tags User
   * @name SearchUsers
   * @request GET:/users/search
   * @response `200` `SearchUsersData`
   */
  export namespace SearchUsers {
    export type RequestParams = {};
    export type RequestQuery = {
      query: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SearchUsersData;
  }

  /**
   * No description
   * @tags User
   * @name GetUserById
   * @request GET:/users/{id}
   * @secure
   * @response `200` `GetUserByIdData` User details retrieved successfully
   * @response `404` `void` User not found or access denied
   */
  export namespace GetUserById {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUserByIdData;
  }

  /**
   * No description
   * @tags User
   * @name GetUserByAuthId
   * @request GET:/users/authUserId/{authUserId}
   * @secure
   * @response `200` `GetUserByAuthIdData` User details retrieved successfully
   * @response `404` `void` User not found or access denied (prevents user enumeration)
   */
  export namespace GetUserByAuthId {
    export type RequestParams = {
      authUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUserByAuthIdData;
  }

  /**
   * No description
   * @tags User
   * @name GetAdminRoleById
   * @request GET:/users/adminRoles/{id}
   * @secure
   * @response `200` `GetAdminRoleByIdData` User role retrieved successfully
   * @response `404` `void` User not found or access denied (prevents user enumeration)
   */
  export namespace GetAdminRoleById {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAdminRoleByIdData;
  }

  /**
   * No description
   * @tags User
   * @name FindAll
   * @request GET:/users
   * @response `200` `FindAllData`
   */
  export namespace FindAll {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindAllData;
  }

  /**
 * No description
 * @tags User
 * @name Create
 * @summary Legacy webhook endpoint for Bloom (backward compatible).
Handles `user.created` events from the Bloom Clerk app.
 * @request POST:/users
 * @response `201` `CreateResult`
*/
  export namespace Create {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CreateResult;
  }

  /**
   * No description
   * @tags User
   * @name CreateUser
   * @request POST:/users/create
   * @response `201` `CreateUserData`
   */
  export namespace CreateUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateNewUserDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserData;
  }

  /**
   * No description
   * @tags User
   * @name CreateBloomUser
   * @summary Webhook endpoint for Bloom user.created events.
   * @request POST:/users/webhooks/bloom/user-created
   * @response `201` `CreateBloomUserData`
   */
  export namespace CreateBloomUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CreateBloomUserData;
  }

  /**
   * No description
   * @tags User
   * @name GetRequiresPasswordReset
   * @request GET:/users/{email}/requiresPasswordReset
   * @response `200` `GetRequiresPasswordResetData`
   */
  export namespace GetRequiresPasswordReset {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetRequiresPasswordResetData;
  }

  /**
   * No description
   * @tags User
   * @name UpdateRequiresPasswordReset
   * @request PATCH:/users/{email}/requiresPasswordReset
   * @response `200` `UpdateRequiresPasswordResetData`
   */
  export namespace UpdateRequiresPasswordReset {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateRequiresPasswordResetData;
  }

  /**
   * No description
   * @tags User
   * @name UpdateAuthUserId
   * @request PATCH:/users/{email}/authUserId
   * @response `200` `UpdateAuthUserIdData`
   */
  export namespace UpdateAuthUserId {
    export type RequestParams = {
      email: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateAuthUserIdData;
  }

  /**
   * No description
   * @tags User
   * @name GetNumberOfRemainingSessions
   * @request GET:/users/numberOfSessionRemaining/{id}
   * @response `200` `GetNumberOfRemainingSessionsData`
   */
  export namespace GetNumberOfRemainingSessions {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetNumberOfRemainingSessionsData;
  }

  /**
   * No description
   * @tags User
   * @name UpdateLanguageId
   * @request PATCH:/users/{id}/language
   * @response `200` `UpdateLanguageIdData`
   */
  export namespace UpdateLanguageId {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateLanguageIdData;
  }

  /**
   * No description
   * @tags User
   * @name NotifyPasswordReset
   * @request POST:/users/notifyPasswordReset
   * @response `201` `NotifyPasswordResetData`
   */
  export namespace NotifyPasswordReset {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NotifyPasswordResetData;
  }

  /**
   * No description
   * @tags User
   * @name UpdateOrganization
   * @request PATCH:/users/{id}/organization
   * @secure
   * @response `200` `UpdateOrganizationData` The organization was updated successfully.
   * @response `400` `void` Bad Request (e.g., validation error, organization not found)
   * @response `403` `void` Forbidden (Authentication error)
   * @response `404` `void` User not found
   */
  export namespace UpdateOrganization {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateUserOrganizationDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateOrganizationData;
  }
}

export namespace Webhook {
  /**
   * No description
   * @tags ClerkWebhook
   * @name Email
   * @request POST:/webhook/email
   * @response `201` `EmailData`
   */
  export namespace Email {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EmailData;
  }
}

export namespace Organizations {
  /**
   * No description
   * @tags Organizations
   * @name GetOhsHubOrgs
   * @summary Get all OHS Hub organizations
   * @request GET:/organizations/ohs-hub-organizations
   * @secure
   * @response `200` `GetOhsHubOrgsData` Successfully retrieved the list of OHS Hub organizations.
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin or ops role
   */
  export namespace GetOhsHubOrgs {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOhsHubOrgsData;
  }

  /**
   * No description
   * @tags Organizations
   * @name FetchOrg
   * @summary Get organization by ID
   * @request GET:/organizations/{orgId}
   * @secure
   * @response `200` `FetchOrgData` Successfully retrieved the organization.
   * @response `404` `void` Organization not found
   */
  export namespace FetchOrg {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FetchOrgData;
  }

  /**
   * No description
   * @tags Organizations
   * @name FetchOrgDetailed
   * @summary Get detailed organization information by ID
   * @request GET:/organizations/{orgId}/detailed
   * @secure
   * @response `200` `FetchOrgDetailedData` Successfully retrieved detailed organization information.
   * @response `404` `void` Organization not found
   */
  export namespace FetchOrgDetailed {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FetchOrgDetailedData;
  }

  /**
   * No description
   * @tags Organizations
   * @name FetchOrgDetailedAdmin
   * @summary Get detailed organization information by ID (Admin only)
   * @request GET:/organizations/{orgId}/detailed/admin
   * @secure
   * @response `200` `FetchOrgDetailedAdminData` Successfully retrieved detailed organization information.
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin role
   * @response `404` `void` Organization not found
   */
  export namespace FetchOrgDetailedAdmin {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FetchOrgDetailedAdminData;
  }

  /**
   * No description
   * @tags Organizations
   * @name GetAreTcRequiredForEnduserOfOrganisation
   * @summary Check if terms and conditions are required for end users of an organization
   * @request GET:/organizations/tc/{orgId}
   * @secure
   * @response `200` `GetAreTcRequiredForEnduserOfOrganisationData` Successfully checked terms and conditions requirement.
   * @response `404` `void` Organization not found
   */
  export namespace GetAreTcRequiredForEnduserOfOrganisation {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAreTcRequiredForEnduserOfOrganisationData;
  }

  /**
   * No description
   * @tags Organizations
   * @name UpdateExclusions
   * @summary Update organization exclusions
   * @request PATCH:/organizations/{id}/exclusions
   * @secure
   * @response `200` `UpdateExclusionsData` Successfully updated organization exclusions.
   * @response `400` `void` Bad request - Invalid input data
   * @response `404` `void` Organization not found
   */
  export namespace UpdateExclusions {
    export type RequestParams = {
      /** UUID of the organization */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateOrganizationExclusionsDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateExclusionsData;
  }

  /**
   * No description
   * @tags Organizations
   * @name GetExclusions
   * @summary Get organization exclusions
   * @request GET:/organizations/{id}/exclusions
   * @secure
   * @response `200` `GetExclusionsData` Successfully retrieved organization exclusions.
   * @response `404` `void` Organization not found
   */
  export namespace GetExclusions {
    export type RequestParams = {
      /** UUID of the organization */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetExclusionsData;
  }

  /**
   * No description
   * @tags Organizations
   * @name CreateOrganizationAdmin
   * @request POST:/organizations/admin
   * @secure
   * @response `201` `CreateOrganizationAdminData`
   */
  export namespace CreateOrganizationAdmin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateOrganizationAdminRequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateOrganizationAdminData;
  }

  /**
   * No description
   * @tags Organizations
   * @name GetOrganizationByQrCode
   * @request GET:/organizations/qr/{qrCode}
   * @secure
   * @response `200` `GetOrganizationByQrCodeData`
   */
  export namespace GetOrganizationByQrCode {
    export type RequestParams = {
      qrCode: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOrganizationByQrCodeData;
  }

  /**
   * No description
   * @tags Organizations
   * @name SubmitExternalFirstAidLog
   * @request POST:/organizations/{orgId}/first-aid-logs/external
   * @secure
   * @response `201` `SubmitExternalFirstAidLogData`
   */
  export namespace SubmitExternalFirstAidLog {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateUnassignedFirstAidLogDto;
    export type RequestHeaders = {};
    export type ResponseBody = SubmitExternalFirstAidLogData;
  }

  /**
   * No description
   * @tags Organization Invitations
   * @name GetAllConfig
   * @request POST:/organizations/{orgId}/invitations
   * @response `201` `GetAllConfigData`
   */
  export namespace GetAllConfig {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = GetAllConfigPayload;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllConfigData;
  }

  /**
   * No description
   * @tags Organization Invitations
   * @name InviteVerification
   * @request POST:/organizations/{orgId}/invitation/verification
   * @response `201` `InviteVerificationData`
   */
  export namespace InviteVerification {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = InvitationCodeVerificationDto;
    export type RequestHeaders = {};
    export type ResponseBody = InviteVerificationData;
  }
}

export namespace OhsHub {
  /**
   * @description Retrieves detailed information about a specific organization including its structure and settings.
   * @tags OHS Hub - Organization Management
   * @name FindOne
   * @summary Get organization details
   * @request GET:/ohs-hub/orgs/{orgId}
   * @secure
   * @response `200` `FindOneData`
   */
  export namespace FindOne {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindOneData;
  }

  /**
   * @description Retrieves the occupational medicine information and settings for an organization.
   * @tags OHS Hub - Organization Management
   * @name GetOccupationalMedicineInfo
   * @summary Get occupational medicine info
   * @request GET:/ohs-hub/orgs/{orgId}/occ-medicine
   * @secure
   * @response `200` `GetOccupationalMedicineInfoData`
   */
  export namespace GetOccupationalMedicineInfo {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      legalEntityId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOccupationalMedicineInfoData;
  }

  /**
   * @description Creates new occupational medicine information for an organization.
   * @tags OHS Hub - Organization Management
   * @name CreateOccupationalMedicineInfo
   * @summary Create occupational medicine info
   * @request POST:/ohs-hub/orgs/{orgId}/occ-medicine
   * @secure
   * @response `201` `CreateOccupationalMedicineInfoData`
   */
  export namespace CreateOccupationalMedicineInfo {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateOrganizationOccupationalMedicineInfoDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateOccupationalMedicineInfoData;
  }

  /**
   * @description Updates the occupational medicine information for an organization.
   * @tags OHS Hub - Organization Management
   * @name UpdateOccupationalMedicineInfo
   * @summary Update occupational medicine info
   * @request PUT:/ohs-hub/orgs/{orgId}/occ-medicine/{id}
   * @secure
   * @response `200` `UpdateOccupationalMedicineInfoData`
   */
  export namespace UpdateOccupationalMedicineInfo {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateOrganizationOccupationalMedicineInfoDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateOccupationalMedicineInfoData;
  }

  /**
   * @description Enables or disables email notifications for occupational medicine information.
   * @tags OHS Hub - Organization Management
   * @name ToggleEmailSending
   * @summary Toggle email notifications
   * @request PUT:/ohs-hub/orgs/{orgId}/occ-medicine/{id}/toggle-email
   * @secure
   * @response `200` `ToggleEmailSendingData`
   */
  export namespace ToggleEmailSending {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ToggleEmailSendingData;
  }
}

export namespace PreventionRegister {
  /**
   * @description Evaluates all prevention rules for an organization and creates assignments and notices for matching rules. If an assignment already exists with no notice, a notice will be created.
   * @tags OHS Hub - Prevention
   * @name EvaluateRulesForOrg
   * @summary Evaluate prevention rules
   * @request POST:/prevention-register/generate/{orgId}
   * @secure
   * @response `201` `EvaluateRulesForOrgData`
   */
  export namespace EvaluateRulesForOrg {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EvaluateRulesForOrgData;
  }

  /**
   * @description Processes all pending prevention notices for an organization. Processing a notice will send it to the employee. Can be run in dry-run mode to preview changes.
   * @tags OHS Hub - Prevention
   * @name ProcessNoticesByOrganization
   * @summary Process pending notices
   * @request POST:/prevention-register/process/organization/{orgId}
   * @secure
   * @response `201` `ProcessNoticesByOrganizationData`
   */
  export namespace ProcessNoticesByOrganization {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      dryRun: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessNoticesByOrganizationData;
  }

  /**
   * @description Processes a single prevention notice. Can be run in dry-run mode to preview changes.
   * @tags OHS Hub - Prevention
   * @name ProcessNotice
   * @summary Process single notice
   * @request POST:/prevention-register/notices/{id}/process
   * @secure
   * @response `201` `ProcessNoticeData`
   */
  export namespace ProcessNotice {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessNoticeData;
  }

  /**
   * @description Updates the prevention status for all assignments in an organization.
   * @tags OHS Hub - Prevention
   * @name UpdateStatusForOrg
   * @summary Update prevention status
   * @request POST:/prevention-register/update-status/{orgId}
   * @secure
   * @response `201` `UpdateStatusForOrgData`
   */
  export namespace UpdateStatusForOrg {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateStatusForOrgData;
  }

  /**
   * No description
   * @tags OHS Hub - Prevention
   * @name ProcessNoticesForSingleOrg
   * @summary Process prevention notices for a single organization
   * @request POST:/prevention-register/notices/process/{orgId}
   * @secure
   * @response `200` `ProcessNoticesForSingleOrgData` Successfully processed notices for organization
   * @response `201` `ProcessSingleOrgResultDto`
   */
  export namespace ProcessNoticesForSingleOrg {
    export type RequestParams = {
      /** Organization ID to process notices for */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessNoticesForSingleOrgData;
  }

  /**
   * No description
   * @tags OHS Hub - Prevention
   * @name ProcessNoticesForAllOrgs
   * @summary Process prevention notices for all organizations
   * @request POST:/prevention-register/notices/process-all/{orgId}
   * @secure
   * @response `200` `ProcessNoticesForAllOrgsData` Successfully processed notices for all organizations
   * @response `201` `ProcessNoticesResultDto`
   */
  export namespace ProcessNoticesForAllOrgs {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessNoticesForAllOrgsData;
  }

  /**
   * @description Processes mandatory prevention reminder emails for assignments approaching their due dates.
   * @tags OHS Hub - Prevention
   * @name ProcessMandatoryEmailsForSingleOrg
   * @summary Process mandatory prevention emails for a single organization
   * @request POST:/prevention-register/mandatory/process/{orgId}
   * @secure
   * @response `200` `ProcessMandatoryEmailsForSingleOrgData` Successfully processed mandatory emails for organization
   * @response `201` `object`
   */
  export namespace ProcessMandatoryEmailsForSingleOrg {
    export type RequestParams = {
      /** Organization ID to process mandatory emails for */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessMandatoryEmailsForSingleOrgData;
  }

  /**
   * @description Processes mandatory prevention reminder emails for all organizations with assignments approaching their due dates.
   * @tags OHS Hub - Prevention
   * @name ProcessMandatoryEmailsForAllOrgs
   * @summary Process mandatory prevention emails for all organizations
   * @request POST:/prevention-register/mandatory/process-all/{orgId}
   * @secure
   * @response `200` `ProcessMandatoryEmailsForAllOrgsData` Successfully processed mandatory emails for all organizations
   * @response `201` `object`
   */
  export namespace ProcessMandatoryEmailsForAllOrgs {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessMandatoryEmailsForAllOrgsData;
  }

  /**
   * @description Unified endpoint that processes both offer and mandatory prevention emails for a specific organization.
   * @tags OHS Hub - Prevention
   * @name ProcessPreventionEmailsUnifiedSingleOrg
   * @summary 🚀 Process ALL prevention emails (offer + mandatory) for a single organization
   * @request POST:/prevention-register/unified/process/{orgId}
   * @secure
   * @response `200` `ProcessPreventionEmailsUnifiedSingleOrgData` Successfully processed prevention emails for organization
   * @response `201` `object`
   */
  export namespace ProcessPreventionEmailsUnifiedSingleOrg {
    export type RequestParams = {
      /** Organization ID to process */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessPreventionEmailsUnifiedSingleOrgData;
  }

  /**
   * @description Unified endpoint that processes both offer and mandatory prevention emails for all organizations. This is the main production job that runs daily.
   * @tags OHS Hub - Prevention
   * @name ProcessAllPreventionEmailsUnified
   * @summary 🚀 Process ALL prevention emails (offer + mandatory) for all organizations
   * @request POST:/prevention-register/unified/process-all/{orgId}
   * @secure
   * @response `200` `ProcessAllPreventionEmailsUnifiedData` Successfully processed all prevention emails for all organizations
   * @response `201` `object`
   */
  export namespace ProcessAllPreventionEmailsUnified {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {
      /** Whether to perform a dry run (default: true) */
      dryRun?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessAllPreventionEmailsUnifiedData;
  }

  /**
   * @description Sends a test message to the configured Slack channel to verify webhook integration.
   * @tags OHS Hub - Prevention
   * @name TestSlackIntegration
   * @summary 🧪 Test Slack integration
   * @request POST:/prevention-register/unified/test-slack/{orgId}
   * @secure
   * @response `200` `TestSlackIntegrationData` Slack test result
   * @response `201` `void`
   */
  export namespace TestSlackIntegration {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TestSlackIntegrationData;
  }

  /**
   * @description Send test mandatory prevention emails to a specified email address. Supports sending specific email types or all types at once. This endpoint uses real email delivery for end-to-end testing.
   * @tags OHS Hub - Prevention
   * @name SendTestMandatoryPreventionEmail
   * @summary 🧪 Test mandatory prevention email sending
   * @request POST:/prevention-register/mandatory-prevention/test-email/{orgId}
   * @secure
   * @response `200` `SendTestMandatoryPreventionEmailData` Test emails sent successfully
   * @response `201` `object`
   */
  export namespace SendTestMandatoryPreventionEmail {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SendTestMandatoryPreventionEmailDto;
    export type RequestHeaders = {};
    export type ResponseBody = SendTestMandatoryPreventionEmailData;
  }

  /**
   * @description Send a test offer prevention email to a specified email address. Uses real org data if available, otherwise mock data.
   * @tags OHS Hub - Prevention
   * @name SendTestOfferPreventionEmail
   * @summary Send test offer prevention email
   * @request POST:/prevention-register/offer-prevention/test-email/{orgId}
   * @secure
   * @response `200` `SendTestOfferPreventionEmailData` Test offer email sent successfully
   * @response `201` `object`
   */
  export namespace SendTestOfferPreventionEmail {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SendTestOfferPreventionEmailDto;
    export type RequestHeaders = {};
    export type ResponseBody = SendTestOfferPreventionEmailData;
  }
}

export namespace PreventionNotices {
  /**
   * @description Retrieves a specific prevention notice by its ID.
   * @tags Prevention Notices
   * @name FindById
   * @summary Get notice by ID
   * @request GET:/prevention-notices/orgs/{orgId}/{id}
   * @secure
   * @response `200` `FindByIdData` The prevention notice was found
   * @response `404` `void` The prevention notice was not found
   */
  export namespace FindById {
    export type RequestParams = {
      /** The ID of the prevention notice */
      id: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindByIdData;
  }

  /**
   * @description Updates the properties of a prevention notice.
   * @tags Prevention Notices
   * @name Update
   * @summary Update notice
   * @request PATCH:/prevention-notices/orgs/{orgId}/{id}
   * @secure
   * @response `200` `UpdateResult` The prevention notice was updated
   * @response `404` `void` The prevention notice was not found
   */
  export namespace Update {
    export type RequestParams = {
      /** The ID of the prevention notice */
      id: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdatePreventionNoticeDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateResult;
  }

  /**
   * @description Retrieves all prevention notices for a specific employee.
   * @tags Prevention Notices
   * @name FindByEmployeeId
   * @summary Get employee notices
   * @request GET:/prevention-notices/orgs/{orgId}/employee/{employeeId}
   * @secure
   * @response `200` `FindByEmployeeIdData` List of prevention notices
   */
  export namespace FindByEmployeeId {
    export type RequestParams = {
      /** The ID of the employee */
      employeeId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindByEmployeeIdData;
  }

  /**
   * @description Processes a single prevention notice. Can be run in dry-run mode to preview changes.
   * @tags Prevention Notices
   * @name ProcessNotice
   * @summary Process notice
   * @request POST:/prevention-notices/orgs/{orgId}/{id}/process
   * @secure
   * @response `200` `ProcessNoticeResult` The notice was processed
   * @response `201` `ProcessSingleResultDto`
   * @response `404` `void` The notice was not found
   */
  export namespace ProcessNotice {
    export type RequestParams = {
      /** The ID of the prevention notice */
      id: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {
      /** If true, will not send emails or update records */
      dryRun?: any;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessNoticeResult;
  }
}

export namespace KomboIntegration {
  /**
   * No description
   * @tags Kombo Integration
   * @name SyncById
   * @request GET:/kombo-integration/sync/{orgId}
   * @secure
   * @response `200` `SyncByIdData` Full synchronization completed successfully.
   * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
   * @response `500` `ApiErrorResponseDto` Internal server error during synchronization.
   */
  export namespace SyncById {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SyncByIdData;
  }

  /**
   * No description
   * @tags Kombo Integration
   * @name ProcessById
   * @request GET:/kombo-integration/process/{orgId}
   * @secure
   * @response `200` `ProcessByIdData` Domain entity processing completed successfully.
   * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
   * @response `500` `ApiErrorResponseDto` Internal server error during processing.
   */
  export namespace ProcessById {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ProcessByIdData;
  }

  /**
   * No description
   * @tags Kombo Integration
   * @name IngestById
   * @request GET:/kombo-integration/ingest/{orgId}
   * @secure
   * @response `200` `IngestByIdData` Data ingestion completed successfully.
   * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
   * @response `500` `ApiErrorResponseDto` Internal server error during ingestion.
   */
  export namespace IngestById {
    export type RequestParams = {
      /** UUID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = IngestByIdData;
  }

  /**
   * No description
   * @tags Kombo Integration
   * @name TriggerDailySync
   * @summary Trigger daily sync manually
   * @request POST:/kombo-integration/sync/daily/{orgId}
   * @secure
   * @response `200` `TriggerDailySyncData` Daily sync completed successfully
   * @response `201` `void`
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin role
   * @response `500` `void` Internal server error
   */
  export namespace TriggerDailySync {
    export type RequestParams = {
      /** Organization ID (required for authentication) */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TriggerDailySyncData;
  }
}

export namespace HumanResources {
  /**
   * @description Retrieves all groups, legal entities, and work locations for an organization. Use this for populating dropdown filters in the UI.
   * @tags OHS Hub - HR
   * @name GetOrganizationOptions
   * @summary Get organization options for dropdowns
   * @request GET:/human-resources/orgs/{orgId}/admin/options
   * @secure
   * @response `200` `GetOrganizationOptionsData` Organization options retrieved successfully
   * @response `404` `void` Organization not found
   */
  export namespace GetOrganizationOptions {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOrganizationOptionsData;
  }

  /**
   * @description Retrieves all groups, kombo staginglegal entities, and kombo staging work locations and kombo staging employees for an organization. Use this for populating dropdown filters in the UI. Currently used on updateKomboExclusions
   * @tags OHS Hub - HR
   * @name GetOrganizationOptionsKombo
   * @summary Get organization kombo staging options for dropdowns
   * @request GET:/human-resources/orgs/{orgId}/admin/options/kombo
   * @secure
   * @response `200` `GetOrganizationOptionsKomboData` Organization kombo staging options retrieved successfully
   * @response `404` `void` Organization not found
   */
  export namespace GetOrganizationOptionsKombo {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOrganizationOptionsKomboData;
  }

  /**
   * @description Creates a new employee for an organization without requiring HRI integration. A unique komboId is generated automatically.
   * @tags OHS Hub - HR
   * @name CreateEmployee
   * @summary Create a new employee manually
   * @request POST:/human-resources/orgs/{orgId}/employees
   * @secure
   * @response `201` `CreateEmployeeData` The employee has been successfully created
   * @response `400` `void` Invalid input data
   * @response `404` `void` Legal entity, work location, or group not found
   */
  export namespace CreateEmployee {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ManualCreateEmployeeDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateEmployeeData;
  }

  /**
   * @description Creates a new legal entity for an organization. The komboId is required and must be unique within the organization.
   * @tags OHS Hub - HR
   * @name CreateLegalEntity
   * @summary Create a new legal entity
   * @request POST:/human-resources/orgs/{orgId}/legal-entities
   * @secure
   * @response `201` `CreateLegalEntityData` The legal entity has been successfully created
   * @response `400` `void` Invalid input data
   * @response `404` `void` Organization not found
   */
  export namespace CreateLegalEntity {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateLegalEntityDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateLegalEntityData;
  }

  /**
   * @description Creates a new work location for an organization. The komboId is required and must be unique within the organization.
   * @tags OHS Hub - HR
   * @name CreateWorkLocation
   * @summary Create a new work location
   * @request POST:/human-resources/orgs/{orgId}/work-locations
   * @secure
   * @response `201` `CreateWorkLocationData` The work location has been successfully created
   * @response `400` `void` Invalid input data
   * @response `404` `void` Organization not found
   */
  export namespace CreateWorkLocation {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateWorkLocationDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateWorkLocationData;
  }

  /**
   * @description Assigns an existing employee to a legal entity and/or work location. Both legalEntityId and workLocationId are optional.
   * @tags OHS Hub - HR
   * @name AssignEmployee
   * @summary Assign employee to legal entity and/or work location
   * @request POST:/human-resources/orgs/{orgId}/admin/employees/{employeeId}/assign
   * @secure
   * @response `200` `AssignEmployeeData` The employee has been successfully assigned
   * @response `201` `Employee`
   * @response `400` `void` Invalid input data
   * @response `404` `void` Employee, legal entity, or work location not found
   */
  export namespace AssignEmployee {
    export type RequestParams = {
      /** The ID of the employee */
      employeeId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AssignEmployeeData;
  }

  /**
   * @description Updates the note field for a specific employee. Input is sanitized to prevent XSS attacks.
   * @tags OHS Hub - HR
   * @name UpdateNoteForEmployee
   * @summary Update employee note
   * @request POST:/human-resources/orgs/{orgId}/update-note/{employeeId}
   * @secure
   * @response `200` `UpdateNoteForEmployeeData` The employee note was updated
   * @response `201` `Employee`
   * @response `400` `void` Invalid input data
   * @response `404` `void` The employee was not found
   */
  export namespace UpdateNoteForEmployee {
    export type RequestParams = {
      /** The ID of the employee */
      employeeId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateEmployeeNoteDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateNoteForEmployeeData;
  }
}

export namespace ActivityLogs {
  /**
   * No description
   * @tags Activity Logs
   * @name GetAllLogs
   * @request GET:/activity-logs
   * @secure
   * @response `200` `GetAllLogsData` Successfully retrieved enriched activity logs. When aggregated=true, returns only aggregated logs.
   */
  export namespace GetAllLogs {
    export type RequestParams = {};
    export type RequestQuery = {
      /** When true, returns aggregated logs with individual maternity, mental health, and first aid logs */
      aggregated?: boolean;
      /** End date for filtering (ISO 8601 format) */
      endDate?: string;
      /** Filter logs by specific entity ID */
      entityId?: string;
      /** Filter logs by entity type (e.g., mh_risk_assessment) */
      entityType?: GetAllLogsParams1EntityTypeEnum;
      /** Filter logs by multiple entity types (comma-separated) */
      entityTypes?: string[];
      /** Organization ID to filter logs by */
      organizationId: string;
      /** Start date for filtering (ISO 8601 format) */
      startDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllLogsData;
  }

  /**
   * No description
   * @tags Activity Logs
   * @name GetLogsByEmployee
   * @request GET:/activity-logs/employee/{employeeId}
   * @secure
   * @response `200` `GetLogsByEmployeeData` Successfully retrieved activity logs for employee.
   */
  export namespace GetLogsByEmployee {
    export type RequestParams = {
      employeeId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetLogsByEmployeeData;
  }

  /**
   * No description
   * @tags Activity Logs
   * @name GetPreventionDetailLogs
   * @request GET:/activity-logs/prevention-detail
   * @secure
   * @response `200` `GetPreventionDetailLogsData` Successfully retrieved prevention detail logs for a specific prevention assignment and employee.
   */
  export namespace GetPreventionDetailLogs {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Prevention assignment ID (prevention detail id) */
      assignmentId: string;
      /** Employee ID to filter logs by */
      employeeId: string;
      /** Organization ID to filter logs by */
      organizationId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetPreventionDetailLogsData;
  }

  /**
   * No description
   * @tags Activity Logs
   * @name GetMentalHealthRiskAssessmentLogs
   * @request GET:/activity-logs/mh-risk-assessment
   * @secure
   * @response `200` `GetMentalHealthRiskAssessmentLogsData` Successfully retrieved mental health risk assessment logs.
   */
  export namespace GetMentalHealthRiskAssessmentLogs {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Organization ID to filter logs by */
      organizationId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetMentalHealthRiskAssessmentLogsData;
  }

  /**
   * No description
   * @tags Activity Logs
   * @name CreateAdminManualActivityLog
   * @request POST:/activity-logs/manual
   * @secure
   * @response `200` `CreateAdminManualActivityLogData` Successfully created activity log.
   * @response `201` `void`
   */
  export namespace CreateAdminManualActivityLog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateManualActivityLogAdminDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateAdminManualActivityLogData;
  }
}

export namespace MaternityRiskAssessments {
  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name ListNotifications
   * @summary List all maternity notifications for an organization
   * @request GET:/maternity-risk-assessments/{orgId}/notifications
   * @secure
   * @response `200` `ListNotificationsData`
   */
  export namespace ListNotifications {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      /** Filter by end date (YYYY-MM-DD) */
      endDate?: string;
      /** Filter by start date (YYYY-MM-DD) */
      startDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListNotificationsData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name CreateNotification
   * @summary Create a new maternity notification
   * @request POST:/maternity-risk-assessments/{orgId}/notifications
   * @secure
   * @response `201` `CreateNotificationData`
   */
  export namespace CreateNotification {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateMaternityNotificationDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateNotificationData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name GetNotification
   * @summary Get a specific maternity notification
   * @request GET:/maternity-risk-assessments/{orgId}/notifications/{id}
   * @secure
   * @response `200` `GetNotificationData`
   */
  export namespace GetNotification {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetNotificationData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name UpdateNotification
   * @summary Update a maternity notification
   * @request PUT:/maternity-risk-assessments/{orgId}/notifications/{id}
   * @secure
   * @response `200` `UpdateNotificationData`
   */
  export namespace UpdateNotification {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateMaternityNotificationDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateNotificationData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name DeleteNotification
   * @summary Delete a maternity notification
   * @request DELETE:/maternity-risk-assessments/{orgId}/notifications/{id}
   * @secure
   * @response `200` `DeleteNotificationData`
   * @response `204` `void`
   */
  export namespace DeleteNotification {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteNotificationData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name GetNotificationsByEmployee
   * @summary Get all maternity notifications for a specific employee
   * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}
   * @secure
   * @response `200` `GetNotificationsByEmployeeData`
   */
  export namespace GetNotificationsByEmployee {
    export type RequestParams = {
      employeeId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetNotificationsByEmployeeData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name GetLatestNotificationByEmployee
   * @summary Get the latest maternity notification for a specific employee
   * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}/latest
   * @secure
   * @response `200` `GetLatestNotificationByEmployeeData`
   */
  export namespace GetLatestNotificationByEmployee {
    export type RequestParams = {
      employeeId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetLatestNotificationByEmployeeData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name GetEmployeeMaternityStatus
   * @summary Get maternity status for a specific employee
   * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}/maternity-status
   * @secure
   * @response `200` `GetEmployeeMaternityStatusData` Returns maternity status including active notification and assessment status
   */
  export namespace GetEmployeeMaternityStatus {
    export type RequestParams = {
      employeeId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetEmployeeMaternityStatusData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Notifications
   * @name GetNotificationCounts
   * @summary Get notification statistics for the organization
   * @request GET:/maternity-risk-assessments/{orgId}/notifications/statistics/counts
   * @secure
   * @response `200` `GetNotificationCountsData` Returns notification counts including total, active, and completed
   */
  export namespace GetNotificationCounts {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetNotificationCountsData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name CreateAssessment
   * @summary Create a new maternity risk assessment
   * @request POST:/maternity-risk-assessments/{orgId}/assessments
   * @secure
   * @response `201` `CreateAssessmentData`
   */
  export namespace CreateAssessment {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateMaternityRiskAssessmentDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateAssessmentData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name ListAssessments
   * @summary List all maternity risk assessments for an organization
   * @request GET:/maternity-risk-assessments/{orgId}/assessments
   * @secure
   * @response `200` `ListAssessmentsData`
   */
  export namespace ListAssessments {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      /** Filter by completion status */
      completed?: boolean;
      /** Filter by assessment status */
      status?: AssessmentStatus;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListAssessmentsData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name GetAssessmentStatistics
   * @summary Get assessment statistics for the organization
   * @request GET:/maternity-risk-assessments/{orgId}/assessments/statistics
   * @secure
   * @response `200` `GetAssessmentStatisticsData` Returns assessment statistics including counts and completion rates
   */
  export namespace GetAssessmentStatistics {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssessmentStatisticsData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name GetAssessmentTimeline
   * @summary Get assessments completed within a date range
   * @request GET:/maternity-risk-assessments/{orgId}/assessments/timeline
   * @secure
   * @response `200` `GetAssessmentTimelineData`
   */
  export namespace GetAssessmentTimeline {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      /** End date (YYYY-MM-DD) */
      endDate: string;
      /** Start date (YYYY-MM-DD) */
      startDate: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssessmentTimelineData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name GetAssessment
   * @summary Get a specific maternity risk assessment
   * @request GET:/maternity-risk-assessments/{orgId}/assessments/{id}
   * @secure
   * @response `200` `GetAssessmentData`
   */
  export namespace GetAssessment {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssessmentData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name UpdateAssessment
   * @summary Update a maternity risk assessment
   * @request PUT:/maternity-risk-assessments/{orgId}/assessments/{id}
   * @secure
   * @response `200` `UpdateAssessmentData`
   */
  export namespace UpdateAssessment {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateMaternityRiskAssessmentDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateAssessmentData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name DeleteAssessment
   * @summary Delete a maternity risk assessment
   * @request DELETE:/maternity-risk-assessments/{orgId}/assessments/{id}
   * @secure
   * @response `200` `DeleteAssessmentData`
   * @response `204` `void`
   */
  export namespace DeleteAssessment {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteAssessmentData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name GetAssessmentWithDetails
   * @summary Get a maternity risk assessment with full details
   * @request GET:/maternity-risk-assessments/{orgId}/assessments/{id}/details
   * @secure
   * @response `200` `GetAssessmentWithDetailsData`
   */
  export namespace GetAssessmentWithDetails {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssessmentWithDetailsData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name UpdateAssessmentStatus
   * @summary Update assessment status
   * @request PUT:/maternity-risk-assessments/{orgId}/assessments/{id}/status
   * @secure
   * @response `200` `UpdateAssessmentStatusData`
   */
  export namespace UpdateAssessmentStatus {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateAssessmentStatusData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Assessments
   * @name GetAssessmentsByEmployee
   * @summary Get all assessments for a specific employee
   * @request GET:/maternity-risk-assessments/{orgId}/assessments/employees/{employeeId}
   * @secure
   * @response `200` `GetAssessmentsByEmployeeData`
   */
  export namespace GetAssessmentsByEmployee {
    export type RequestParams = {
      employeeId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAssessmentsByEmployeeData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Questionnaire
   * @name GetQuestionnaire
   * @summary Get the maternity questionnaire template
   * @request GET:/maternity-risk-assessments/{orgId}/questionnaire
   * @secure
   * @response `200` `GetQuestionnaireData`
   */
  export namespace GetQuestionnaire {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetQuestionnaireData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Questionnaire
   * @name SubmitQuestionnaire
   * @summary Submit questionnaire responses for an assessment
   * @request POST:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
   * @secure
   * @response `201` `SubmitQuestionnaireData`
   */
  export namespace SubmitQuestionnaire {
    export type RequestParams = {
      assessmentId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitQuestionnaireResponseDto;
    export type RequestHeaders = {};
    export type ResponseBody = SubmitQuestionnaireData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Questionnaire
   * @name UpdateQuestionnaire
   * @summary Update questionnaire responses for an assessment
   * @request PUT:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
   * @secure
   * @response `200` `UpdateQuestionnaireData`
   */
  export namespace UpdateQuestionnaire {
    export type RequestParams = {
      assessmentId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateQuestionnaireResponseDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateQuestionnaireData;
  }

  /**
   * No description
   * @tags Maternity Risk Assessment - Questionnaire
   * @name GetQuestionnaireResponse
   * @summary Get questionnaire responses for an assessment
   * @request GET:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
   * @secure
   * @response `200` `GetQuestionnaireResponseData`
   */
  export namespace GetQuestionnaireResponse {
    export type RequestParams = {
      assessmentId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetQuestionnaireResponseData;
  }
}

export namespace Instructions {
  /**
   * No description
   * @tags OHS Hub - Instructions (Public)
   * @name ValidateToken
   * @summary Validate an instruction access token for a given assignment
   * @request GET:/instructions/access/{assignmentId}
   * @response `200` `ValidateTokenData`
   * @response `401` `void` Missing or invalid Authorization header
   * @response `404` `void` Assignment not found or token invalid
   */
  export namespace ValidateToken {
    export type RequestParams = {
      assignmentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /** Bearer <access-token> */
      Authorization: string;
      authorization: string;
    };
    export type ResponseBody = ValidateTokenData;
  }

  /**
   * No description
   * @tags OHS Hub - Instructions (Public)
   * @name SubmitQuiz
   * @summary Submit answers for an instruction quiz
   * @request POST:/instructions/access/{assignmentId}/quiz/submit
   * @response `200` `SubmitQuizData`
   * @response `401` `void` Missing or invalid Authorization header
   * @response `404` `void` Assignment not found or token invalid
   */
  export namespace SubmitQuiz {
    export type RequestParams = {
      assignmentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = QuizSubmitDto;
    export type RequestHeaders = {
      /** Bearer <access-token> */
      Authorization: string;
      authorization: string;
    };
    export type ResponseBody = SubmitQuizData;
  }
}

export namespace InstructionTopics {
  /**
   * No description
   * @tags OHS Hub - Instructions
   * @name FindAll
   * @summary List all instruction topics for an organization
   * @request GET:/instruction-topics/{orgId}
   * @secure
   * @response `200` `FindAllResult`
   */
  export namespace FindAll {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindAllResult;
  }

  /**
   * No description
   * @tags OHS Hub - Instructions
   * @name FindOne
   * @summary Get an instruction topic by ID
   * @request GET:/instruction-topics/{orgId}/{id}
   * @secure
   * @response `200` `FindOneResult`
   */
  export namespace FindOne {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindOneResult;
  }
}

export namespace InstructionAssignments {
  /**
   * No description
   * @tags OHS Hub - Instructions
   * @name FindAll
   * @summary List instruction assignments for an organization
   * @request GET:/instruction-assignments/{orgId}
   * @secure
   * @response `200` `FindAllOutput`
   */
  export namespace FindAll {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      /** @format uuid */
      employeeId?: string;
      /** @format uuid */
      instructionTopicId?: string;
      status?: FindAllParams3StatusEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindAllOutput;
  }

  /**
   * No description
   * @tags OHS Hub - Instructions
   * @name FindOne
   * @summary Get an instruction assignment by ID
   * @request GET:/instruction-assignments/{orgId}/{id}
   * @secure
   * @response `200` `FindOneOutput`
   */
  export namespace FindOne {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindOneOutput;
  }

  /**
   * No description
   * @tags OHS Hub - Instructions
   * @name UpdateDueDate
   * @summary Update the due date of an instruction assignment
   * @request PATCH:/instruction-assignments/{orgId}/{id}/due-date
   * @secure
   * @response `200` `UpdateDueDateData`
   */
  export namespace UpdateDueDate {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateInstructionAssignmentDueDateDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateDueDateData;
  }
}

export namespace PreventionCompletions {
  /**
   * No description
   * @tags Prevention Completions
   * @name GetCompletionsByAssignment
   * @summary Get all completions for an assignment
   * @request GET:/prevention-completions/orgs/{orgId}/assignment/{assignmentId}
   * @secure
   * @response `200` `GetCompletionsByAssignmentData` Prevention completions retrieved successfully
   */
  export namespace GetCompletionsByAssignment {
    export type RequestParams = {
      /** The ID of the assignment */
      assignmentId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetCompletionsByAssignmentData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name GetLatestCompletion
   * @summary Get the latest completion for an assignment
   * @request GET:/prevention-completions/orgs/{orgId}/assignment/{assignmentId}/latest
   * @secure
   * @response `200` `GetLatestCompletionData` Latest prevention completion retrieved successfully (or null if none found)
   */
  export namespace GetLatestCompletion {
    export type RequestParams = {
      /** The ID of the assignment */
      assignmentId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetLatestCompletionData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name CreateCompletion
   * @summary Create a new prevention completion
   * @request POST:/prevention-completions/orgs/{orgId}
   * @secure
   * @response `201` `CreateCompletionData` Prevention completion created successfully
   * @response `400` `void` Invalid input data
   * @response `404` `void` Prevention assignment not found
   */
  export namespace CreateCompletion {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreatePreventionCompletionDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateCompletionData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name GetReceiptSummary
   * @summary Get receipt document summary for a completion
   * @request GET:/prevention-completions/orgs/{orgId}/{completionId}/receipt/summary
   * @secure
   * @response `200` `GetReceiptSummaryData` Receipt document summary retrieved successfully
   * @response `404` `void` Prevention completion not found
   */
  export namespace GetReceiptSummary {
    export type RequestParams = {
      /** The ID of the prevention completion */
      completionId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetReceiptSummaryData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name GetReceipt
   * @summary Get receipt document for a completion
   * @request GET:/prevention-completions/orgs/{orgId}/{completionId}/receipt
   * @secure
   * @response `200` `GetReceiptData` Receipt document download URL retrieved successfully (or null if no receipt found)
   * @response `404` `void` Prevention completion not found
   */
  export namespace GetReceipt {
    export type RequestParams = {
      /** The ID of the prevention completion */
      completionId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetReceiptData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name DeleteReceipt
   * @summary Delete receipt document for a completion
   * @request DELETE:/prevention-completions/orgs/{orgId}/{completionId}/receipt
   * @secure
   * @response `204` `DeleteReceiptData` Receipt document deleted successfully
   * @response `404` `void` Prevention completion or receipt document not found
   */
  export namespace DeleteReceipt {
    export type RequestParams = {
      /** The ID of the prevention completion */
      completionId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteReceiptData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name UpdateCompletion
   * @summary Update an existing prevention completion
   * @request PUT:/prevention-completions/orgs/{orgId}/{completionId}
   * @secure
   * @response `200` `UpdateCompletionData` Prevention completion updated successfully
   * @response `400` `void` Invalid input data
   * @response `404` `void` Prevention completion not found
   */
  export namespace UpdateCompletion {
    export type RequestParams = {
      /** The ID of the prevention completion */
      completionId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdatePreventionCompletionDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateCompletionData;
  }

  /**
   * No description
   * @tags Prevention Completions
   * @name DeleteCompletion
   * @summary Delete a prevention completion
   * @request DELETE:/prevention-completions/orgs/{orgId}/{completionId}
   * @secure
   * @response `204` `DeleteCompletionData` Prevention completion deleted successfully
   * @response `404` `void` Prevention completion not found
   */
  export namespace DeleteCompletion {
    export type RequestParams = {
      /** The ID of the prevention completion */
      completionId: string;
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteCompletionData;
  }
}

export namespace PreventionAssignment {
  /**
   * No description
   * @tags PreventionAssignment
   * @name UpdateDeadline
   * @request POST:/prevention-assignment/orgs/{orgId}/update/deadline
   * @secure
   * @response `201` `UpdateDeadlineData`
   */
  export namespace UpdateDeadline {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdatePreventionAssignmentDeadlineDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateDeadlineData;
  }
}

export namespace PreventionProfiles {
  /**
   * No description
   * @tags PreventionProfile
   * @name CreatePreventionProfile
   * @request POST:/prevention-profiles/orgs/{orgId}/profiles/create
   * @secure
   * @response `201` `CreatePreventionProfileData`
   */
  export namespace CreatePreventionProfile {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreatePreventionProfileDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreatePreventionProfileData;
  }
}

export namespace Documents {
  /**
   * No description
   * @tags Document Management
   * @name RequestUpload
   * @request POST:/documents/orgs/{orgId}/request-upload
   * @secure
   * @response `201` `RequestUploadData`
   */
  export namespace RequestUpload {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = RequestUploadDto;
    export type RequestHeaders = {};
    export type ResponseBody = RequestUploadData;
  }

  /**
   * No description
   * @tags Document Management
   * @name CompleteUpload
   * @request POST:/documents/orgs/{orgId}/documents/{id}/complete
   * @secure
   * @response `200` `CompleteUploadData`
   */
  export namespace CompleteUpload {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CompleteUploadData;
  }

  /**
 * No description
 * @tags Document Management
 * @name GetDownloadUrl
 * @summary SECURE: Generate signed download URL (Recommended for production/medical data)
Returns a time-limited signed URL that expires in 2 minutes
Enhanced with comprehensive security logging and validation
 * @request GET:/documents/orgs/{orgId}/documents/{id}/download-url
 * @secure
 * @response `200` `GetDownloadUrlData`
*/
  export namespace GetDownloadUrl {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetDownloadUrlData;
  }

  /**
   * No description
   * @tags Document Management
   * @name GetDocument
   * @request GET:/documents/orgs/{orgId}/documents/{id}
   * @secure
   * @response `200` `GetDocumentData`
   */
  export namespace GetDocument {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetDocumentData;
  }

  /**
   * No description
   * @tags Document Management
   * @name DeleteDocument
   * @request DELETE:/documents/orgs/{orgId}/documents/{id}
   * @secure
   * @response `204` `DeleteDocumentData`
   */
  export namespace DeleteDocument {
    export type RequestParams = {
      id: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeleteDocumentData;
  }

  /**
   * No description
   * @tags Document Management
   * @name GetDocuments
   * @request GET:/documents/orgs/{orgId}/documents
   * @secure
   * @response `200` `GetDocumentsData`
   */
  export namespace GetDocuments {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {
      entityId: string;
      entityType: string;
      uploaderId: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetDocumentsData;
  }
}

export namespace StressTest {
  /**
   * No description
   * @tags TestResult
   * @name Create
   * @request POST:/stress-test
   * @response `201` `CreateOutput`
   */
  export namespace Create {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTestResultDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateOutput;
  }

  /**
   * No description
   * @tags TestResult
   * @name GetStressLevels
   * @request GET:/stress-test/{user_id}
   * @response `200` `GetStressLevelsData`
   */
  export namespace GetStressLevels {
    export type RequestParams = {
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetStressLevelsData;
  }
}

export namespace Statistics {
  /**
   * No description
   * @tags Statistics
   * @name GetPreventionStatistics
   * @request GET:/statistics/{orgId}/prevention
   * @secure
   * @response `200` `GetPreventionStatisticsData`
   */
  export namespace GetPreventionStatistics {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetPreventionStatisticsData;
  }

  /**
   * No description
   * @tags Statistics
   * @name GetGiniscoreStatistics
   * @request GET:/statistics/{orgId}/giniscore
   * @secure
   * @response `200` `GetGiniscoreStatisticsData`
   */
  export namespace GetGiniscoreStatistics {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetGiniscoreStatisticsData;
  }

  /**
   * No description
   * @tags Statistics
   * @name GetInstructionStatistics
   * @request GET:/statistics/{orgId}/instructions
   * @secure
   * @response `200` `GetInstructionStatisticsData`
   */
  export namespace GetInstructionStatistics {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetInstructionStatisticsData;
  }
}

export namespace Admin {
  /**
   * No description
   * @tags Admin Users
   * @name ChurnUsersByEmail
   * @request PATCH:/admin/users/churn/email
   * @secure
   * @response `200` `ChurnUsersByEmailData`
   */
  export namespace ChurnUsersByEmail {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ChurnUserByEmailDto;
    export type RequestHeaders = {};
    export type ResponseBody = ChurnUsersByEmailData;
  }

  /**
   * No description
   * @tags Admin Users
   * @name CreateUser
   * @request POST:/admin/users
   * @secure
   * @response `201` `CreateUserResult`
   */
  export namespace CreateUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateUserAdminDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserResult;
  }

  /**
   * No description
   * @tags Admin Users
   * @name GenerateUsers
   * @request POST:/admin/users/create
   * @secure
   * @response `201` `GenerateUsersData`
   */
  export namespace GenerateUsers {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTestUsersDto;
    export type RequestHeaders = {};
    export type ResponseBody = GenerateUsersData;
  }

  /**
   * @description Clears the cached data for a specific user. This is useful when user data has been manually updated in the database.
   * @tags Admin Users
   * @name InvalidateUserCache
   * @summary Invalidate cache for a specific user
   * @request DELETE:/admin/users/cache/{userId}
   * @secure
   * @response `200` `InvalidateUserCacheData` User cache invalidated successfully
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin role
   */
  export namespace InvalidateUserCache {
    export type RequestParams = {
      /** The ID of the user whose cache should be invalidated */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InvalidateUserCacheData;
  }

  /**
   * @description Clears the cache for all users. This is useful when multiple user records have been updated in the database.
   * @tags Admin Users
   * @name ClearUserCache
   * @summary Clear the entire user cache
   * @request DELETE:/admin/users/cache
   * @secure
   * @response `200` `ClearUserCacheData` User cache cleared successfully
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin role
   */
  export namespace ClearUserCache {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClearUserCacheData;
  }

  /**
   * @description Retrieves all users associated with a specific organization, including their roles and accessible Legal Entities and Work Locations. Used for admin user management.
   * @tags Admin Users
   * @name GetUsersByOrganization
   * @summary Get all users for an organization
   * @request GET:/admin/users/organizations/{orgId}/admin/users
   * @secure
   * @response `200` `GetUsersByOrganizationData` Users retrieved successfully
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin or ops role
   */
  export namespace GetUsersByOrganization {
    export type RequestParams = {
      /** The ID of the organization */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetUsersByOrganizationData;
  }

  /**
   * @description Assigns Legal Entities and Work Locations to a user for OHS Hub access control. This is primarily used for restricted users to control which employees they can view. The user cache is automatically invalidated after the update.
   * @tags Admin Users
   * @name UpdateUserAccess
   * @summary Update user access to Legal Entities and Work Locations
   * @request PATCH:/admin/users/{userId}/admin/access
   * @secure
   * @response `200` `UpdateUserAccessData` User access updated successfully
   * @response `400` `void` Invalid request - bad UUIDs or entities not found
   * @response `401` `void` Unauthorized - User not authenticated
   * @response `403` `void` Forbidden - User does not have admin role
   * @response `404` `void` User not found
   */
  export namespace UpdateUserAccess {
    export type RequestParams = {
      /** The ID of the user to update access for */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateUserAccessDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateUserAccessData;
  }

  /**
   * No description
   * @tags Orgs
   * @name GetOrgBudgets
   * @summary List every organization with its current budget (admin/ops only)
   * @request GET:/admin/orgs/budgets
   * @secure
   * @response `200` `GetOrgBudgetsData` Successfully retrieved organization budgets.
   */
  export namespace GetOrgBudgets {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOrgBudgetsData;
  }

  /**
   * No description
   * @tags Orgs
   * @name GetAllOrgs
   * @summary List every organization regardless of feature access (admin only)
   * @request GET:/admin/orgs/all
   * @secure
   * @response `200` `GetAllOrgsData` Successfully retrieved all organizations.
   */
  export namespace GetAllOrgs {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetAllOrgsData;
  }

  /**
   * No description
   * @tags Orgs
   * @name UpdateBudget
   * @request PATCH:/admin/orgs/update_budget
   * @secure
   * @response `200` `UpdateBudgetData`
   */
  export namespace UpdateBudget {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateOrgBudgetDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateBudgetData;
  }

  /**
   * No description
   * @tags Orgs
   * @name ChurnOrg
   * @request PATCH:/admin/orgs/churn
   * @secure
   * @response `200` `ChurnOrgData`
   */
  export namespace ChurnOrg {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ChurnOrgDto;
    export type RequestHeaders = {};
    export type ResponseBody = ChurnOrgData;
  }

  /**
   * No description
   * @tags Orgs
   * @name UpdateExclusions
   * @request PATCH:/admin/orgs/update_exclusions
   * @secure
   * @response `200` `UpdateExclusionsResult`
   */
  export namespace UpdateExclusions {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateOrgExclusionsDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateExclusionsResult;
  }

  /**
   * No description
   * @tags Orgs
   * @name UpdateInstructionsAccess
   * @summary Update organization feature access flags
   * @request PATCH:/admin/orgs/instruction-update-access
   * @secure
   * @response `200` `UpdateInstructionsAccessData` Access flags updated successfully
   */
  export namespace UpdateInstructionsAccess {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateOrgAccessDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateInstructionsAccessData;
  }

  /**
   * No description
   * @tags Orgs
   * @name UpdateEapAccess
   * @summary Update organization EAP access flag
   * @request PATCH:/admin/orgs/eap-update-access
   * @secure
   * @response `200` `UpdateEapAccessData` EAP access flag updated successfully
   */
  export namespace UpdateEapAccess {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateOrgEapAccessDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateEapAccessData;
  }

  /**
   * No description
   * @tags Orgs
   * @name UpdateOhsHubAccess
   * @summary Update organization OHS Hub access flag
   * @request PATCH:/admin/orgs/ohs-hub-update-access
   * @secure
   * @response `200` `UpdateOhsHubAccessData` OHS Hub access flag updated successfully
   */
  export namespace UpdateOhsHubAccess {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateOrgOhsHubAccessDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateOhsHubAccessData;
  }

  /**
   * @description Retrieves the existing Kombo integration magic link for an organization if one exists.
   * @tags Orgs
   * @name GetKomboIntegration
   * @summary Get existing Kombo integration link for an organization
   * @request GET:/admin/orgs/{orgId}/kombo-integration
   * @secure
   * @response `200` `GetKomboIntegrationData` Kombo integration link retrieved successfully
   * @response `404` `void` Organization not found or no integration link exists
   */
  export namespace GetKomboIntegration {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetKomboIntegrationData;
  }

  /**
   * @description Creates a connection link for Kombo HRIS integration. The link is stored in the database along with its expiry date.
   * @tags Orgs
   * @name CreateKomboIntegration
   * @summary Create Kombo integration link for an organization
   * @request POST:/admin/orgs/kombo-integration
   * @secure
   * @response `201` `CreateKomboIntegrationData` Kombo integration link created successfully
   * @response `404` `void` Organization not found
   * @response `500` `void` Internal server error
   */
  export namespace CreateKomboIntegration {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateKomboIntegrationDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateKomboIntegrationData;
  }

  /**
   * @description Retrieves all available prevention triggers for dropdown selection
   * @tags Admin - Prevention
   * @name GetPreventionTriggers
   * @summary Get all prevention triggers
   * @request GET:/admin/prevention/triggers
   * @secure
   * @response `200` `GetPreventionTriggersData` Prevention triggers retrieved successfully
   */
  export namespace GetPreventionTriggers {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetPreventionTriggersData;
  }

  /**
   * @description Retrieves all prevention profiles for dropdown selection
   * @tags Admin - Prevention
   * @name GetPreventionProfiles
   * @summary Get prevention profiles for organization
   * @request GET:/admin/prevention/orgs/{orgId}/profiles
   * @secure
   * @response `200` `GetPreventionProfilesData` Prevention profiles retrieved successfully
   */
  export namespace GetPreventionProfiles {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetPreventionProfilesData;
  }

  /**
   * @description Retrieves all prevention rules (profiles) for a specific organization
   * @tags Admin - Prevention
   * @name GetPreventionRules
   * @summary Get prevention rules for organization
   * @request GET:/admin/prevention/rules/{orgId}
   * @secure
   * @response `200` `GetPreventionRulesData` Prevention rules retrieved successfully
   */
  export namespace GetPreventionRules {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetPreventionRulesData;
  }

  /**
   * @description Creates a new prevention rule for an organization
   * @tags Admin - Prevention
   * @name CreatePreventionRule
   * @summary Create prevention rule
   * @request POST:/admin/prevention/rules
   * @secure
   * @response `201` `CreatePreventionRuleData` Prevention rule created successfully
   * @response `400` `void` Invalid input data
   */
  export namespace CreatePreventionRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreatePreventionRuleDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreatePreventionRuleData;
  }

  /**
   * @description Updates an existing prevention rule
   * @tags Admin - Prevention
   * @name UpdatePreventionRule
   * @summary Update prevention rule
   * @request PUT:/admin/prevention/orgs/{orgId}/rules/{id}
   * @secure
   * @response `200` `UpdatePreventionRuleData` Prevention rule updated successfully
   * @response `400` `void` Invalid input data
   * @response `404` `void` Prevention rule not found
   */
  export namespace UpdatePreventionRule {
    export type RequestParams = {
      /** Prevention rule ID */
      id: string;
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdatePreventionRuleDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdatePreventionRuleData;
  }

  /**
   * @description Deactivates a prevention rule (soft delete)
   * @tags Admin - Prevention
   * @name DeletePreventionRule
   * @summary Delete prevention rule
   * @request DELETE:/admin/prevention/orgs/{orgId}/rules/{id}
   * @secure
   * @response `200` `DeletePreventionRuleData` Prevention rule deleted successfully
   * @response `404` `void` Prevention rule not found
   */
  export namespace DeletePreventionRule {
    export type RequestParams = {
      /** Prevention rule ID */
      id: string;
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeletePreventionRuleData;
  }

  /**
   * @description Retrieves employees with their current prevention assignments including cycles, notices, and completions
   * @tags Admin - Prevention
   * @name GetEmployeesWithPreventionStatus
   * @summary Get employees with prevention status
   * @request GET:/admin/prevention/employees/{orgId}
   * @secure
   * @response `200` `GetEmployeesWithPreventionStatusData` Employees with prevention status retrieved successfully
   * @response `404` `void` Organization not found
   */
  export namespace GetEmployeesWithPreventionStatus {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetEmployeesWithPreventionStatusData;
  }

  /**
   * @description Creates a new prevention trigger, profile with employee-targeting rules, and assigns to specified employees. This endpoint follows production logic for testing purposes in staging environment.
   * @tags Admin - Prevention
   * @name CreatePreventionWithProfile
   * @summary Create prevention trigger, profile and assignments
   * @request POST:/admin/prevention/create-with-profile
   * @secure
   * @response `201` `CreatePreventionWithProfileData` Prevention trigger, profile and assignments created successfully
   * @response `400` `void` Invalid input data or validation failed
   * @response `404` `void` Organization or employees not found
   */
  export namespace CreatePreventionWithProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreatePreventionWithProfileDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreatePreventionWithProfileData;
  }

  /**
   * @description Allows admins to override prevention assignment deadlines without validation for testing purposes. This endpoint bypasses all restrictions including past date checks and email notice order validation.
   * @tags Admin - Prevention
   * @name AdminDeadlineOverride
   * @summary Admin-only deadline override
   * @request POST:/admin/prevention/orgs/{orgId}/update/deadline-admin
   * @secure
   * @response `200` `AdminDeadlineOverrideData` Deadline updated successfully (admin override)
   * @response `201` `PreventionAssignment`
   * @response `404` `void` Prevention assignment not found
   */
  export namespace AdminDeadlineOverride {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AdminDeadlineOverrideDto;
    export type RequestHeaders = {};
    export type ResponseBody = AdminDeadlineOverrideData;
  }

  /**
   * @description Retrieves active instruction topics for admin dropdown selection
   * @tags Admin - Instructions
   * @name GetInstructionTopics
   * @summary Get instruction topics for organization
   * @request GET:/admin/instructions/orgs/{orgId}/topics
   * @secure
   * @response `200` `GetInstructionTopicsData` Instruction topics retrieved successfully
   */
  export namespace GetInstructionTopics {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetInstructionTopicsData;
  }

  /**
   * @description Creates missing instruction topics for all currently available instruction content keys in this organization.
   * @tags Admin - Instructions
   * @name BootstrapInstructionTopics
   * @summary Bootstrap instruction topics from available content keys
   * @request POST:/admin/instructions/orgs/{orgId}/topics/bootstrap
   * @secure
   * @response `201` `BootstrapInstructionTopicsData` Missing instruction topics were created successfully
   * @response `404` `void` Organization not found
   */
  export namespace BootstrapInstructionTopics {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BootstrapInstructionTopicsData;
  }

  /**
   * @description Creates a rule-based instruction profile targeting specific employees and assigns instructions using production orchestrator logic.
   * @tags Admin - Instructions
   * @name CreateInstructionWithProfile
   * @summary Create instruction profile and assignments
   * @request POST:/admin/instructions/create-with-profile
   * @secure
   * @response `201` `CreateInstructionWithProfileData` Instruction profile and assignments created successfully
   * @response `400` `void` Invalid input data or validation failed
   * @response `404` `void` Organization, topic, or employees not found
   */
  export namespace CreateInstructionWithProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateInstructionWithProfileDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateInstructionWithProfileData;
  }

  /**
   * No description
   * @tags Experts
   * @name ListExperts
   * @request GET:/admin/experts
   * @secure
   * @response `200` `ListExpertsData`
   */
  export namespace ListExperts {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListExpertsData;
  }

  /**
   * No description
   * @tags Experts
   * @name CreateExpert
   * @request POST:/admin/experts
   * @secure
   * @response `201` `CreateExpertData`
   */
  export namespace CreateExpert {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateExpertDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateExpertData;
  }

  /**
   * No description
   * @tags Experts
   * @name UpdateCalendlyToken
   * @request PATCH:/admin/experts/{id}/calendly-token
   * @secure
   * @response `200` `UpdateCalendlyTokenData`
   */
  export namespace UpdateCalendlyToken {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateExpertCalendlyTokenDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateCalendlyTokenData;
  }
}

export namespace Metrics {
  /**
   * No description
   * @tags Prometheus
   * @name Index
   * @request GET:/metrics
   * @response `200` `IndexData`
   */
  export namespace Index {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = IndexData;
  }
}

export namespace Health {
  /**
 * No description
 * @tags Health
 * @name Check
 * @request GET:/health
 * @response `200` `CheckData` The Health Check is successful
 * @response `503` `{
  \** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} *\
    details?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"redis":{"status":"down","message":"Could not connect"}} *\
    error?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"database":{"status":"up"}} *\
    info?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example "error" *\
    status?: string,

}` The Health Check is not successful
*/
  export namespace Check {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CheckData;
  }
}

export namespace FirstAidLogs {
  /**
   * @description Creates a new first aid log with the provided data. Requires the affected employee ID, first aider IDs, and witness IDs to be valid UUIDs of existing employees. All employees referenced must exist in the system.
   * @tags First Aid Logs
   * @name Create
   * @summary Create a new first aid log
   * @request POST:/first-aid-logs/{orgId}
   * @secure
   * @response `201` `CreateOutput1` The first aid log has been successfully created.
   * @response `400` `void` Invalid input data provided.
   * @response `404` `void` One or more referenced employees not found.
   */
  export namespace Create {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateFirstAidLogDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateOutput1;
  }

  /**
   * No description
   * @tags First Aid Logs
   * @name FindByOrganization
   * @summary Get all first aid logs for an organization
   * @request GET:/first-aid-logs/{orgId}
   * @secure
   * @response `200` `FindByOrganizationData` List of first aid logs for the organization
   */
  export namespace FindByOrganization {
    export type RequestParams = {
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindByOrganizationData;
  }

  /**
   * No description
   * @tags First Aid Logs
   * @name GetOrganizationFirstAidQrCode
   * @request GET:/first-aid-logs/{orgId}/qr-code
   * @secure
   * @response `200` `GetOrganizationFirstAidQrCodeData`
   */
  export namespace GetOrganizationFirstAidQrCode {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetOrganizationFirstAidQrCodeData;
  }

  /**
   * No description
   * @tags First Aid Logs
   * @name AssignFirstAidLogEntry
   * @summary Assign first aid log to an employee
   * @request PATCH:/first-aid-logs/{orgId}/{logId}/assign
   * @secure
   * @response `200` `AssignFirstAidLogEntryData` Assigned first aid log to employee
   * @response `400` `void` First aid log already assigned
   * @response `403` `void` User is not authorized to assign log
   * @response `404` `void` First aid log not found
   */
  export namespace AssignFirstAidLogEntry {
    export type RequestParams = {
      logId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AssignEmployeeFirstLogDto;
    export type RequestHeaders = {};
    export type ResponseBody = AssignFirstAidLogEntryData;
  }

  /**
   * No description
   * @tags First Aid Logs
   * @name FindOne
   * @summary Get a specific first aid log by ID
   * @request GET:/first-aid-logs/{orgId}/{id}
   * @secure
   * @response `200` `FindOneOutput1` First aid log details
   * @response `404` `void` First aid log not found
   */
  export namespace FindOne {
    export type RequestParams = {
      /** First Aid Log ID */
      id: string;
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FindOneOutput1;
  }

  /**
   * @description Deletes a first aid log by ID and creates an activity log entry
   * @tags First Aid Logs
   * @name Remove
   * @summary Delete a first aid log
   * @request DELETE:/first-aid-logs/{orgId}/{id}
   * @secure
   * @response `200` `RemoveData` The first aid log has been successfully deleted.
   * @response `404` `void` First aid log not found
   */
  export namespace Remove {
    export type RequestParams = {
      /** First Aid Log ID */
      id: string;
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RemoveData;
  }

  /**
   * No description
   * @tags First Aid Logs
   * @name Update
   * @summary Update a specific first aid log by ID
   * @request PATCH:/first-aid-logs/{orgId}/{id}
   * @secure
   * @response `200` `UpdateOutput` First aid log details
   * @response `404` `void` First aid log not found
   */
  export namespace Update {
    export type RequestParams = {
      /** First Aid Log ID */
      id: string;
      /** Organization ID */
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateFirstAidLogDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateOutput;
  }
}

export namespace MentalHealthRiskAssessments {
  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name CreateCycle
   * @summary Create a new assessment cycle
   * @request POST:/mental-health-risk-assessments/{orgId}
   * @secure
   * @response `201` `CreateCycleData`
   */
  export namespace CreateCycle {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateAssessmentCycleDto;
    export type RequestHeaders = {};
    export type ResponseBody = CreateCycleData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name ListCycles
   * @summary List all assessment cycles for an organization
   * @request GET:/mental-health-risk-assessments/{orgId}
   * @secure
   * @response `200` `ListCyclesData`
   */
  export namespace ListCycles {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ListCyclesData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name GetCycle
   * @summary Get a specific assessment cycle
   * @request GET:/mental-health-risk-assessments/{orgId}/{cycleId}
   * @secure
   * @response `200` `GetCycleData`
   */
  export namespace GetCycle {
    export type RequestParams = {
      cycleId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetCycleData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name UpdateCycleNote
   * @summary Update the employee note of an assessment cycle
   * @request PUT:/mental-health-risk-assessments/{orgId}/{cycleId}/note
   * @secure
   * @response `200` `UpdateCycleNoteData`
   */
  export namespace UpdateCycleNote {
    export type RequestParams = {
      cycleId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateAssessmentCycleNoteDto;
    export type RequestHeaders = {};
    export type ResponseBody = UpdateCycleNoteData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name CloseCycle
   * @summary Close an assessment cycle
   * @request POST:/mental-health-risk-assessments/{orgId}/{cycleId}/close
   * @secure
   * @response `200` `CloseCycleData`
   * @response `201` `AssessmentCycle`
   */
  export namespace CloseCycle {
    export type RequestParams = {
      cycleId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CloseCycleData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name FinalizeCycle
   * @summary Finalize an assessment cycle
   * @request POST:/mental-health-risk-assessments/{orgId}/{cycleId}/finalize
   * @secure
   * @response `200` `FinalizeCycleData`
   * @response `201` `AssessmentCycle`
   */
  export namespace FinalizeCycle {
    export type RequestParams = {
      cycleId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FinalizeCycleData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name GetSelectableGroups
   * @summary Get selectable groups for the organization
   * @request GET:/mental-health-risk-assessments/{orgId}/groups
   * @secure
   * @response `200` `GetSelectableGroupsData`
   */
  export namespace GetSelectableGroups {
    export type RequestParams = {
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetSelectableGroupsData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name GetCycleByToken
   * @summary Get assessment cycle details by anonymous link token
   * @request GET:/mental-health-risk-assessments/{orgId}/public/assessment-config/{token}
   * @secure
   * @response `200` `GetCycleByTokenData`
   */
  export namespace GetCycleByToken {
    export type RequestParams = {
      orgId: string;
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetCycleByTokenData;
  }

  /**
   * No description
   * @tags Mental Health Risk Assessment
   * @name GetSurvey
   * @summary Get survey for a specific assessment cycle
   * @request GET:/mental-health-risk-assessments/{orgId}/cycles/{cycleId}/survey
   * @secure
   * @response `200` `GetSurveyData` Returns the survey for the specified cycle
   */
  export namespace GetSurvey {
    export type RequestParams = {
      cycleId: string;
      orgId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetSurveyData;
  }
}

export namespace Public {
  /**
   * No description
   * @tags Anonymous Mental Health Risk Assessment
   * @name GetSurvey
   * @summary Get survey for an anonymous assessment
   * @request GET:/public/mental-health-risk-assessments/survey/{token}
   * @response `200` `GetSurveyResult` Returns the survey response with either active survey or inactive status
   */
  export namespace GetSurvey {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {
      /** Survey language */
      locale?: GetSurveyParams2LocaleEnum;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetSurveyResult;
  }

  /**
   * No description
   * @tags Anonymous Mental Health Risk Assessment
   * @name GetGroups
   * @summary Get selectable groups for an anonymous assessment
   * @request GET:/public/mental-health-risk-assessments/groups/{token}
   * @response `200` `GetGroupsData` Returns the list of selectable groups for the specified token
   */
  export namespace GetGroups {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GetGroupsData;
  }

  /**
   * No description
   * @tags Anonymous Mental Health Risk Assessment
   * @name SubmitResponse
   * @summary Submit anonymous assessment responses
   * @request POST:/public/mental-health-risk-assessments/submit/{orgId}/{token}
   * @response `201` `SubmitResponseData`
   */
  export namespace SubmitResponse {
    export type RequestParams = {
      orgId: string;
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SubmitAssessmentDto;
    export type RequestHeaders = {};
    export type ResponseBody = SubmitResponseData;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:3001";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      return data;
    });
  };
}

/**
 * @title Ginione
 * @version 1.0
 * @baseUrl http://localhost:3001
 * @contact
 *
 * Ginione API document
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Application
   * @name GetHello
   * @request GET:/
   * @secure
   * @response `200` `GetHelloData`
   */
  getHello = (params: RequestParams = {}) =>
    this.request<GetHelloData, any>({
      path: `/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  videos = {
    /**
     * No description
     *
     * @tags Video
     * @name GetTotalDuration
     * @request GET:/videos/total-duration/{id}
     * @response `200` `GetTotalDurationData`
     */
    getTotalDuration: (id: string, params: RequestParams = {}) =>
      this.request<GetTotalDurationData, any>({
        path: `/videos/total-duration/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name SaveVideoProgress
     * @request POST:/videos/progress
     * @response `201` `SaveVideoProgressData`
     */
    saveVideoProgress: (params: RequestParams = {}) =>
      this.request<SaveVideoProgressData, any>({
        path: `/videos/progress`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name GetSingleVideosProgress
     * @request GET:/videos/progress
     * @response `200` `GetSingleVideosProgressData`
     */
    getSingleVideosProgress: (
      query: GetSingleVideosProgressParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSingleVideosProgressData, any>({
        path: `/videos/progress`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name GetVideosProgress
     * @request GET:/videos/progress/{courseId}
     * @response `200` `GetVideosProgressData`
     */
    getVideosProgress: (
      { courseId, ...query }: GetVideosProgressParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVideosProgressData, any>({
        path: `/videos/progress/${courseId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name GetVideoDuration
     * @request GET:/videos/video-duration
     * @response `200` `GetVideoDurationData`
     */
    getVideoDuration: (
      query: GetVideoDurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVideoDurationData, any>({
        path: `/videos/video-duration`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  bookings = {
    /**
     * No description
     *
     * @tags Booking
     * @name CreateBooking
     * @request POST:/bookings
     * @response `201` `CreateBookingData`
     */
    createBooking: (data: CreateBookingDto, params: RequestParams = {}) =>
      this.request<CreateBookingData, any>({
        path: `/bookings`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name FindBooking
     * @request GET:/bookings/find-booking
     * @response `200` `FindBookingData`
     */
    findBooking: (query: FindBookingParams, params: RequestParams = {}) =>
      this.request<FindBookingData, any>({
        path: `/bookings/find-booking`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetParticipantsCount
     * @request GET:/bookings/participants-count
     * @response `200` `GetParticipantsCountData`
     */
    getParticipantsCount: (
      query: GetParticipantsCountParams,
      params: RequestParams = {},
    ) =>
      this.request<GetParticipantsCountData, any>({
        path: `/bookings/participants-count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name HasActiveBooking
     * @request GET:/bookings/has-active-booking
     * @response `200` `HasActiveBookingData`
     */
    hasActiveBooking: (
      query: HasActiveBookingParams,
      params: RequestParams = {},
    ) =>
      this.request<HasActiveBookingData, any>({
        path: `/bookings/has-active-booking`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetUserBookings
     * @request GET:/bookings/user/{userId}
     * @response `200` `GetUserBookingsData`
     */
    getUserBookings: (
      { userId, ...query }: GetUserBookingsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserBookingsData, any>({
        path: `/bookings/user/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetExpertBookings
     * @request GET:/bookings/expert/{expertId}
     * @response `200` `GetExpertBookingsData`
     */
    getExpertBookings: (
      { expertId, ...query }: GetExpertBookingsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExpertBookingsData, any>({
        path: `/bookings/expert/${expertId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetBookingDetails
     * @request GET:/bookings/{id}
     * @response `200` `GetBookingDetailsData`
     */
    getBookingDetails: (id: string, params: RequestParams = {}) =>
      this.request<GetBookingDetailsData, any>({
        path: `/bookings/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name UpdateBooking
     * @request PUT:/bookings/{id}
     * @response `200` `UpdateBookingData`
     */
    updateBooking: (
      id: string,
      data: UpdateBookingDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBookingData, any>({
        path: `/bookings/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name ApproveBooking
     * @request PUT:/bookings/{id}/approve
     * @response `200` `ApproveBookingData`
     */
    approveBooking: (id: string, params: RequestParams = {}) =>
      this.request<ApproveBookingData, any>({
        path: `/bookings/${id}/approve`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name CancelBooking
     * @request PUT:/bookings/{id}/cancel
     * @response `200` `CancelBookingData`
     */
    cancelBooking: (id: string, params: RequestParams = {}) =>
      this.request<CancelBookingData, any>({
        path: `/bookings/${id}/cancel`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name UpdateBookingTime
     * @request PUT:/bookings/{id}/update-time
     * @response `200` `UpdateBookingTimeData`
     */
    updateBookingTime: (
      id: string,
      data: UpdateBookingTimeDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBookingTimeData, any>({
        path: `/bookings/${id}/update-time`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name Messages
     * @request POST:/bookings/{id}/messages
     * @response `201` `MessagesData`
     */
    messages: (
      id: string,
      data: SessionMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<MessagesData, any>({
        path: `/bookings/${id}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetMessages
     * @request GET:/bookings/{id}/messages
     * @response `200` `GetMessagesData`
     */
    getMessages: (id: string, params: RequestParams = {}) =>
      this.request<GetMessagesData, any>({
        path: `/bookings/${id}/messages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetUserConversations
     * @request GET:/bookings/{userId}/conversations
     * @response `200` `GetUserConversationsData`
     */
    getUserConversations: (userId: string, params: RequestParams = {}) =>
      this.request<GetUserConversationsData, any>({
        path: `/bookings/${userId}/conversations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetTotalUnreadMessagesCount
     * @summary Get total unread messages count for a user
     * @request GET:/bookings/{authUserId}/unread-messages-count
     * @response `200` `GetTotalUnreadMessagesCountData` Returns the total count of unread messages
     */
    getTotalUnreadMessagesCount: (
      authUserId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetTotalUnreadMessagesCountData, any>({
        path: `/bookings/${authUserId}/unread-messages-count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetExpertConversations
     * @request GET:/bookings/{expertId}/expert-conversations
     * @response `200` `GetExpertConversationsData`
     */
    getExpertConversations: (
      { expertId, ...query }: GetExpertConversationsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExpertConversationsData, any>({
        path: `/bookings/${expertId}/expert-conversations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name GetTotalUnreadMessagesCountForExpert
     * @summary Get total unread messages count for an expert
     * @request GET:/bookings/{expertId}/expert-unread-messages-count
     * @response `200` `GetTotalUnreadMessagesCountForExpertData` Returns the total count of unread messages
     */
    getTotalUnreadMessagesCountForExpert: (
      expertId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetTotalUnreadMessagesCountForExpertData, any>({
        path: `/bookings/${expertId}/expert-unread-messages-count`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  orgs = {
    /**
     * No description
     *
     * @tags Org
     * @name GetBookings
     * @request GET:/orgs/{orgId}
     * @response `200` `GetBookingsData`
     */
    getBookings: (orgId: string, params: RequestParams = {}) =>
      this.request<GetBookingsData, any>({
        path: `/orgs/${orgId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Org
     * @name GetUsers
     * @request GET:/orgs/{orgId}/users
     * @response `200` `GetUsersData`
     */
    getUsers: (
      { orgId, ...query }: GetUsersParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersData, any>({
        path: `/orgs/${orgId}/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  orientationCall = {
    /**
     * No description
     *
     * @tags OrientationCall
     * @name HandleCalendlyWebhook
     * @request POST:/orientation-call/calendly
     * @response `201` `HandleCalendlyWebhookData`
     */
    handleCalendlyWebhook: (params: RequestParams = {}) =>
      this.request<HandleCalendlyWebhookData, any>({
        path: `/orientation-call/calendly`,
        method: "POST",
        ...params,
      }),
  };
  experts = {
    /**
     * No description
     *
     * @tags Expert
     * @name Update
     * @request POST:/experts
     * @response `201` `UpdateData`
     */
    update: (params: RequestParams = {}) =>
      this.request<UpdateData, any>({
        path: `/experts`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetAll
     * @request GET:/experts
     * @response `200` `GetAllData`
     */
    getAll: (params: RequestParams = {}) =>
      this.request<GetAllData, any>({
        path: `/experts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetByExternalId
     * @request GET:/experts/{expert_external_id}
     * @response `200` `GetByExternalIdData`
     */
    getByExternalId: (expertExternalId: string, params: RequestParams = {}) =>
      this.request<GetByExternalIdData, any>({
        path: `/experts/${expertExternalId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetAvailabilities
     * @request GET:/experts/{expert_external_id}/availabilities
     * @response `200` `GetAvailabilitiesData`
     */
    getAvailabilities: (expertExternalId: string, params: RequestParams = {}) =>
      this.request<GetAvailabilitiesData, any>({
        path: `/experts/${expertExternalId}/availabilities`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetAllBookings
     * @request GET:/experts/{expert_external_id}/bookings
     * @response `200` `GetAllBookingsData`
     */
    getAllBookings: (
      { expertExternalId, ...query }: GetAllBookingsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAllBookingsData, any>({
        path: `/experts/${expertExternalId}/bookings`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name UpdateBooking
     * @request POST:/experts/{expert_external_id}/bookings/{booking_id}
     * @response `201` `UpdateBookingResult`
     */
    updateBooking: (
      expertExternalId: string,
      bookingId: string,
      data: UpdateBookingDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBookingResult, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetBookingDetails
     * @request GET:/experts/{expert_external_id}/bookings/{booking_id}
     * @response `200` `GetBookingDetailsResult`
     */
    getBookingDetails: (
      expertExternalId: string,
      bookingId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetBookingDetailsResult, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetExpertBookingDetails
     * @request GET:/experts/{expert_external_id}/bookings-details/{booking_id}
     * @response `200` `GetExpertBookingDetailsData`
     */
    getExpertBookingDetails: (
      expertExternalId: string,
      bookingId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetExpertBookingDetailsData, any>({
        path: `/experts/${expertExternalId}/bookings-details/${bookingId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name MeetingToken
     * @request GET:/experts/{expert_external_id}/bookings/{booking_id}/meeting/token
     * @response `200` `MeetingTokenData`
     */
    meetingToken: (
      { expertExternalId, bookingId, ...query }: MeetingTokenParams,
      params: RequestParams = {},
    ) =>
      this.request<MeetingTokenData, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}/meeting/token`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name GetCourseToken
     * @request GET:/experts/bookings/{booking_id}/course/token
     * @response `200` `GetCourseTokenData`
     */
    getCourseToken: (
      { bookingId, ...query }: GetCourseTokenParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseTokenData, any>({
        path: `/experts/bookings/${bookingId}/course/token`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name ReserveSession
     * @request GET:/experts/{expert_external_id}/reserve/session
     * @response `200` `ReserveSessionData`
     */
    reserveSession: (
      expertExternalId: string,
      data: ReserveSessionDto,
      params: RequestParams = {},
    ) =>
      this.request<ReserveSessionData, any>({
        path: `/experts/${expertExternalId}/reserve/session`,
        method: "GET",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name ApproveBooking
     * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/approve
     * @response `200` `ApproveBookingResult`
     */
    approveBooking: (
      expertExternalId: string,
      bookingId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApproveBookingResult, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}/approve`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name CancelBooking
     * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/cancel
     * @response `200` `CancelBookingResult`
     */
    cancelBooking: (
      expertExternalId: string,
      bookingId: string,
      params: RequestParams = {},
    ) =>
      this.request<CancelBookingResult, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}/cancel`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expert
     * @name UpdateBookingTime
     * @request PUT:/experts/{expert_external_id}/bookings/{booking_id}/update-time
     * @response `200` `UpdateBookingTimeResult`
     */
    updateBookingTime: (
      expertExternalId: string,
      bookingId: string,
      data: UpdateBookingTimeDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateBookingTimeResult, any>({
        path: `/experts/${expertExternalId}/bookings/${bookingId}/update-time`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  partners = {
    /**
     * No description
     *
     * @tags Partner
     * @name Create
     * @request POST:/partners
     * @response `201` `CreateData`
     */
    create: (params: RequestParams = {}) =>
      this.request<CreateData, any>({
        path: `/partners`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partner
     * @name GetAll
     * @request GET:/partners
     * @response `200` `GetAllResult`
     */
    getAll: (params: RequestParams = {}) =>
      this.request<GetAllResult, any>({
        path: `/partners`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  strapi = {
    /**
     * No description
     *
     * @tags StrapiWebhook
     * @name Event
     * @request POST:/strapi/webhook
     * @response `201` `EventData`
     */
    event: (params: RequestParams = {}) =>
      this.request<EventData, any>({
        path: `/strapi/webhook`,
        method: "POST",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags UserBooking
     * @name MeetingToken
     * @request GET:/users/{user_id}/bookings/{booking_id}/meeting/token
     * @response `200` `MeetingTokenResult`
     */
    meetingToken: (
      bookingId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetingTokenResult, any>({
        path: `/users/${userId}/bookings/${bookingId}/meeting/token`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserBooking
     * @name CourseToken
     * @request GET:/users/bookings/{booking_id}/course/token
     * @response `200` `CourseTokenData`
     */
    courseToken: (bookingId: string, params: RequestParams = {}) =>
      this.request<CourseTokenData, any>({
        path: `/users/bookings/${bookingId}/course/token`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CourseBooking
     * @name MeetingToken2
     * @request GET:/users/{user_id}/bookings/{booking_id}/course/token
     * @originalName meetingToken
     * @duplicate
     * @response `200` `MeetingToken2Data`
     */
    meetingToken2: (
      bookingId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetingToken2Data, any>({
        path: `/users/${userId}/bookings/${bookingId}/course/token`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SearchUsers
     * @request GET:/users/search
     * @response `200` `SearchUsersData`
     */
    searchUsers: (query: SearchUsersParams, params: RequestParams = {}) =>
      this.request<SearchUsersData, any>({
        path: `/users/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserById
     * @request GET:/users/{id}
     * @secure
     * @response `200` `GetUserByIdData` User details retrieved successfully
     * @response `404` `void` User not found or access denied
     */
    getUserById: (id: string, params: RequestParams = {}) =>
      this.request<GetUserByIdData, void>({
        path: `/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserByAuthId
     * @request GET:/users/authUserId/{authUserId}
     * @secure
     * @response `200` `GetUserByAuthIdData` User details retrieved successfully
     * @response `404` `void` User not found or access denied (prevents user enumeration)
     */
    getUserByAuthId: (authUserId: string, params: RequestParams = {}) =>
      this.request<GetUserByAuthIdData, void>({
        path: `/users/authUserId/${authUserId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetAdminRoleById
     * @request GET:/users/adminRoles/{id}
     * @secure
     * @response `200` `GetAdminRoleByIdData` User role retrieved successfully
     * @response `404` `void` User not found or access denied (prevents user enumeration)
     */
    getAdminRoleById: (id: string, params: RequestParams = {}) =>
      this.request<GetAdminRoleByIdData, void>({
        path: `/users/adminRoles/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name FindAll
     * @request GET:/users
     * @response `200` `FindAllData`
     */
    findAll: (params: RequestParams = {}) =>
      this.request<FindAllData, any>({
        path: `/users`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name Create
 * @summary Legacy webhook endpoint for Bloom (backward compatible).
Handles `user.created` events from the Bloom Clerk app.
 * @request POST:/users
 * @response `201` `CreateResult`
 */
    create: (params: RequestParams = {}) =>
      this.request<CreateResult, any>({
        path: `/users`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CreateUser
     * @request POST:/users/create
     * @response `201` `CreateUserData`
     */
    createUser: (data: CreateNewUserDto, params: RequestParams = {}) =>
      this.request<CreateUserData, any>({
        path: `/users/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name CreateBloomUser
     * @summary Webhook endpoint for Bloom user.created events.
     * @request POST:/users/webhooks/bloom/user-created
     * @response `201` `CreateBloomUserData`
     */
    createBloomUser: (params: RequestParams = {}) =>
      this.request<CreateBloomUserData, any>({
        path: `/users/webhooks/bloom/user-created`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetRequiresPasswordReset
     * @request GET:/users/{email}/requiresPasswordReset
     * @response `200` `GetRequiresPasswordResetData`
     */
    getRequiresPasswordReset: (email: string, params: RequestParams = {}) =>
      this.request<GetRequiresPasswordResetData, any>({
        path: `/users/${email}/requiresPasswordReset`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateRequiresPasswordReset
     * @request PATCH:/users/{email}/requiresPasswordReset
     * @response `200` `UpdateRequiresPasswordResetData`
     */
    updateRequiresPasswordReset: (email: string, params: RequestParams = {}) =>
      this.request<UpdateRequiresPasswordResetData, any>({
        path: `/users/${email}/requiresPasswordReset`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateAuthUserId
     * @request PATCH:/users/{email}/authUserId
     * @response `200` `UpdateAuthUserIdData`
     */
    updateAuthUserId: (email: string, params: RequestParams = {}) =>
      this.request<UpdateAuthUserIdData, any>({
        path: `/users/${email}/authUserId`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetNumberOfRemainingSessions
     * @request GET:/users/numberOfSessionRemaining/{id}
     * @response `200` `GetNumberOfRemainingSessionsData`
     */
    getNumberOfRemainingSessions: (id: string, params: RequestParams = {}) =>
      this.request<GetNumberOfRemainingSessionsData, any>({
        path: `/users/numberOfSessionRemaining/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateLanguageId
     * @request PATCH:/users/{id}/language
     * @response `200` `UpdateLanguageIdData`
     */
    updateLanguageId: (id: string, params: RequestParams = {}) =>
      this.request<UpdateLanguageIdData, any>({
        path: `/users/${id}/language`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name NotifyPasswordReset
     * @request POST:/users/notifyPasswordReset
     * @response `201` `NotifyPasswordResetData`
     */
    notifyPasswordReset: (params: RequestParams = {}) =>
      this.request<NotifyPasswordResetData, any>({
        path: `/users/notifyPasswordReset`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateOrganization
     * @request PATCH:/users/{id}/organization
     * @secure
     * @response `200` `UpdateOrganizationData` The organization was updated successfully.
     * @response `400` `void` Bad Request (e.g., validation error, organization not found)
     * @response `403` `void` Forbidden (Authentication error)
     * @response `404` `void` User not found
     */
    updateOrganization: (
      id: string,
      data: UpdateUserOrganizationDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOrganizationData, void>({
        path: `/users/${id}/organization`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhook = {
    /**
     * No description
     *
     * @tags ClerkWebhook
     * @name Email
     * @request POST:/webhook/email
     * @response `201` `EmailData`
     */
    email: (params: RequestParams = {}) =>
      this.request<EmailData, any>({
        path: `/webhook/email`,
        method: "POST",
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags Organizations
     * @name GetOhsHubOrgs
     * @summary Get all OHS Hub organizations
     * @request GET:/organizations/ohs-hub-organizations
     * @secure
     * @response `200` `GetOhsHubOrgsData` Successfully retrieved the list of OHS Hub organizations.
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin or ops role
     */
    getOhsHubOrgs: (params: RequestParams = {}) =>
      this.request<GetOhsHubOrgsData, void>({
        path: `/organizations/ohs-hub-organizations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name FetchOrg
     * @summary Get organization by ID
     * @request GET:/organizations/{orgId}
     * @secure
     * @response `200` `FetchOrgData` Successfully retrieved the organization.
     * @response `404` `void` Organization not found
     */
    fetchOrg: (orgId: string, params: RequestParams = {}) =>
      this.request<FetchOrgData, void>({
        path: `/organizations/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name FetchOrgDetailed
     * @summary Get detailed organization information by ID
     * @request GET:/organizations/{orgId}/detailed
     * @secure
     * @response `200` `FetchOrgDetailedData` Successfully retrieved detailed organization information.
     * @response `404` `void` Organization not found
     */
    fetchOrgDetailed: (orgId: string, params: RequestParams = {}) =>
      this.request<FetchOrgDetailedData, void>({
        path: `/organizations/${orgId}/detailed`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name FetchOrgDetailedAdmin
     * @summary Get detailed organization information by ID (Admin only)
     * @request GET:/organizations/{orgId}/detailed/admin
     * @secure
     * @response `200` `FetchOrgDetailedAdminData` Successfully retrieved detailed organization information.
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin role
     * @response `404` `void` Organization not found
     */
    fetchOrgDetailedAdmin: (orgId: string, params: RequestParams = {}) =>
      this.request<FetchOrgDetailedAdminData, void>({
        path: `/organizations/${orgId}/detailed/admin`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name GetAreTcRequiredForEnduserOfOrganisation
     * @summary Check if terms and conditions are required for end users of an organization
     * @request GET:/organizations/tc/{orgId}
     * @secure
     * @response `200` `GetAreTcRequiredForEnduserOfOrganisationData` Successfully checked terms and conditions requirement.
     * @response `404` `void` Organization not found
     */
    getAreTcRequiredForEnduserOfOrganisation: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetAreTcRequiredForEnduserOfOrganisationData, void>({
        path: `/organizations/tc/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name UpdateExclusions
     * @summary Update organization exclusions
     * @request PATCH:/organizations/{id}/exclusions
     * @secure
     * @response `200` `UpdateExclusionsData` Successfully updated organization exclusions.
     * @response `400` `void` Bad request - Invalid input data
     * @response `404` `void` Organization not found
     */
    updateExclusions: (
      id: string,
      data: UpdateOrganizationExclusionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateExclusionsData, void>({
        path: `/organizations/${id}/exclusions`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name GetExclusions
     * @summary Get organization exclusions
     * @request GET:/organizations/{id}/exclusions
     * @secure
     * @response `200` `GetExclusionsData` Successfully retrieved organization exclusions.
     * @response `404` `void` Organization not found
     */
    getExclusions: (id: string, params: RequestParams = {}) =>
      this.request<GetExclusionsData, void>({
        path: `/organizations/${id}/exclusions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name CreateOrganizationAdmin
     * @request POST:/organizations/admin
     * @secure
     * @response `201` `CreateOrganizationAdminData`
     */
    createOrganizationAdmin: (
      data: CreateOrganizationAdminRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateOrganizationAdminData, any>({
        path: `/organizations/admin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name GetOrganizationByQrCode
     * @request GET:/organizations/qr/{qrCode}
     * @secure
     * @response `200` `GetOrganizationByQrCodeData`
     */
    getOrganizationByQrCode: (qrCode: string, params: RequestParams = {}) =>
      this.request<GetOrganizationByQrCodeData, any>({
        path: `/organizations/qr/${qrCode}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name SubmitExternalFirstAidLog
     * @request POST:/organizations/{orgId}/first-aid-logs/external
     * @secure
     * @response `201` `SubmitExternalFirstAidLogData`
     */
    submitExternalFirstAidLog: (
      orgId: string,
      data: CreateUnassignedFirstAidLogDto,
      params: RequestParams = {},
    ) =>
      this.request<SubmitExternalFirstAidLogData, any>({
        path: `/organizations/${orgId}/first-aid-logs/external`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Invitations
     * @name GetAllConfig
     * @request POST:/organizations/{orgId}/invitations
     * @response `201` `GetAllConfigData`
     */
    getAllConfig: (
      orgId: string,
      data: GetAllConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetAllConfigData, any>({
        path: `/organizations/${orgId}/invitations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Invitations
     * @name InviteVerification
     * @request POST:/organizations/{orgId}/invitation/verification
     * @response `201` `InviteVerificationData`
     */
    inviteVerification: (
      orgId: string,
      data: InvitationCodeVerificationDto,
      params: RequestParams = {},
    ) =>
      this.request<InviteVerificationData, any>({
        path: `/organizations/${orgId}/invitation/verification`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ohsHub = {
    /**
     * @description Retrieves detailed information about a specific organization including its structure and settings.
     *
     * @tags OHS Hub - Organization Management
     * @name FindOne
     * @summary Get organization details
     * @request GET:/ohs-hub/orgs/{orgId}
     * @secure
     * @response `200` `FindOneData`
     */
    findOne: (orgId: string, params: RequestParams = {}) =>
      this.request<FindOneData, any>({
        path: `/ohs-hub/orgs/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the occupational medicine information and settings for an organization.
     *
     * @tags OHS Hub - Organization Management
     * @name GetOccupationalMedicineInfo
     * @summary Get occupational medicine info
     * @request GET:/ohs-hub/orgs/{orgId}/occ-medicine
     * @secure
     * @response `200` `GetOccupationalMedicineInfoData`
     */
    getOccupationalMedicineInfo: (
      { orgId, ...query }: GetOccupationalMedicineInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<GetOccupationalMedicineInfoData, any>({
        path: `/ohs-hub/orgs/${orgId}/occ-medicine`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates new occupational medicine information for an organization.
     *
     * @tags OHS Hub - Organization Management
     * @name CreateOccupationalMedicineInfo
     * @summary Create occupational medicine info
     * @request POST:/ohs-hub/orgs/{orgId}/occ-medicine
     * @secure
     * @response `201` `CreateOccupationalMedicineInfoData`
     */
    createOccupationalMedicineInfo: (
      orgId: string,
      data: CreateOrganizationOccupationalMedicineInfoDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateOccupationalMedicineInfoData, any>({
        path: `/ohs-hub/orgs/${orgId}/occ-medicine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the occupational medicine information for an organization.
     *
     * @tags OHS Hub - Organization Management
     * @name UpdateOccupationalMedicineInfo
     * @summary Update occupational medicine info
     * @request PUT:/ohs-hub/orgs/{orgId}/occ-medicine/{id}
     * @secure
     * @response `200` `UpdateOccupationalMedicineInfoData`
     */
    updateOccupationalMedicineInfo: (
      orgId: string,
      id: string,
      data: UpdateOrganizationOccupationalMedicineInfoDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOccupationalMedicineInfoData, any>({
        path: `/ohs-hub/orgs/${orgId}/occ-medicine/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enables or disables email notifications for occupational medicine information.
     *
     * @tags OHS Hub - Organization Management
     * @name ToggleEmailSending
     * @summary Toggle email notifications
     * @request PUT:/ohs-hub/orgs/{orgId}/occ-medicine/{id}/toggle-email
     * @secure
     * @response `200` `ToggleEmailSendingData`
     */
    toggleEmailSending: (
      orgId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ToggleEmailSendingData, any>({
        path: `/ohs-hub/orgs/${orgId}/occ-medicine/${id}/toggle-email`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  preventionRegister = {
    /**
     * @description Evaluates all prevention rules for an organization and creates assignments and notices for matching rules. If an assignment already exists with no notice, a notice will be created.
     *
     * @tags OHS Hub - Prevention
     * @name EvaluateRulesForOrg
     * @summary Evaluate prevention rules
     * @request POST:/prevention-register/generate/{orgId}
     * @secure
     * @response `201` `EvaluateRulesForOrgData`
     */
    evaluateRulesForOrg: (orgId: string, params: RequestParams = {}) =>
      this.request<EvaluateRulesForOrgData, any>({
        path: `/prevention-register/generate/${orgId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Processes all pending prevention notices for an organization. Processing a notice will send it to the employee. Can be run in dry-run mode to preview changes.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessNoticesByOrganization
     * @summary Process pending notices
     * @request POST:/prevention-register/process/organization/{orgId}
     * @secure
     * @response `201` `ProcessNoticesByOrganizationData`
     */
    processNoticesByOrganization: (
      { orgId, ...query }: ProcessNoticesByOrganizationParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessNoticesByOrganizationData, any>({
        path: `/prevention-register/process/organization/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Processes a single prevention notice. Can be run in dry-run mode to preview changes.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessNotice
     * @summary Process single notice
     * @request POST:/prevention-register/notices/{id}/process
     * @secure
     * @response `201` `ProcessNoticeData`
     */
    processNotice: (id: string, params: RequestParams = {}) =>
      this.request<ProcessNoticeData, any>({
        path: `/prevention-register/notices/${id}/process`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the prevention status for all assignments in an organization.
     *
     * @tags OHS Hub - Prevention
     * @name UpdateStatusForOrg
     * @summary Update prevention status
     * @request POST:/prevention-register/update-status/{orgId}
     * @secure
     * @response `201` `UpdateStatusForOrgData`
     */
    updateStatusForOrg: (orgId: string, params: RequestParams = {}) =>
      this.request<UpdateStatusForOrgData, any>({
        path: `/prevention-register/update-status/${orgId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Prevention
     * @name ProcessNoticesForSingleOrg
     * @summary Process prevention notices for a single organization
     * @request POST:/prevention-register/notices/process/{orgId}
     * @secure
     * @response `200` `ProcessNoticesForSingleOrgData` Successfully processed notices for organization
     * @response `201` `ProcessSingleOrgResultDto`
     */
    processNoticesForSingleOrg: (
      { orgId, ...query }: ProcessNoticesForSingleOrgParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessNoticesForSingleOrgData, any>({
        path: `/prevention-register/notices/process/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Prevention
     * @name ProcessNoticesForAllOrgs
     * @summary Process prevention notices for all organizations
     * @request POST:/prevention-register/notices/process-all/{orgId}
     * @secure
     * @response `200` `ProcessNoticesForAllOrgsData` Successfully processed notices for all organizations
     * @response `201` `ProcessNoticesResultDto`
     */
    processNoticesForAllOrgs: (
      { orgId, ...query }: ProcessNoticesForAllOrgsParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessNoticesForAllOrgsData, any>({
        path: `/prevention-register/notices/process-all/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Processes mandatory prevention reminder emails for assignments approaching their due dates.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessMandatoryEmailsForSingleOrg
     * @summary Process mandatory prevention emails for a single organization
     * @request POST:/prevention-register/mandatory/process/{orgId}
     * @secure
     * @response `200` `ProcessMandatoryEmailsForSingleOrgData` Successfully processed mandatory emails for organization
     * @response `201` `object`
     */
    processMandatoryEmailsForSingleOrg: (
      { orgId, ...query }: ProcessMandatoryEmailsForSingleOrgParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessMandatoryEmailsForSingleOrgData, any>({
        path: `/prevention-register/mandatory/process/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Processes mandatory prevention reminder emails for all organizations with assignments approaching their due dates.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessMandatoryEmailsForAllOrgs
     * @summary Process mandatory prevention emails for all organizations
     * @request POST:/prevention-register/mandatory/process-all/{orgId}
     * @secure
     * @response `200` `ProcessMandatoryEmailsForAllOrgsData` Successfully processed mandatory emails for all organizations
     * @response `201` `object`
     */
    processMandatoryEmailsForAllOrgs: (
      { orgId, ...query }: ProcessMandatoryEmailsForAllOrgsParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessMandatoryEmailsForAllOrgsData, any>({
        path: `/prevention-register/mandatory/process-all/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Unified endpoint that processes both offer and mandatory prevention emails for a specific organization.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessPreventionEmailsUnifiedSingleOrg
     * @summary 🚀 Process ALL prevention emails (offer + mandatory) for a single organization
     * @request POST:/prevention-register/unified/process/{orgId}
     * @secure
     * @response `200` `ProcessPreventionEmailsUnifiedSingleOrgData` Successfully processed prevention emails for organization
     * @response `201` `object`
     */
    processPreventionEmailsUnifiedSingleOrg: (
      { orgId, ...query }: ProcessPreventionEmailsUnifiedSingleOrgParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessPreventionEmailsUnifiedSingleOrgData, any>({
        path: `/prevention-register/unified/process/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Unified endpoint that processes both offer and mandatory prevention emails for all organizations. This is the main production job that runs daily.
     *
     * @tags OHS Hub - Prevention
     * @name ProcessAllPreventionEmailsUnified
     * @summary 🚀 Process ALL prevention emails (offer + mandatory) for all organizations
     * @request POST:/prevention-register/unified/process-all/{orgId}
     * @secure
     * @response `200` `ProcessAllPreventionEmailsUnifiedData` Successfully processed all prevention emails for all organizations
     * @response `201` `object`
     */
    processAllPreventionEmailsUnified: (
      { orgId, ...query }: ProcessAllPreventionEmailsUnifiedParams,
      params: RequestParams = {},
    ) =>
      this.request<ProcessAllPreventionEmailsUnifiedData, any>({
        path: `/prevention-register/unified/process-all/${orgId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends a test message to the configured Slack channel to verify webhook integration.
     *
     * @tags OHS Hub - Prevention
     * @name TestSlackIntegration
     * @summary 🧪 Test Slack integration
     * @request POST:/prevention-register/unified/test-slack/{orgId}
     * @secure
     * @response `200` `TestSlackIntegrationData` Slack test result
     * @response `201` `void`
     */
    testSlackIntegration: (orgId: string, params: RequestParams = {}) =>
      this.request<TestSlackIntegrationData, any>({
        path: `/prevention-register/unified/test-slack/${orgId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Send test mandatory prevention emails to a specified email address. Supports sending specific email types or all types at once. This endpoint uses real email delivery for end-to-end testing.
     *
     * @tags OHS Hub - Prevention
     * @name SendTestMandatoryPreventionEmail
     * @summary 🧪 Test mandatory prevention email sending
     * @request POST:/prevention-register/mandatory-prevention/test-email/{orgId}
     * @secure
     * @response `200` `SendTestMandatoryPreventionEmailData` Test emails sent successfully
     * @response `201` `object`
     */
    sendTestMandatoryPreventionEmail: (
      orgId: string,
      data: SendTestMandatoryPreventionEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<SendTestMandatoryPreventionEmailData, any>({
        path: `/prevention-register/mandatory-prevention/test-email/${orgId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a test offer prevention email to a specified email address. Uses real org data if available, otherwise mock data.
     *
     * @tags OHS Hub - Prevention
     * @name SendTestOfferPreventionEmail
     * @summary Send test offer prevention email
     * @request POST:/prevention-register/offer-prevention/test-email/{orgId}
     * @secure
     * @response `200` `SendTestOfferPreventionEmailData` Test offer email sent successfully
     * @response `201` `object`
     */
    sendTestOfferPreventionEmail: (
      orgId: string,
      data: SendTestOfferPreventionEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<SendTestOfferPreventionEmailData, any>({
        path: `/prevention-register/offer-prevention/test-email/${orgId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  preventionNotices = {
    /**
     * @description Retrieves a specific prevention notice by its ID.
     *
     * @tags Prevention Notices
     * @name FindById
     * @summary Get notice by ID
     * @request GET:/prevention-notices/orgs/{orgId}/{id}
     * @secure
     * @response `200` `FindByIdData` The prevention notice was found
     * @response `404` `void` The prevention notice was not found
     */
    findById: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<FindByIdData, void>({
        path: `/prevention-notices/orgs/${orgId}/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the properties of a prevention notice.
     *
     * @tags Prevention Notices
     * @name Update
     * @summary Update notice
     * @request PATCH:/prevention-notices/orgs/{orgId}/{id}
     * @secure
     * @response `200` `UpdateResult` The prevention notice was updated
     * @response `404` `void` The prevention notice was not found
     */
    update: (
      orgId: string,
      id: string,
      data: UpdatePreventionNoticeDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateResult, void>({
        path: `/prevention-notices/orgs/${orgId}/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all prevention notices for a specific employee.
     *
     * @tags Prevention Notices
     * @name FindByEmployeeId
     * @summary Get employee notices
     * @request GET:/prevention-notices/orgs/{orgId}/employee/{employeeId}
     * @secure
     * @response `200` `FindByEmployeeIdData` List of prevention notices
     */
    findByEmployeeId: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<FindByEmployeeIdData, any>({
        path: `/prevention-notices/orgs/${orgId}/employee/${employeeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Processes a single prevention notice. Can be run in dry-run mode to preview changes.
     *
     * @tags Prevention Notices
     * @name ProcessNotice
     * @summary Process notice
     * @request POST:/prevention-notices/orgs/{orgId}/{id}/process
     * @secure
     * @response `200` `ProcessNoticeResult` The notice was processed
     * @response `201` `ProcessSingleResultDto`
     * @response `404` `void` The notice was not found
     */
    processNotice: (
      { orgId, id, ...query }: ProcessNoticeParams1,
      params: RequestParams = {},
    ) =>
      this.request<ProcessNoticeResult, void>({
        path: `/prevention-notices/orgs/${orgId}/${id}/process`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  komboIntegration = {
    /**
     * No description
     *
     * @tags Kombo Integration
     * @name SyncById
     * @request GET:/kombo-integration/sync/{orgId}
     * @secure
     * @response `200` `SyncByIdData` Full synchronization completed successfully.
     * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
     * @response `500` `ApiErrorResponseDto` Internal server error during synchronization.
     */
    syncById: (orgId: string, params: RequestParams = {}) =>
      this.request<SyncByIdData, SyncByIdError>({
        path: `/kombo-integration/sync/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kombo Integration
     * @name ProcessById
     * @request GET:/kombo-integration/process/{orgId}
     * @secure
     * @response `200` `ProcessByIdData` Domain entity processing completed successfully.
     * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
     * @response `500` `ApiErrorResponseDto` Internal server error during processing.
     */
    processById: (orgId: string, params: RequestParams = {}) =>
      this.request<ProcessByIdData, ProcessByIdError>({
        path: `/kombo-integration/process/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kombo Integration
     * @name IngestById
     * @request GET:/kombo-integration/ingest/{orgId}
     * @secure
     * @response `200` `IngestByIdData` Data ingestion completed successfully.
     * @response `404` `ApiErrorResponseDto` Organization or Kombo Integration not found.
     * @response `500` `ApiErrorResponseDto` Internal server error during ingestion.
     */
    ingestById: (orgId: string, params: RequestParams = {}) =>
      this.request<IngestByIdData, IngestByIdError>({
        path: `/kombo-integration/ingest/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kombo Integration
     * @name TriggerDailySync
     * @summary Trigger daily sync manually
     * @request POST:/kombo-integration/sync/daily/{orgId}
     * @secure
     * @response `200` `TriggerDailySyncData` Daily sync completed successfully
     * @response `201` `void`
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin role
     * @response `500` `void` Internal server error
     */
    triggerDailySync: (orgId: string, params: RequestParams = {}) =>
      this.request<TriggerDailySyncData, void>({
        path: `/kombo-integration/sync/daily/${orgId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  humanResources = {
    /**
     * @description Retrieves all groups, legal entities, and work locations for an organization. Use this for populating dropdown filters in the UI.
     *
     * @tags OHS Hub - HR
     * @name GetOrganizationOptions
     * @summary Get organization options for dropdowns
     * @request GET:/human-resources/orgs/{orgId}/admin/options
     * @secure
     * @response `200` `GetOrganizationOptionsData` Organization options retrieved successfully
     * @response `404` `void` Organization not found
     */
    getOrganizationOptions: (orgId: string, params: RequestParams = {}) =>
      this.request<GetOrganizationOptionsData, void>({
        path: `/human-resources/orgs/${orgId}/admin/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all groups, kombo staginglegal entities, and kombo staging work locations and kombo staging employees for an organization. Use this for populating dropdown filters in the UI. Currently used on updateKomboExclusions
     *
     * @tags OHS Hub - HR
     * @name GetOrganizationOptionsKombo
     * @summary Get organization kombo staging options for dropdowns
     * @request GET:/human-resources/orgs/{orgId}/admin/options/kombo
     * @secure
     * @response `200` `GetOrganizationOptionsKomboData` Organization kombo staging options retrieved successfully
     * @response `404` `void` Organization not found
     */
    getOrganizationOptionsKombo: (orgId: string, params: RequestParams = {}) =>
      this.request<GetOrganizationOptionsKomboData, void>({
        path: `/human-resources/orgs/${orgId}/admin/options/kombo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new employee for an organization without requiring HRI integration. A unique komboId is generated automatically.
     *
     * @tags OHS Hub - HR
     * @name CreateEmployee
     * @summary Create a new employee manually
     * @request POST:/human-resources/orgs/{orgId}/employees
     * @secure
     * @response `201` `CreateEmployeeData` The employee has been successfully created
     * @response `400` `void` Invalid input data
     * @response `404` `void` Legal entity, work location, or group not found
     */
    createEmployee: (
      orgId: string,
      data: ManualCreateEmployeeDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateEmployeeData, void>({
        path: `/human-resources/orgs/${orgId}/employees`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new legal entity for an organization. The komboId is required and must be unique within the organization.
     *
     * @tags OHS Hub - HR
     * @name CreateLegalEntity
     * @summary Create a new legal entity
     * @request POST:/human-resources/orgs/{orgId}/legal-entities
     * @secure
     * @response `201` `CreateLegalEntityData` The legal entity has been successfully created
     * @response `400` `void` Invalid input data
     * @response `404` `void` Organization not found
     */
    createLegalEntity: (
      orgId: string,
      data: CreateLegalEntityDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateLegalEntityData, void>({
        path: `/human-resources/orgs/${orgId}/legal-entities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new work location for an organization. The komboId is required and must be unique within the organization.
     *
     * @tags OHS Hub - HR
     * @name CreateWorkLocation
     * @summary Create a new work location
     * @request POST:/human-resources/orgs/{orgId}/work-locations
     * @secure
     * @response `201` `CreateWorkLocationData` The work location has been successfully created
     * @response `400` `void` Invalid input data
     * @response `404` `void` Organization not found
     */
    createWorkLocation: (
      orgId: string,
      data: CreateWorkLocationDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateWorkLocationData, void>({
        path: `/human-resources/orgs/${orgId}/work-locations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Assigns an existing employee to a legal entity and/or work location. Both legalEntityId and workLocationId are optional.
     *
     * @tags OHS Hub - HR
     * @name AssignEmployee
     * @summary Assign employee to legal entity and/or work location
     * @request POST:/human-resources/orgs/{orgId}/admin/employees/{employeeId}/assign
     * @secure
     * @response `200` `AssignEmployeeData` The employee has been successfully assigned
     * @response `201` `Employee`
     * @response `400` `void` Invalid input data
     * @response `404` `void` Employee, legal entity, or work location not found
     */
    assignEmployee: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<AssignEmployeeData, void>({
        path: `/human-resources/orgs/${orgId}/admin/employees/${employeeId}/assign`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the note field for a specific employee. Input is sanitized to prevent XSS attacks.
     *
     * @tags OHS Hub - HR
     * @name UpdateNoteForEmployee
     * @summary Update employee note
     * @request POST:/human-resources/orgs/{orgId}/update-note/{employeeId}
     * @secure
     * @response `200` `UpdateNoteForEmployeeData` The employee note was updated
     * @response `201` `Employee`
     * @response `400` `void` Invalid input data
     * @response `404` `void` The employee was not found
     */
    updateNoteForEmployee: (
      orgId: string,
      employeeId: string,
      data: UpdateEmployeeNoteDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateNoteForEmployeeData, void>({
        path: `/human-resources/orgs/${orgId}/update-note/${employeeId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  activityLogs = {
    /**
     * No description
     *
     * @tags Activity Logs
     * @name GetAllLogs
     * @request GET:/activity-logs
     * @secure
     * @response `200` `GetAllLogsData` Successfully retrieved enriched activity logs. When aggregated=true, returns only aggregated logs.
     */
    getAllLogs: (query: GetAllLogsParams, params: RequestParams = {}) =>
      this.request<GetAllLogsData, any>({
        path: `/activity-logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Logs
     * @name GetLogsByEmployee
     * @request GET:/activity-logs/employee/{employeeId}
     * @secure
     * @response `200` `GetLogsByEmployeeData` Successfully retrieved activity logs for employee.
     */
    getLogsByEmployee: (employeeId: string, params: RequestParams = {}) =>
      this.request<GetLogsByEmployeeData, any>({
        path: `/activity-logs/employee/${employeeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Logs
     * @name GetPreventionDetailLogs
     * @request GET:/activity-logs/prevention-detail
     * @secure
     * @response `200` `GetPreventionDetailLogsData` Successfully retrieved prevention detail logs for a specific prevention assignment and employee.
     */
    getPreventionDetailLogs: (
      query: GetPreventionDetailLogsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPreventionDetailLogsData, any>({
        path: `/activity-logs/prevention-detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Logs
     * @name GetMentalHealthRiskAssessmentLogs
     * @request GET:/activity-logs/mh-risk-assessment
     * @secure
     * @response `200` `GetMentalHealthRiskAssessmentLogsData` Successfully retrieved mental health risk assessment logs.
     */
    getMentalHealthRiskAssessmentLogs: (
      query: GetMentalHealthRiskAssessmentLogsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetMentalHealthRiskAssessmentLogsData, any>({
        path: `/activity-logs/mh-risk-assessment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Logs
     * @name CreateAdminManualActivityLog
     * @request POST:/activity-logs/manual
     * @secure
     * @response `200` `CreateAdminManualActivityLogData` Successfully created activity log.
     * @response `201` `void`
     */
    createAdminManualActivityLog: (
      data: CreateManualActivityLogAdminDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateAdminManualActivityLogData, any>({
        path: `/activity-logs/manual`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  maternityRiskAssessments = {
    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name ListNotifications
     * @summary List all maternity notifications for an organization
     * @request GET:/maternity-risk-assessments/{orgId}/notifications
     * @secure
     * @response `200` `ListNotificationsData`
     */
    listNotifications: (
      { orgId, ...query }: ListNotificationsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListNotificationsData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name CreateNotification
     * @summary Create a new maternity notification
     * @request POST:/maternity-risk-assessments/{orgId}/notifications
     * @secure
     * @response `201` `CreateNotificationData`
     */
    createNotification: (
      orgId: string,
      data: CreateMaternityNotificationDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateNotificationData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name GetNotification
     * @summary Get a specific maternity notification
     * @request GET:/maternity-risk-assessments/{orgId}/notifications/{id}
     * @secure
     * @response `200` `GetNotificationData`
     */
    getNotification: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<GetNotificationData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name UpdateNotification
     * @summary Update a maternity notification
     * @request PUT:/maternity-risk-assessments/{orgId}/notifications/{id}
     * @secure
     * @response `200` `UpdateNotificationData`
     */
    updateNotification: (
      orgId: string,
      id: string,
      data: UpdateMaternityNotificationDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateNotificationData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name DeleteNotification
     * @summary Delete a maternity notification
     * @request DELETE:/maternity-risk-assessments/{orgId}/notifications/{id}
     * @secure
     * @response `200` `DeleteNotificationData`
     * @response `204` `void`
     */
    deleteNotification: (
      orgId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteNotificationData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name GetNotificationsByEmployee
     * @summary Get all maternity notifications for a specific employee
     * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}
     * @secure
     * @response `200` `GetNotificationsByEmployeeData`
     */
    getNotificationsByEmployee: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetNotificationsByEmployeeData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/employees/${employeeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name GetLatestNotificationByEmployee
     * @summary Get the latest maternity notification for a specific employee
     * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}/latest
     * @secure
     * @response `200` `GetLatestNotificationByEmployeeData`
     */
    getLatestNotificationByEmployee: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetLatestNotificationByEmployeeData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/employees/${employeeId}/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name GetEmployeeMaternityStatus
     * @summary Get maternity status for a specific employee
     * @request GET:/maternity-risk-assessments/{orgId}/notifications/employees/{employeeId}/maternity-status
     * @secure
     * @response `200` `GetEmployeeMaternityStatusData` Returns maternity status including active notification and assessment status
     */
    getEmployeeMaternityStatus: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetEmployeeMaternityStatusData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/employees/${employeeId}/maternity-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Notifications
     * @name GetNotificationCounts
     * @summary Get notification statistics for the organization
     * @request GET:/maternity-risk-assessments/{orgId}/notifications/statistics/counts
     * @secure
     * @response `200` `GetNotificationCountsData` Returns notification counts including total, active, and completed
     */
    getNotificationCounts: (orgId: string, params: RequestParams = {}) =>
      this.request<GetNotificationCountsData, any>({
        path: `/maternity-risk-assessments/${orgId}/notifications/statistics/counts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name CreateAssessment
     * @summary Create a new maternity risk assessment
     * @request POST:/maternity-risk-assessments/{orgId}/assessments
     * @secure
     * @response `201` `CreateAssessmentData`
     */
    createAssessment: (
      orgId: string,
      data: CreateMaternityRiskAssessmentDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateAssessmentData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name ListAssessments
     * @summary List all maternity risk assessments for an organization
     * @request GET:/maternity-risk-assessments/{orgId}/assessments
     * @secure
     * @response `200` `ListAssessmentsData`
     */
    listAssessments: (
      { orgId, ...query }: ListAssessmentsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAssessmentsData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name GetAssessmentStatistics
     * @summary Get assessment statistics for the organization
     * @request GET:/maternity-risk-assessments/{orgId}/assessments/statistics
     * @secure
     * @response `200` `GetAssessmentStatisticsData` Returns assessment statistics including counts and completion rates
     */
    getAssessmentStatistics: (orgId: string, params: RequestParams = {}) =>
      this.request<GetAssessmentStatisticsData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name GetAssessmentTimeline
     * @summary Get assessments completed within a date range
     * @request GET:/maternity-risk-assessments/{orgId}/assessments/timeline
     * @secure
     * @response `200` `GetAssessmentTimelineData`
     */
    getAssessmentTimeline: (
      { orgId, ...query }: GetAssessmentTimelineParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssessmentTimelineData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/timeline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name GetAssessment
     * @summary Get a specific maternity risk assessment
     * @request GET:/maternity-risk-assessments/{orgId}/assessments/{id}
     * @secure
     * @response `200` `GetAssessmentData`
     */
    getAssessment: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<GetAssessmentData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name UpdateAssessment
     * @summary Update a maternity risk assessment
     * @request PUT:/maternity-risk-assessments/{orgId}/assessments/{id}
     * @secure
     * @response `200` `UpdateAssessmentData`
     */
    updateAssessment: (
      orgId: string,
      id: string,
      data: UpdateMaternityRiskAssessmentDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAssessmentData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name DeleteAssessment
     * @summary Delete a maternity risk assessment
     * @request DELETE:/maternity-risk-assessments/{orgId}/assessments/{id}
     * @secure
     * @response `200` `DeleteAssessmentData`
     * @response `204` `void`
     */
    deleteAssessment: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<DeleteAssessmentData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name GetAssessmentWithDetails
     * @summary Get a maternity risk assessment with full details
     * @request GET:/maternity-risk-assessments/{orgId}/assessments/{id}/details
     * @secure
     * @response `200` `GetAssessmentWithDetailsData`
     */
    getAssessmentWithDetails: (
      orgId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<GetAssessmentWithDetailsData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/${id}/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name UpdateAssessmentStatus
     * @summary Update assessment status
     * @request PUT:/maternity-risk-assessments/{orgId}/assessments/{id}/status
     * @secure
     * @response `200` `UpdateAssessmentStatusData`
     */
    updateAssessmentStatus: (
      orgId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAssessmentStatusData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/${id}/status`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Assessments
     * @name GetAssessmentsByEmployee
     * @summary Get all assessments for a specific employee
     * @request GET:/maternity-risk-assessments/{orgId}/assessments/employees/{employeeId}
     * @secure
     * @response `200` `GetAssessmentsByEmployeeData`
     */
    getAssessmentsByEmployee: (
      orgId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetAssessmentsByEmployeeData, any>({
        path: `/maternity-risk-assessments/${orgId}/assessments/employees/${employeeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Questionnaire
     * @name GetQuestionnaire
     * @summary Get the maternity questionnaire template
     * @request GET:/maternity-risk-assessments/{orgId}/questionnaire
     * @secure
     * @response `200` `GetQuestionnaireData`
     */
    getQuestionnaire: (orgId: string, params: RequestParams = {}) =>
      this.request<GetQuestionnaireData, any>({
        path: `/maternity-risk-assessments/${orgId}/questionnaire`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Questionnaire
     * @name SubmitQuestionnaire
     * @summary Submit questionnaire responses for an assessment
     * @request POST:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
     * @secure
     * @response `201` `SubmitQuestionnaireData`
     */
    submitQuestionnaire: (
      orgId: string,
      assessmentId: string,
      data: SubmitQuestionnaireResponseDto,
      params: RequestParams = {},
    ) =>
      this.request<SubmitQuestionnaireData, any>({
        path: `/maternity-risk-assessments/${orgId}/questionnaire/assessments/${assessmentId}/responses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Questionnaire
     * @name UpdateQuestionnaire
     * @summary Update questionnaire responses for an assessment
     * @request PUT:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
     * @secure
     * @response `200` `UpdateQuestionnaireData`
     */
    updateQuestionnaire: (
      orgId: string,
      assessmentId: string,
      data: UpdateQuestionnaireResponseDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateQuestionnaireData, any>({
        path: `/maternity-risk-assessments/${orgId}/questionnaire/assessments/${assessmentId}/responses`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maternity Risk Assessment - Questionnaire
     * @name GetQuestionnaireResponse
     * @summary Get questionnaire responses for an assessment
     * @request GET:/maternity-risk-assessments/{orgId}/questionnaire/assessments/{assessmentId}/responses
     * @secure
     * @response `200` `GetQuestionnaireResponseData`
     */
    getQuestionnaireResponse: (
      orgId: string,
      assessmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetQuestionnaireResponseData, any>({
        path: `/maternity-risk-assessments/${orgId}/questionnaire/assessments/${assessmentId}/responses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  instructions = {
    /**
     * No description
     *
     * @tags OHS Hub - Instructions (Public)
     * @name ValidateToken
     * @summary Validate an instruction access token for a given assignment
     * @request GET:/instructions/access/{assignmentId}
     * @response `200` `ValidateTokenData`
     * @response `401` `void` Missing or invalid Authorization header
     * @response `404` `void` Assignment not found or token invalid
     */
    validateToken: (assignmentId: string, params: RequestParams = {}) =>
      this.request<ValidateTokenData, void>({
        path: `/instructions/access/${assignmentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Instructions (Public)
     * @name SubmitQuiz
     * @summary Submit answers for an instruction quiz
     * @request POST:/instructions/access/{assignmentId}/quiz/submit
     * @response `200` `SubmitQuizData`
     * @response `401` `void` Missing or invalid Authorization header
     * @response `404` `void` Assignment not found or token invalid
     */
    submitQuiz: (
      assignmentId: string,
      data: QuizSubmitDto,
      params: RequestParams = {},
    ) =>
      this.request<SubmitQuizData, void>({
        path: `/instructions/access/${assignmentId}/quiz/submit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  instructionTopics = {
    /**
     * No description
     *
     * @tags OHS Hub - Instructions
     * @name FindAll
     * @summary List all instruction topics for an organization
     * @request GET:/instruction-topics/{orgId}
     * @secure
     * @response `200` `FindAllResult`
     */
    findAll: (orgId: string, params: RequestParams = {}) =>
      this.request<FindAllResult, any>({
        path: `/instruction-topics/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Instructions
     * @name FindOne
     * @summary Get an instruction topic by ID
     * @request GET:/instruction-topics/{orgId}/{id}
     * @secure
     * @response `200` `FindOneResult`
     */
    findOne: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<FindOneResult, any>({
        path: `/instruction-topics/${orgId}/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  instructionAssignments = {
    /**
     * No description
     *
     * @tags OHS Hub - Instructions
     * @name FindAll
     * @summary List instruction assignments for an organization
     * @request GET:/instruction-assignments/{orgId}
     * @secure
     * @response `200` `FindAllOutput`
     */
    findAll: (
      { orgId, ...query }: FindAllParams2,
      params: RequestParams = {},
    ) =>
      this.request<FindAllOutput, any>({
        path: `/instruction-assignments/${orgId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Instructions
     * @name FindOne
     * @summary Get an instruction assignment by ID
     * @request GET:/instruction-assignments/{orgId}/{id}
     * @secure
     * @response `200` `FindOneOutput`
     */
    findOne: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<FindOneOutput, any>({
        path: `/instruction-assignments/${orgId}/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OHS Hub - Instructions
     * @name UpdateDueDate
     * @summary Update the due date of an instruction assignment
     * @request PATCH:/instruction-assignments/{orgId}/{id}/due-date
     * @secure
     * @response `200` `UpdateDueDateData`
     */
    updateDueDate: (
      orgId: string,
      id: string,
      data: UpdateInstructionAssignmentDueDateDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDueDateData, any>({
        path: `/instruction-assignments/${orgId}/${id}/due-date`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  preventionCompletions = {
    /**
     * No description
     *
     * @tags Prevention Completions
     * @name GetCompletionsByAssignment
     * @summary Get all completions for an assignment
     * @request GET:/prevention-completions/orgs/{orgId}/assignment/{assignmentId}
     * @secure
     * @response `200` `GetCompletionsByAssignmentData` Prevention completions retrieved successfully
     */
    getCompletionsByAssignment: (
      orgId: string,
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCompletionsByAssignmentData, any>({
        path: `/prevention-completions/orgs/${orgId}/assignment/${assignmentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name GetLatestCompletion
     * @summary Get the latest completion for an assignment
     * @request GET:/prevention-completions/orgs/{orgId}/assignment/{assignmentId}/latest
     * @secure
     * @response `200` `GetLatestCompletionData` Latest prevention completion retrieved successfully (or null if none found)
     */
    getLatestCompletion: (
      orgId: string,
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetLatestCompletionData, any>({
        path: `/prevention-completions/orgs/${orgId}/assignment/${assignmentId}/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name CreateCompletion
     * @summary Create a new prevention completion
     * @request POST:/prevention-completions/orgs/{orgId}
     * @secure
     * @response `201` `CreateCompletionData` Prevention completion created successfully
     * @response `400` `void` Invalid input data
     * @response `404` `void` Prevention assignment not found
     */
    createCompletion: (
      orgId: string,
      data: CreatePreventionCompletionDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateCompletionData, void>({
        path: `/prevention-completions/orgs/${orgId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name GetReceiptSummary
     * @summary Get receipt document summary for a completion
     * @request GET:/prevention-completions/orgs/{orgId}/{completionId}/receipt/summary
     * @secure
     * @response `200` `GetReceiptSummaryData` Receipt document summary retrieved successfully
     * @response `404` `void` Prevention completion not found
     */
    getReceiptSummary: (
      orgId: string,
      completionId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetReceiptSummaryData, void>({
        path: `/prevention-completions/orgs/${orgId}/${completionId}/receipt/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name GetReceipt
     * @summary Get receipt document for a completion
     * @request GET:/prevention-completions/orgs/{orgId}/{completionId}/receipt
     * @secure
     * @response `200` `GetReceiptData` Receipt document download URL retrieved successfully (or null if no receipt found)
     * @response `404` `void` Prevention completion not found
     */
    getReceipt: (
      orgId: string,
      completionId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetReceiptData, void>({
        path: `/prevention-completions/orgs/${orgId}/${completionId}/receipt`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name DeleteReceipt
     * @summary Delete receipt document for a completion
     * @request DELETE:/prevention-completions/orgs/{orgId}/{completionId}/receipt
     * @secure
     * @response `204` `DeleteReceiptData` Receipt document deleted successfully
     * @response `404` `void` Prevention completion or receipt document not found
     */
    deleteReceipt: (
      orgId: string,
      completionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteReceiptData, void>({
        path: `/prevention-completions/orgs/${orgId}/${completionId}/receipt`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name UpdateCompletion
     * @summary Update an existing prevention completion
     * @request PUT:/prevention-completions/orgs/{orgId}/{completionId}
     * @secure
     * @response `200` `UpdateCompletionData` Prevention completion updated successfully
     * @response `400` `void` Invalid input data
     * @response `404` `void` Prevention completion not found
     */
    updateCompletion: (
      orgId: string,
      completionId: string,
      data: UpdatePreventionCompletionDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCompletionData, void>({
        path: `/prevention-completions/orgs/${orgId}/${completionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prevention Completions
     * @name DeleteCompletion
     * @summary Delete a prevention completion
     * @request DELETE:/prevention-completions/orgs/{orgId}/{completionId}
     * @secure
     * @response `204` `DeleteCompletionData` Prevention completion deleted successfully
     * @response `404` `void` Prevention completion not found
     */
    deleteCompletion: (
      orgId: string,
      completionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteCompletionData, void>({
        path: `/prevention-completions/orgs/${orgId}/${completionId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  preventionAssignment = {
    /**
     * No description
     *
     * @tags PreventionAssignment
     * @name UpdateDeadline
     * @request POST:/prevention-assignment/orgs/{orgId}/update/deadline
     * @secure
     * @response `201` `UpdateDeadlineData`
     */
    updateDeadline: (
      orgId: string,
      data: UpdatePreventionAssignmentDeadlineDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateDeadlineData, any>({
        path: `/prevention-assignment/orgs/${orgId}/update/deadline`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  preventionProfiles = {
    /**
     * No description
     *
     * @tags PreventionProfile
     * @name CreatePreventionProfile
     * @request POST:/prevention-profiles/orgs/{orgId}/profiles/create
     * @secure
     * @response `201` `CreatePreventionProfileData`
     */
    createPreventionProfile: (
      orgId: string,
      data: CreatePreventionProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<CreatePreventionProfileData, any>({
        path: `/prevention-profiles/orgs/${orgId}/profiles/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags Document Management
     * @name RequestUpload
     * @request POST:/documents/orgs/{orgId}/request-upload
     * @secure
     * @response `201` `RequestUploadData`
     */
    requestUpload: (
      orgId: string,
      data: RequestUploadDto,
      params: RequestParams = {},
    ) =>
      this.request<RequestUploadData, any>({
        path: `/documents/orgs/${orgId}/request-upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Management
     * @name CompleteUpload
     * @request POST:/documents/orgs/{orgId}/documents/{id}/complete
     * @secure
     * @response `200` `CompleteUploadData`
     */
    completeUpload: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<CompleteUploadData, any>({
        path: `/documents/orgs/${orgId}/documents/${id}/complete`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Document Management
 * @name GetDownloadUrl
 * @summary SECURE: Generate signed download URL (Recommended for production/medical data)
Returns a time-limited signed URL that expires in 2 minutes
Enhanced with comprehensive security logging and validation
 * @request GET:/documents/orgs/{orgId}/documents/{id}/download-url
 * @secure
 * @response `200` `GetDownloadUrlData`
 */
    getDownloadUrl: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<GetDownloadUrlData, any>({
        path: `/documents/orgs/${orgId}/documents/${id}/download-url`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Management
     * @name GetDocument
     * @request GET:/documents/orgs/{orgId}/documents/{id}
     * @secure
     * @response `200` `GetDocumentData`
     */
    getDocument: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<GetDocumentData, any>({
        path: `/documents/orgs/${orgId}/documents/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Management
     * @name DeleteDocument
     * @request DELETE:/documents/orgs/{orgId}/documents/{id}
     * @secure
     * @response `204` `DeleteDocumentData`
     */
    deleteDocument: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<DeleteDocumentData, any>({
        path: `/documents/orgs/${orgId}/documents/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Management
     * @name GetDocuments
     * @request GET:/documents/orgs/{orgId}/documents
     * @secure
     * @response `200` `GetDocumentsData`
     */
    getDocuments: (
      { orgId, ...query }: GetDocumentsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetDocumentsData, any>({
        path: `/documents/orgs/${orgId}/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  stressTest = {
    /**
     * No description
     *
     * @tags TestResult
     * @name Create
     * @request POST:/stress-test
     * @response `201` `CreateOutput`
     */
    create: (data: CreateTestResultDto, params: RequestParams = {}) =>
      this.request<CreateOutput, any>({
        path: `/stress-test`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TestResult
     * @name GetStressLevels
     * @request GET:/stress-test/{user_id}
     * @response `200` `GetStressLevelsData`
     */
    getStressLevels: (userId: string, params: RequestParams = {}) =>
      this.request<GetStressLevelsData, any>({
        path: `/stress-test/${userId}`,
        method: "GET",
        ...params,
      }),
  };
  statistics = {
    /**
     * No description
     *
     * @tags Statistics
     * @name GetPreventionStatistics
     * @request GET:/statistics/{orgId}/prevention
     * @secure
     * @response `200` `GetPreventionStatisticsData`
     */
    getPreventionStatistics: (orgId: string, params: RequestParams = {}) =>
      this.request<GetPreventionStatisticsData, any>({
        path: `/statistics/${orgId}/prevention`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Statistics
     * @name GetGiniscoreStatistics
     * @request GET:/statistics/{orgId}/giniscore
     * @secure
     * @response `200` `GetGiniscoreStatisticsData`
     */
    getGiniscoreStatistics: (orgId: string, params: RequestParams = {}) =>
      this.request<GetGiniscoreStatisticsData, any>({
        path: `/statistics/${orgId}/giniscore`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Statistics
     * @name GetInstructionStatistics
     * @request GET:/statistics/{orgId}/instructions
     * @secure
     * @response `200` `GetInstructionStatisticsData`
     */
    getInstructionStatistics: (orgId: string, params: RequestParams = {}) =>
      this.request<GetInstructionStatisticsData, any>({
        path: `/statistics/${orgId}/instructions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @tags Admin Users
     * @name ChurnUsersByEmail
     * @request PATCH:/admin/users/churn/email
     * @secure
     * @response `200` `ChurnUsersByEmailData`
     */
    churnUsersByEmail: (
      data: ChurnUserByEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<ChurnUsersByEmailData, any>({
        path: `/admin/users/churn/email`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users
     * @name CreateUser
     * @request POST:/admin/users
     * @secure
     * @response `201` `CreateUserResult`
     */
    createUser: (data: CreateUserAdminDto, params: RequestParams = {}) =>
      this.request<CreateUserResult, any>({
        path: `/admin/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Users
     * @name GenerateUsers
     * @request POST:/admin/users/create
     * @secure
     * @response `201` `GenerateUsersData`
     */
    generateUsers: (data: CreateTestUsersDto, params: RequestParams = {}) =>
      this.request<GenerateUsersData, any>({
        path: `/admin/users/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Clears the cached data for a specific user. This is useful when user data has been manually updated in the database.
     *
     * @tags Admin Users
     * @name InvalidateUserCache
     * @summary Invalidate cache for a specific user
     * @request DELETE:/admin/users/cache/{userId}
     * @secure
     * @response `200` `InvalidateUserCacheData` User cache invalidated successfully
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin role
     */
    invalidateUserCache: (userId: string, params: RequestParams = {}) =>
      this.request<InvalidateUserCacheData, void>({
        path: `/admin/users/cache/${userId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Clears the cache for all users. This is useful when multiple user records have been updated in the database.
     *
     * @tags Admin Users
     * @name ClearUserCache
     * @summary Clear the entire user cache
     * @request DELETE:/admin/users/cache
     * @secure
     * @response `200` `ClearUserCacheData` User cache cleared successfully
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin role
     */
    clearUserCache: (params: RequestParams = {}) =>
      this.request<ClearUserCacheData, void>({
        path: `/admin/users/cache`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all users associated with a specific organization, including their roles and accessible Legal Entities and Work Locations. Used for admin user management.
     *
     * @tags Admin Users
     * @name GetUsersByOrganization
     * @summary Get all users for an organization
     * @request GET:/admin/users/organizations/{orgId}/admin/users
     * @secure
     * @response `200` `GetUsersByOrganizationData` Users retrieved successfully
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin or ops role
     */
    getUsersByOrganization: (orgId: string, params: RequestParams = {}) =>
      this.request<GetUsersByOrganizationData, void>({
        path: `/admin/users/organizations/${orgId}/admin/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Assigns Legal Entities and Work Locations to a user for OHS Hub access control. This is primarily used for restricted users to control which employees they can view. The user cache is automatically invalidated after the update.
     *
     * @tags Admin Users
     * @name UpdateUserAccess
     * @summary Update user access to Legal Entities and Work Locations
     * @request PATCH:/admin/users/{userId}/admin/access
     * @secure
     * @response `200` `UpdateUserAccessData` User access updated successfully
     * @response `400` `void` Invalid request - bad UUIDs or entities not found
     * @response `401` `void` Unauthorized - User not authenticated
     * @response `403` `void` Forbidden - User does not have admin role
     * @response `404` `void` User not found
     */
    updateUserAccess: (
      userId: string,
      data: UpdateUserAccessDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserAccessData, void>({
        path: `/admin/users/${userId}/admin/access`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name GetOrgBudgets
     * @summary List every organization with its current budget (admin/ops only)
     * @request GET:/admin/orgs/budgets
     * @secure
     * @response `200` `GetOrgBudgetsData` Successfully retrieved organization budgets.
     */
    getOrgBudgets: (params: RequestParams = {}) =>
      this.request<GetOrgBudgetsData, any>({
        path: `/admin/orgs/budgets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name GetAllOrgs
     * @summary List every organization regardless of feature access (admin only)
     * @request GET:/admin/orgs/all
     * @secure
     * @response `200` `GetAllOrgsData` Successfully retrieved all organizations.
     */
    getAllOrgs: (params: RequestParams = {}) =>
      this.request<GetAllOrgsData, any>({
        path: `/admin/orgs/all`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name UpdateBudget
     * @request PATCH:/admin/orgs/update_budget
     * @secure
     * @response `200` `UpdateBudgetData`
     */
    updateBudget: (data: UpdateOrgBudgetDto, params: RequestParams = {}) =>
      this.request<UpdateBudgetData, any>({
        path: `/admin/orgs/update_budget`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name ChurnOrg
     * @request PATCH:/admin/orgs/churn
     * @secure
     * @response `200` `ChurnOrgData`
     */
    churnOrg: (data: ChurnOrgDto, params: RequestParams = {}) =>
      this.request<ChurnOrgData, any>({
        path: `/admin/orgs/churn`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name UpdateExclusions
     * @request PATCH:/admin/orgs/update_exclusions
     * @secure
     * @response `200` `UpdateExclusionsResult`
     */
    updateExclusions: (
      data: UpdateOrgExclusionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateExclusionsResult, any>({
        path: `/admin/orgs/update_exclusions`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name UpdateInstructionsAccess
     * @summary Update organization feature access flags
     * @request PATCH:/admin/orgs/instruction-update-access
     * @secure
     * @response `200` `UpdateInstructionsAccessData` Access flags updated successfully
     */
    updateInstructionsAccess: (
      data: UpdateOrgAccessDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateInstructionsAccessData, any>({
        path: `/admin/orgs/instruction-update-access`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name UpdateEapAccess
     * @summary Update organization EAP access flag
     * @request PATCH:/admin/orgs/eap-update-access
     * @secure
     * @response `200` `UpdateEapAccessData` EAP access flag updated successfully
     */
    updateEapAccess: (
      data: UpdateOrgEapAccessDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEapAccessData, any>({
        path: `/admin/orgs/eap-update-access`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orgs
     * @name UpdateOhsHubAccess
     * @summary Update organization OHS Hub access flag
     * @request PATCH:/admin/orgs/ohs-hub-update-access
     * @secure
     * @response `200` `UpdateOhsHubAccessData` OHS Hub access flag updated successfully
     */
    updateOhsHubAccess: (
      data: UpdateOrgOhsHubAccessDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOhsHubAccessData, any>({
        path: `/admin/orgs/ohs-hub-update-access`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves the existing Kombo integration magic link for an organization if one exists.
     *
     * @tags Orgs
     * @name GetKomboIntegration
     * @summary Get existing Kombo integration link for an organization
     * @request GET:/admin/orgs/{orgId}/kombo-integration
     * @secure
     * @response `200` `GetKomboIntegrationData` Kombo integration link retrieved successfully
     * @response `404` `void` Organization not found or no integration link exists
     */
    getKomboIntegration: (orgId: string, params: RequestParams = {}) =>
      this.request<GetKomboIntegrationData, void>({
        path: `/admin/orgs/${orgId}/kombo-integration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a connection link for Kombo HRIS integration. The link is stored in the database along with its expiry date.
     *
     * @tags Orgs
     * @name CreateKomboIntegration
     * @summary Create Kombo integration link for an organization
     * @request POST:/admin/orgs/kombo-integration
     * @secure
     * @response `201` `CreateKomboIntegrationData` Kombo integration link created successfully
     * @response `404` `void` Organization not found
     * @response `500` `void` Internal server error
     */
    createKomboIntegration: (
      data: CreateKomboIntegrationDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateKomboIntegrationData, void>({
        path: `/admin/orgs/kombo-integration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all available prevention triggers for dropdown selection
     *
     * @tags Admin - Prevention
     * @name GetPreventionTriggers
     * @summary Get all prevention triggers
     * @request GET:/admin/prevention/triggers
     * @secure
     * @response `200` `GetPreventionTriggersData` Prevention triggers retrieved successfully
     */
    getPreventionTriggers: (params: RequestParams = {}) =>
      this.request<GetPreventionTriggersData, any>({
        path: `/admin/prevention/triggers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all prevention profiles for dropdown selection
     *
     * @tags Admin - Prevention
     * @name GetPreventionProfiles
     * @summary Get prevention profiles for organization
     * @request GET:/admin/prevention/orgs/{orgId}/profiles
     * @secure
     * @response `200` `GetPreventionProfilesData` Prevention profiles retrieved successfully
     */
    getPreventionProfiles: (orgId: string, params: RequestParams = {}) =>
      this.request<GetPreventionProfilesData, any>({
        path: `/admin/prevention/orgs/${orgId}/profiles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all prevention rules (profiles) for a specific organization
     *
     * @tags Admin - Prevention
     * @name GetPreventionRules
     * @summary Get prevention rules for organization
     * @request GET:/admin/prevention/rules/{orgId}
     * @secure
     * @response `200` `GetPreventionRulesData` Prevention rules retrieved successfully
     */
    getPreventionRules: (orgId: string, params: RequestParams = {}) =>
      this.request<GetPreventionRulesData, any>({
        path: `/admin/prevention/rules/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new prevention rule for an organization
     *
     * @tags Admin - Prevention
     * @name CreatePreventionRule
     * @summary Create prevention rule
     * @request POST:/admin/prevention/rules
     * @secure
     * @response `201` `CreatePreventionRuleData` Prevention rule created successfully
     * @response `400` `void` Invalid input data
     */
    createPreventionRule: (
      data: CreatePreventionRuleDto,
      params: RequestParams = {},
    ) =>
      this.request<CreatePreventionRuleData, void>({
        path: `/admin/prevention/rules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing prevention rule
     *
     * @tags Admin - Prevention
     * @name UpdatePreventionRule
     * @summary Update prevention rule
     * @request PUT:/admin/prevention/orgs/{orgId}/rules/{id}
     * @secure
     * @response `200` `UpdatePreventionRuleData` Prevention rule updated successfully
     * @response `400` `void` Invalid input data
     * @response `404` `void` Prevention rule not found
     */
    updatePreventionRule: (
      orgId: string,
      id: string,
      data: UpdatePreventionRuleDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePreventionRuleData, void>({
        path: `/admin/prevention/orgs/${orgId}/rules/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deactivates a prevention rule (soft delete)
     *
     * @tags Admin - Prevention
     * @name DeletePreventionRule
     * @summary Delete prevention rule
     * @request DELETE:/admin/prevention/orgs/{orgId}/rules/{id}
     * @secure
     * @response `200` `DeletePreventionRuleData` Prevention rule deleted successfully
     * @response `404` `void` Prevention rule not found
     */
    deletePreventionRule: (
      orgId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DeletePreventionRuleData, void>({
        path: `/admin/prevention/orgs/${orgId}/rules/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves employees with their current prevention assignments including cycles, notices, and completions
     *
     * @tags Admin - Prevention
     * @name GetEmployeesWithPreventionStatus
     * @summary Get employees with prevention status
     * @request GET:/admin/prevention/employees/{orgId}
     * @secure
     * @response `200` `GetEmployeesWithPreventionStatusData` Employees with prevention status retrieved successfully
     * @response `404` `void` Organization not found
     */
    getEmployeesWithPreventionStatus: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetEmployeesWithPreventionStatusData, void>({
        path: `/admin/prevention/employees/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new prevention trigger, profile with employee-targeting rules, and assigns to specified employees. This endpoint follows production logic for testing purposes in staging environment.
     *
     * @tags Admin - Prevention
     * @name CreatePreventionWithProfile
     * @summary Create prevention trigger, profile and assignments
     * @request POST:/admin/prevention/create-with-profile
     * @secure
     * @response `201` `CreatePreventionWithProfileData` Prevention trigger, profile and assignments created successfully
     * @response `400` `void` Invalid input data or validation failed
     * @response `404` `void` Organization or employees not found
     */
    createPreventionWithProfile: (
      data: CreatePreventionWithProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<CreatePreventionWithProfileData, void>({
        path: `/admin/prevention/create-with-profile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Allows admins to override prevention assignment deadlines without validation for testing purposes. This endpoint bypasses all restrictions including past date checks and email notice order validation.
     *
     * @tags Admin - Prevention
     * @name AdminDeadlineOverride
     * @summary Admin-only deadline override
     * @request POST:/admin/prevention/orgs/{orgId}/update/deadline-admin
     * @secure
     * @response `200` `AdminDeadlineOverrideData` Deadline updated successfully (admin override)
     * @response `201` `PreventionAssignment`
     * @response `404` `void` Prevention assignment not found
     */
    adminDeadlineOverride: (
      orgId: string,
      data: AdminDeadlineOverrideDto,
      params: RequestParams = {},
    ) =>
      this.request<AdminDeadlineOverrideData, void>({
        path: `/admin/prevention/orgs/${orgId}/update/deadline-admin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves active instruction topics for admin dropdown selection
     *
     * @tags Admin - Instructions
     * @name GetInstructionTopics
     * @summary Get instruction topics for organization
     * @request GET:/admin/instructions/orgs/{orgId}/topics
     * @secure
     * @response `200` `GetInstructionTopicsData` Instruction topics retrieved successfully
     */
    getInstructionTopics: (orgId: string, params: RequestParams = {}) =>
      this.request<GetInstructionTopicsData, any>({
        path: `/admin/instructions/orgs/${orgId}/topics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates missing instruction topics for all currently available instruction content keys in this organization.
     *
     * @tags Admin - Instructions
     * @name BootstrapInstructionTopics
     * @summary Bootstrap instruction topics from available content keys
     * @request POST:/admin/instructions/orgs/{orgId}/topics/bootstrap
     * @secure
     * @response `201` `BootstrapInstructionTopicsData` Missing instruction topics were created successfully
     * @response `404` `void` Organization not found
     */
    bootstrapInstructionTopics: (orgId: string, params: RequestParams = {}) =>
      this.request<BootstrapInstructionTopicsData, void>({
        path: `/admin/instructions/orgs/${orgId}/topics/bootstrap`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a rule-based instruction profile targeting specific employees and assigns instructions using production orchestrator logic.
     *
     * @tags Admin - Instructions
     * @name CreateInstructionWithProfile
     * @summary Create instruction profile and assignments
     * @request POST:/admin/instructions/create-with-profile
     * @secure
     * @response `201` `CreateInstructionWithProfileData` Instruction profile and assignments created successfully
     * @response `400` `void` Invalid input data or validation failed
     * @response `404` `void` Organization, topic, or employees not found
     */
    createInstructionWithProfile: (
      data: CreateInstructionWithProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateInstructionWithProfileData, void>({
        path: `/admin/instructions/create-with-profile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Experts
     * @name ListExperts
     * @request GET:/admin/experts
     * @secure
     * @response `200` `ListExpertsData`
     */
    listExperts: (params: RequestParams = {}) =>
      this.request<ListExpertsData, any>({
        path: `/admin/experts`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Experts
     * @name CreateExpert
     * @request POST:/admin/experts
     * @secure
     * @response `201` `CreateExpertData`
     */
    createExpert: (data: CreateExpertDto, params: RequestParams = {}) =>
      this.request<CreateExpertData, any>({
        path: `/admin/experts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Experts
     * @name UpdateCalendlyToken
     * @request PATCH:/admin/experts/{id}/calendly-token
     * @secure
     * @response `200` `UpdateCalendlyTokenData`
     */
    updateCalendlyToken: (
      id: string,
      data: UpdateExpertCalendlyTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCalendlyTokenData, any>({
        path: `/admin/experts/${id}/calendly-token`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  metrics = {
    /**
     * No description
     *
     * @tags Prometheus
     * @name Index
     * @request GET:/metrics
     * @response `200` `IndexData`
     */
    index: (params: RequestParams = {}) =>
      this.request<IndexData, any>({
        path: `/metrics`,
        method: "GET",
        ...params,
      }),
  };
  health = {
    /**
 * No description
 *
 * @tags Health
 * @name Check
 * @request GET:/health
 * @response `200` `CheckData` The Health Check is successful
 * @response `503` `{
  \** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} *\
    details?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"redis":{"status":"down","message":"Could not connect"}} *\
    error?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"database":{"status":"up"}} *\
    info?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example "error" *\
    status?: string,

}` The Health Check is not successful
 */
    check: (params: RequestParams = {}) =>
      this.request<CheckData, CheckError>({
        path: `/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  firstAidLogs = {
    /**
     * @description Creates a new first aid log with the provided data. Requires the affected employee ID, first aider IDs, and witness IDs to be valid UUIDs of existing employees. All employees referenced must exist in the system.
     *
     * @tags First Aid Logs
     * @name Create
     * @summary Create a new first aid log
     * @request POST:/first-aid-logs/{orgId}
     * @secure
     * @response `201` `CreateOutput1` The first aid log has been successfully created.
     * @response `400` `void` Invalid input data provided.
     * @response `404` `void` One or more referenced employees not found.
     */
    create: (
      orgId: string,
      data: CreateFirstAidLogDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateOutput1, void>({
        path: `/first-aid-logs/${orgId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags First Aid Logs
     * @name FindByOrganization
     * @summary Get all first aid logs for an organization
     * @request GET:/first-aid-logs/{orgId}
     * @secure
     * @response `200` `FindByOrganizationData` List of first aid logs for the organization
     */
    findByOrganization: (orgId: string, params: RequestParams = {}) =>
      this.request<FindByOrganizationData, any>({
        path: `/first-aid-logs/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags First Aid Logs
     * @name GetOrganizationFirstAidQrCode
     * @request GET:/first-aid-logs/{orgId}/qr-code
     * @secure
     * @response `200` `GetOrganizationFirstAidQrCodeData`
     */
    getOrganizationFirstAidQrCode: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetOrganizationFirstAidQrCodeData, any>({
        path: `/first-aid-logs/${orgId}/qr-code`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags First Aid Logs
     * @name AssignFirstAidLogEntry
     * @summary Assign first aid log to an employee
     * @request PATCH:/first-aid-logs/{orgId}/{logId}/assign
     * @secure
     * @response `200` `AssignFirstAidLogEntryData` Assigned first aid log to employee
     * @response `400` `void` First aid log already assigned
     * @response `403` `void` User is not authorized to assign log
     * @response `404` `void` First aid log not found
     */
    assignFirstAidLogEntry: (
      logId: string,
      orgId: string,
      data: AssignEmployeeFirstLogDto,
      params: RequestParams = {},
    ) =>
      this.request<AssignFirstAidLogEntryData, void>({
        path: `/first-aid-logs/${orgId}/${logId}/assign`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags First Aid Logs
     * @name FindOne
     * @summary Get a specific first aid log by ID
     * @request GET:/first-aid-logs/{orgId}/{id}
     * @secure
     * @response `200` `FindOneOutput1` First aid log details
     * @response `404` `void` First aid log not found
     */
    findOne: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<FindOneOutput1, void>({
        path: `/first-aid-logs/${orgId}/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a first aid log by ID and creates an activity log entry
     *
     * @tags First Aid Logs
     * @name Remove
     * @summary Delete a first aid log
     * @request DELETE:/first-aid-logs/{orgId}/{id}
     * @secure
     * @response `200` `RemoveData` The first aid log has been successfully deleted.
     * @response `404` `void` First aid log not found
     */
    remove: (orgId: string, id: string, params: RequestParams = {}) =>
      this.request<RemoveData, void>({
        path: `/first-aid-logs/${orgId}/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags First Aid Logs
     * @name Update
     * @summary Update a specific first aid log by ID
     * @request PATCH:/first-aid-logs/{orgId}/{id}
     * @secure
     * @response `200` `UpdateOutput` First aid log details
     * @response `404` `void` First aid log not found
     */
    update: (
      id: string,
      orgId: string,
      data: UpdateFirstAidLogDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOutput, void>({
        path: `/first-aid-logs/${orgId}/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  mentalHealthRiskAssessments = {
    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name CreateCycle
     * @summary Create a new assessment cycle
     * @request POST:/mental-health-risk-assessments/{orgId}
     * @secure
     * @response `201` `CreateCycleData`
     */
    createCycle: (
      orgId: string,
      data: CreateAssessmentCycleDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateCycleData, any>({
        path: `/mental-health-risk-assessments/${orgId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name ListCycles
     * @summary List all assessment cycles for an organization
     * @request GET:/mental-health-risk-assessments/{orgId}
     * @secure
     * @response `200` `ListCyclesData`
     */
    listCycles: (orgId: string, params: RequestParams = {}) =>
      this.request<ListCyclesData, any>({
        path: `/mental-health-risk-assessments/${orgId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name GetCycle
     * @summary Get a specific assessment cycle
     * @request GET:/mental-health-risk-assessments/{orgId}/{cycleId}
     * @secure
     * @response `200` `GetCycleData`
     */
    getCycle: (orgId: string, cycleId: string, params: RequestParams = {}) =>
      this.request<GetCycleData, any>({
        path: `/mental-health-risk-assessments/${orgId}/${cycleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name UpdateCycleNote
     * @summary Update the employee note of an assessment cycle
     * @request PUT:/mental-health-risk-assessments/{orgId}/{cycleId}/note
     * @secure
     * @response `200` `UpdateCycleNoteData`
     */
    updateCycleNote: (
      orgId: string,
      cycleId: string,
      data: UpdateAssessmentCycleNoteDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCycleNoteData, any>({
        path: `/mental-health-risk-assessments/${orgId}/${cycleId}/note`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name CloseCycle
     * @summary Close an assessment cycle
     * @request POST:/mental-health-risk-assessments/{orgId}/{cycleId}/close
     * @secure
     * @response `200` `CloseCycleData`
     * @response `201` `AssessmentCycle`
     */
    closeCycle: (orgId: string, cycleId: string, params: RequestParams = {}) =>
      this.request<CloseCycleData, any>({
        path: `/mental-health-risk-assessments/${orgId}/${cycleId}/close`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name FinalizeCycle
     * @summary Finalize an assessment cycle
     * @request POST:/mental-health-risk-assessments/{orgId}/{cycleId}/finalize
     * @secure
     * @response `200` `FinalizeCycleData`
     * @response `201` `AssessmentCycle`
     */
    finalizeCycle: (
      orgId: string,
      cycleId: string,
      params: RequestParams = {},
    ) =>
      this.request<FinalizeCycleData, any>({
        path: `/mental-health-risk-assessments/${orgId}/${cycleId}/finalize`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name GetSelectableGroups
     * @summary Get selectable groups for the organization
     * @request GET:/mental-health-risk-assessments/{orgId}/groups
     * @secure
     * @response `200` `GetSelectableGroupsData`
     */
    getSelectableGroups: (orgId: string, params: RequestParams = {}) =>
      this.request<GetSelectableGroupsData, any>({
        path: `/mental-health-risk-assessments/${orgId}/groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name GetCycleByToken
     * @summary Get assessment cycle details by anonymous link token
     * @request GET:/mental-health-risk-assessments/{orgId}/public/assessment-config/{token}
     * @secure
     * @response `200` `GetCycleByTokenData`
     */
    getCycleByToken: (
      token: string,
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCycleByTokenData, any>({
        path: `/mental-health-risk-assessments/${orgId}/public/assessment-config/${token}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mental Health Risk Assessment
     * @name GetSurvey
     * @summary Get survey for a specific assessment cycle
     * @request GET:/mental-health-risk-assessments/{orgId}/cycles/{cycleId}/survey
     * @secure
     * @response `200` `GetSurveyData` Returns the survey for the specified cycle
     */
    getSurvey: (cycleId: string, orgId: string, params: RequestParams = {}) =>
      this.request<GetSurveyData, any>({
        path: `/mental-health-risk-assessments/${orgId}/cycles/${cycleId}/survey`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  public = {
    /**
     * No description
     *
     * @tags Anonymous Mental Health Risk Assessment
     * @name GetSurvey
     * @summary Get survey for an anonymous assessment
     * @request GET:/public/mental-health-risk-assessments/survey/{token}
     * @response `200` `GetSurveyResult` Returns the survey response with either active survey or inactive status
     */
    getSurvey: (
      { token, ...query }: GetSurveyParams1,
      params: RequestParams = {},
    ) =>
      this.request<GetSurveyResult, any>({
        path: `/public/mental-health-risk-assessments/survey/${token}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Anonymous Mental Health Risk Assessment
     * @name GetGroups
     * @summary Get selectable groups for an anonymous assessment
     * @request GET:/public/mental-health-risk-assessments/groups/{token}
     * @response `200` `GetGroupsData` Returns the list of selectable groups for the specified token
     */
    getGroups: (token: string, params: RequestParams = {}) =>
      this.request<GetGroupsData, any>({
        path: `/public/mental-health-risk-assessments/groups/${token}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Anonymous Mental Health Risk Assessment
     * @name SubmitResponse
     * @summary Submit anonymous assessment responses
     * @request POST:/public/mental-health-risk-assessments/submit/{orgId}/{token}
     * @response `201` `SubmitResponseData`
     */
    submitResponse: (
      token: string,
      orgId: string,
      data: SubmitAssessmentDto,
      params: RequestParams = {},
    ) =>
      this.request<SubmitResponseData, any>({
        path: `/public/mental-health-risk-assessments/submit/${orgId}/${token}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
